export type OfficeLocale = "en" | "nl";

export const officeLocaleOptions: ReadonlyArray<{
    value: OfficeLocale;
    nativeLabel: string;
    shortLabel: string;
}> = [
    { value: "en", nativeLabel: "English", shortLabel: "EN" },
    { value: "nl", nativeLabel: "Nederlands", shortLabel: "NL" },
];

// This catalogue belongs exclusively to the office application. The customer
// portal keeps its own server-provided catalogue and never imports this file.
export const officeTranslations = {
    en: {
        "invoice.detail.pdf": "PDF",
        "invoice.detail.payment": "Payments",
    "invoice.detail.received": "Received",
    "common.showLess": "Show less",
    "email.emailRowInbox.starSubject": "Star {{subject}}",
        "invoice.detail.noPayment": "No payment registered yet",
        "invoice.detail.items": "Invoice items",
        "invoice.detail.deleteItem": "Delete {{name}}",
        "invoice.paymentMethods.bank": "Bank",

        "taxModule.investment_sale": "Investment disposal proceeds",
        "taxModule.title": "Annual accounts",
        "taxModule.report": "Annual accounts",
        "taxModule.investment": "Investments",
        "taxModule.loan": "Loans",
        "taxModule.participation": "Participations",
        "taxModule.journal": "Corrections",
        "taxModule.allocation": "Transaction links",
        "taxModule.allocationListHelp": "Links are grouped by financial classification and show the complete saved transaction, including dates after the report period.",
        "taxModule.groupCount": "{{count}} transaction links",
        "taxModule.expenseSource": "Expense",
        "taxModule.paymentSource": "Receipt",
        "taxModule.bookyear": "Financial years",
        "taxModule.ledger": "Deductibility",
        "taxModule.notes": "Notes",
        "taxModule.tenant": "Company",
        "taxModule.start": "Start date",
        "taxModule.end": "End date",
        "taxModule.asof": "Valuation date",
        "taxModule.year": "Financial year",
        "taxModule.full": "Full year",
        "taxModule.half": "First half year",
        "taxModule.free": "Custom period",
        "taxModule.download": "Download annual accounts",
        "taxModule.generating": "Generating PDF…",
        "taxModule.new": "Add",
        "taxModule.edit": "Edit",
        "taxModule.save": "Save",
        "taxModule.cancel": "Cancel",
        "taxModule.delete": "Delete",
        "taxModule.remove": "Remove row",
        "taxModule.empty": "No registrations yet.",
        "taxModule.name": "Name",
        "taxModule.choose": "Select…",
        "taxModule.loading": "Loading…",
        "taxModule.failed": "The request failed. Please try again.",
        "taxModule.saved": "Saved.",
        "taxModule.confirmDelete": "Delete this registration?",
        "taxModule.acquired": "Acquisition date",
        "taxModule.inUse": "In-use date",
        "taxModule.residual": "Residual value",
        "taxModule.months": "Term in months",
        "taxModule.method": "Method",
        "taxModule.linear": "Linear",
        "taxModule.declining": "Declining balance",
        "taxModule.annuity": "Annuity",
        "taxModule.bullet": "At maturity",
        "taxModule.rate": "Annual percentage",
        "taxModule.fiscalMonths": "Fiscal depreciation term in months (optional)",
        "taxModule.fiscalResidual": "Fiscal residual value (optional)",
        "taxModule.kia": "Eligible for KIA",
        "taxModule.expenses": "Linked expenses",
        "taxModule.search": "Search transactions",
        "taxModule.searchPlaceholder": "Name, counterparty, IBAN, date or amount",
        "taxModule.noSourcesFound": "No matching transactions",
        "taxModule.net": "Excluding entered VAT",
        "taxModule.cost": "Acquisition cost",
        "taxModule.value": "Book value / outstanding principal",
        "taxModule.depreciation": "Cumulative depreciation",
        "taxModule.disposal": "Disposal date (optional)",
        "taxModule.proceeds": "Disposal proceeds excluding VAT",
        "taxModule.investmentHelp": "Register once. Depreciation and book value continue automatically across all periods. Use linked purchase expenses or a manual initial value.",
        "taxModule.investmentBasis": "Value source",
        "taxModule.manualInitialValue": "Manual initial value (no purchase transaction)",
        "taxModule.initialValue": "Initial value excluding deductible VAT",
        "taxModule.initialAccount": "Counter account for initial value",
        "taxModule.initialValueHelp": "Enter the acquisition value on the acquisition date, for example from a contribution or opening balance. Select its equity or payable account. This creates no bank payment or VAT claim; depreciation starts on the in-use date.",
        "taxModule.direction": "Direction",
        "taxModule.received": "Received loan",
        "taxModule.issued": "Issued loan",
        "taxModule.counterparty": "Counterparty",
        "taxModule.principal": "Principal",
        "taxModule.initialPrincipal": "Initial principal",
        "taxModule.loanOpeningBalance": "Opening balance taken over without a bank payment",
        "taxModule.loanOpeningBalanceHelp": "Use this for a loan from an earlier administration, such as incorporation of a sole proprietorship. The initial principal is booked against contributed opening equity. Later drawdowns and repayments follow their actual payments.",
        "taxModule.balloon": "Balloon payment (optional)",
        "taxModule.installment": "Contractual monthly payment including interest (optional)",
        "taxModule.firstPaymentDate": "First installment date (optional)",
        "taxModule.balloonDate": "Balloon due date (optional)",
        "taxModule.loanContractHelp": "A balloon remains outstanding during the regular installments. Leave contract fields empty to calculate payments automatically. The first installment defaults to one month after the start; the balloon defaults to the last installment date. The last regular installment settles rounding and any remaining principal above the balloon.",
        "taxModule.scheduleSaveHelp": "Save your changes to update the repayment schedule.",
        "taxModule.paymentAmount": "Payment amount",
        "taxModule.balloonPart": "Including balloon",
        "taxModule.remainingPrincipal": "Remaining principal",
        "taxModule.interest": "Interest",
        "taxModule.currentAccount": "Current account",
        "taxModule.movements": "Additional movements",
        "taxModule.movementExpense": "Linked expense (optional)",
        "taxModule.movementPayment": "Linked incoming payment (optional)",
        "taxModule.movementLinkHelp": "Link the matching transaction to count the payment once. Date and total come from the transaction; enter any paid interest separately. Similar dates and amounts appear first.",
        "taxModule.loanMovementOwner": "Linked to a movement in {{name}}. Change this link in the loan.",
        "taxModule.drawdown": "Drawdown / issue",
        "taxModule.repayment": "Repayment",
        "taxModule.amount": "Amount",
        "taxModule.date": "Date",
        "taxModule.schedule": "Remaining repayment schedule",
        "taxModule.shortTerm": "Due within twelve months",
        "taxModule.loanHelp": "Initial principal is the amount at the start. If you record all drawdowns as movements, enter 0. The remaining repayment schedule uses the outstanding amount at the valuation date.",
        "taxModule.share": "Ownership (%)",
        "taxModule.netAsset": "Net asset value",
        "taxModule.atCost": "Acquisition cost",
        "taxModule.exempt": "Apply participation exemption",
        "taxModule.equity": "Manual equity valuations",
        "taxModule.subsidiaryEquity": "Total subsidiary equity",
        "taxModule.capitalMovement": "Subsidiary capital contribution since previous valuation",
        "taxModule.dividendMovement": "Subsidiary dividend since previous valuation",
        "taxModule.equityDate": "Latest valuation date",
        "taxModule.participationHelp": "Enter subsidiary equity manually per valuation date. No subsidiary data is fetched from Office. Earlier valuations remain available. Capital and dividends are movements since the previous valuation.",
        "taxModule.debit": "Debit account",
        "taxModule.credit": "Credit account",
        "taxModule.fiscal": "Fiscal profit adjustment (+ add / − deduct)",
        "taxModule.otherDeduction": "Additional investment deduction",
        "taxModule.loss": "Historical unused tax loss",
        "taxModule.deductible": "Deductible for corporation tax (%)",
        "taxModule.ledgerAccount": "Ledger account",
        "taxModule.activities": "Business activities",
        "taxModule.group": "Group structure",
        "taxModule.principles": "Additional accounting principles",
        "taxModule.commitments": "Off-balance-sheet commitments",
        "taxModule.subsequentEvents": "Events after balance date",
        "taxModule.employees": "Average number of employees",
        "taxModule.additional": "Additional notes",
        "taxModule.classification": "Financial classification",
        "taxModule.mollie_settlement": "Mollie collective payment",
        "taxModule.settlementPayout": "Mollie bank payout",
        "taxModule.settlementHelp": "Select the invoice payments included in this payout. Payments dated after the payout or already linked elsewhere cannot be selected.",
        "taxModule.settlementSearch": "Search invoice payments",
        "taxModule.settlementPayments": "Mollie invoice payments including VAT",
        "taxModule.settlementFees": "Withheld Mollie fees",
        "taxModule.settlementFeesHelp": "Fees are filled automatically from the positive difference between the selected invoice payments and the bank payout. You can adjust the amount; your manual value is then retained for this payout. Fees are booked as bank costs without an extra bank transaction.",
        "taxModule.settlementGross": "Gross invoice payments",
        "taxModule.settlementNet": "Net bank payout",
        "taxModule.settlementDifference": "Remaining difference",
        "taxModule.settlementPaymentCount": "{{count}} invoice payments selected",
        "taxModule.settlementChoosePayout": "Choose the bank payout first.",
        "taxModule.settlementChoosePayments": "Select at least one invoice payment.",
        "taxModule.settlementLoadFailed": "Mollie invoice payments could not be loaded. Your selection has been preserved.",
        "taxModule.settlementRetry": "Try again",
        "taxModule.settlementEmpty": "No matching Mollie invoice payments on or before this payout date.",
        "taxModule.settlementInvalidSelection": "Some selected payments are missing, linked elsewhere or dated after this payout. Clear the selection and select the correct payments again.",
        "taxModule.settlementClear": "Clear selection",
        "taxModule.settlementBalanced": "The payout and fees match the selected invoice payments.",
        "taxModule.settlementOpen": "A remaining difference stays open on the Mollie clearing account.",
        "taxModule.transaction": "Transaction",
        "taxModule.ordinaryCost": "Ordinary expense",
        "taxModule.loan_drawdown": "Loan drawdown / issue",
        "taxModule.loan_repayment": "Loan repayment",
        "taxModule.loan_interest": "Loan interest",
        "taxModule.vpb": "Corporation tax payment / refund",
        "taxModule.vat": "VAT payment / refund",
        "taxModule.capital": "Share capital",
        "taxModule.premium": "Share premium",
        "taxModule.dividend": "Dividend / profit appropriation",
        "taxModule.transfer": "Transfer between own accounts",
        "taxModule.participation_purchase": "Participation purchase / capital contribution",
        "taxModule.participation_dividend": "Participation dividend",
        "taxModule.revenue": "Other income",
        "taxModule.related": "Linked loan / participation",
        "taxModule.periodStart": "Cost period start (optional)",
        "taxModule.periodEnd": "Cost period end (optional)",
        "taxModule.allocationHelp": "This financial classification is saved separately. For combined repayments, enter principal and interest separately.",
        "taxModule.linked": "Already linked",
        "taxModule.previewVAT": "Show VAT summary",
        "taxModule.outputVAT": "Output VAT",
        "taxModule.inputVAT": "Input VAT",
        "taxModule.payable": "VAT balance",
        "taxModule.reportHelp": "Generate annual accounts from Office and the additional registrations. The opening balance follows prior history automatically.",
        "taxModule.fiscalHelp": "Automatic VPB and KIA tables: 2020–2026. Enter other fiscal differences as corrections and unused historical losses once in their first financial year.",
        "taxModule.useNext": "Use next year",
        "taxModule.bookyearHelp": "Financial years stay editable. No closing or copying is required.",
        "taxModule.corrections": "Value corrections",
        "taxModule.accounts.bank": "Bank and cash",
        "taxModule.accounts.receivables": "Debtors",
        "taxModule.accounts.prepaid": "Prepaid expenses",
        "taxModule.accounts.inventory": "Inventory",
        "taxModule.accounts.fixed": "Other fixed assets",
        "taxModule.accounts.participations": "Participations",
        "taxModule.accounts.vat": "VAT",
        "taxModule.accounts.vpb": "Corporation tax",
        "taxModule.accounts.creditors": "Creditors",
        "taxModule.accounts.accrued": "Accrued expenses",
        "taxModule.accounts.deferred": "Deferred revenue",
        "taxModule.accounts.provisions": "Provisions",
        "taxModule.accounts.suspense": "Unclassified receipts",
        "taxModule.accounts.capital": "Share capital",
        "taxModule.accounts.premium": "Share premium",
        "taxModule.accounts.reserves": "Other reserves",
        "taxModule.accounts.retained": "Retained earnings",
        "taxModule.accounts.dividend": "Dividends / appropriation",
        "taxModule.accounts.revenue": "Revenue",
        "taxModule.accounts.direct": "Direct costs",
        "taxModule.accounts.costs": "Operating expenses",
        "taxModule.accounts.depreciation": "Depreciation",
        "taxModule.accounts.interest_cost": "Interest expense",
        "taxModule.accounts.interest_income": "Interest income",
        "taxModule.accounts.participation_result": "Participation results",
        "taxModule.accounts.other_result": "Other results",
        "assets.allCriticalities": "All criticalities",
        "assets.allCustomers": "All customers",
        "assets.allStatuses": "All statuses",
        "assets.clearFilters": "Clear filters",
        "assets.calendar.action": "Link calendar",
        "assets.calendar.copied": "Copied",
        "assets.calendar.copy": "Copy link",
        "assets.calendar.copyFailed": "The link could not be copied. Select it and copy it manually.",
        "assets.calendar.help": "Subscribe to the next service execution for every active interval in the tenants you can currently access. Your calendar updates from this feed automatically.",
        "assets.calendar.linkLabel": "ICS subscription link",
        "assets.calendar.loadFailed": "The calendar link could not be created.",
        "assets.calendar.secret": "Keep this link private. Anyone with the link can read these service dates.",
        "assets.calendar.title": "Service intervals in your calendar",
        "assets.back": "Assets",
        "assets.detail.addField": "Add field",
        "assets.detail.addChild": "Add child",
        "assets.detail.addInterval": "Add service interval",
        "assets.detail.addParent": "Add parent",
        "assets.detail.assignedTeam": "Assigned team",
        "assets.detail.complete": "Complete",
        "assets.detail.completeAndExport": "Complete and export report",
        "assets.detail.collapseBranch": "Collapse {{name}}",
        "assets.detail.cron": "Cron expression",
        "assets.detail.deleteIntervalConfirm": "Delete service interval ‘{{name}}’? Existing notes and reports remain available.",
        "assets.detail.dummyScript": "Enable dummy script",
        "assets.detail.editInterval": "Edit service interval",
        "assets.detail.enabled": "Enabled",
        "assets.detail.expandBranch": "Expand {{name}}",
        "assets.detail.fieldKey": "Field key",
        "assets.detail.fieldLabel": "Label",
        "assets.detail.graceDays": "Grace period (days)",
        "assets.detail.hierarchy": "Asset hierarchy",
        "assets.detail.invalidCron": "Invalid cron expression.",
        "assets.detail.lastCompleted": "Last completed",
        "assets.detail.lifecycle": "Asset lifecycle",
        "assets.detail.lifecycleProgress": "Asset lifecycle: {{percentage}}% elapsed",
        "assets.detail.accountParent": "Account",
        "assets.detail.noIntervals": "No service intervals configured.",
        "assets.detail.openOwnerAccount": "Open owner account",
        "assets.detail.optionsHelp": "Options, comma separated",
        "assets.detail.overview": "Overview",
        "assets.detail.ownerAccount": "Owner account",
        "assets.detail.priority": "Priority",
        "assets.detail.report": "Report / notes",
        "assets.detail.required": "Required",
        "assets.detail.result": "Result",
        "assets.detail.serviceIntervals": "Service intervals",
        "assets.detail.template": "Execution template",
        "assets.detail.templateName": "Template name",
        "assets.detail.timezone": "Time zone",
        "assets.detail.unit": "Unit",
        "assets.due": "Due",
        "assets.editAsset": "Edit asset",
        "assets.form.addTitle": "Add asset",
        "assets.form.addingChild": "This asset will be added as a child of the current asset.",
        "assets.form.addingParent": "This asset will be added as a parent of {{name}}.",
        "assets.form.assetType": "Asset type",
        "assets.form.criticality": "Criticality",
        "assets.form.editTitle": "Edit asset",
        "assets.form.endOfLifeDate": "End-of-life date",
        "assets.form.installationDate": "Installation date",
        "assets.form.internalAsset": "Internal asset (no customer)",
        "assets.custom.add": "Add property",
        "assets.custom.help": "Add type-specific metadata without expanding the base asset model.",
        "assets.custom.key": "Key",
        "assets.custom.label": "Label",
        "assets.custom.none": "No custom properties.",
        "assets.custom.remove": "Remove property",
        "assets.custom.title": "Custom properties",
        "assets.custom.type": "Type",
        "assets.custom.unit": "Unit",
        "assets.custom.value": "Value",
        "assets.form.location": "Location",
        "assets.form.manufacturer": "Manufacturer",
        "assets.form.model": "Model",
        "assets.form.noSupplier": "No supplier",
        "assets.form.owner": "Owner",
        "assets.form.parentAssets": "Parent assets",
        "assets.form.purchaseDate": "Purchase date",
        "assets.form.required": "Tenant, name and asset type are required.",
        "assets.form.selectTenant": "Select an administration…",
        "assets.form.serialNumber": "Serial number",
        "assets.form.tenant": "Administration",
        "assets.form.warrantyUntil": "Warranty until",
        "assets.internal": "Internal",
        "assets.filters": "Filters",
        "assets.management.enabled": "Manager enabled",
        "assets.management.help": "Add one or more managers to this asset. Each manager has its own configuration and status check.",
        "assets.management.remoteHelp": "The existing remote desktop flow uses this RPort client ID.",
        "assets.management.rportId": "RPort client ID",
        "assets.management.title": "Managers",
        "assets.management.mikrotik": "MikroTik",
        "assets.management.remoteDesktop": "Remote desktop",
        "assets.management.domainName": "Domain name",
        "assets.management.domain": "Domain",
        "assets.management.managerName": "Manager name",
        "assets.management.managerNameOptional": "Optional, for example primary connection",
        "assets.management.remove": "Remove manager",
        "assets.management.none": "No managers have been added yet.",
        "assets.management.disabled": "Disabled",
        "assets.management.expiresAt": "Expires",
        "assets.management.daysRemaining": "{{count}} days remaining",
        "assets.management.checked": "Checked",
        "assets.management.connecting": "Connecting",
        "assets.management.unreachable": "Unreachable",
        "assets.management.authenticationFailed": "Authentication failed",
        "assets.management.configurationError": "Configuration error",
        "assets.management.lastSeen": "Last seen",
        "assets.management.pingTargets": "Ping targets",
        "assets.management.pingTargetsHelp": "The router checks these internal addresses over its existing API connection.",
        "assets.management.addPingTarget": "Add target",
        "assets.management.pingTargetNumber": "Target {{count}}",
        "assets.management.pingTargetEnabled": "Ping target enabled",
        "assets.management.removePingTarget": "Remove ping target",
        "assets.management.linkedAsset": "Linked asset",
        "assets.management.manualTarget": "Manual target",
        "assets.management.noAssetsFound": "No assets found",
        "assets.management.pingAddress": "IP address or hostname",
        "assets.management.noPingTargets": "No ping targets have been added yet.",
        "assets.management.pingState.unknown": "Unknown",
        "assets.management.pingState.up": "Reachable",
        "assets.management.pingState.degraded": "Packet loss",
        "assets.management.pingState.unreachable": "Unreachable",
        "assets.management.pingState.down": "Down",
        "assets.management.pingStateStale": "Outdated",
        "assets.management.pingIssues": "{{count}} ping issue(s)",
        "assets.management.pingIssues_one": "{{count}} ping issue",
        "assets.management.pingIssues_other": "{{count}} ping issues",
        "assets.management.averageRtt": "Average RTT",
        "assets.management.packetLoss": "Packet loss",
        "assets.newAsset": "Add asset",
        "assets.noAssets": "No assets found.",
        "assets.notes.addAttachment": "Add attachment",
        "assets.notes.addDocument": "Add attachment",
        "assets.notes.addLinkedNote": "Add follow-up note",
        "assets.notes.addNote": "Add note",
        "assets.notes.attachments": "Attachments",
        "assets.notes.attachmentsSelected": "{{count}} attachment(s) selected",
        "assets.notes.byAuthor": "by {{author}}",
        "assets.notes.content": "Content",
        "assets.notes.correct": "Correct (F13)",
        "assets.notes.corrected": "Corrected",
        "assets.notes.correctionReason": "Reason for correction",
        "assets.notes.edit": "Edit note",
        "assets.notes.edited": "edited",
        "assets.notes.editWindow": "The author can edit this note for 24 hours after creation.",
        "assets.notes.linkedTo": "This note will be linked to {{name}}.",
        "assets.notes.logbook": "Asset logbook",
        "assets.notes.noNotes": "No notes have been added.",
        "assets.notes.openDocumentFailed": "The attachment could not be opened.",
        "assets.notes.removeAttachment": "Remove attachment",
        "assets.notes.saveCorrection": "Save correction",
        "assets.notes.signaturePending": "Signature required",
        "assets.notes.signatureQuestion": "Does this document require the customer's signature?",
        "assets.notes.signatureRequired": "Signature required",
        "assets.notes.signed": "Signed",
        "assets.notes.title": "Title",
        "assets.overdue": "Overdue",
        "assets.resultCount": "{{count}} assets",
        "assets.resultCountSingle": "1 asset",
        "assets.relation.dueCount": "{{count}} due",
        "assets.relation.loadFailed": "Assets could not be loaded.",
        "assets.relation.none": "No assets are linked to this customer.",
        "assets.relation.overdueCount": "{{count}} overdue",
        "assets.search": "Search assets…",
        "assets.subtitle": "Central overview of internal and customer assets, maintenance and notes.",
        "assets.title": "Assets",
        "accounts.accountAssetsCard.addRouter": "Add router",
        "accounts.accountAssetsCard.assets": "Assets",
        "accounts.accountAssetsCard.connected": "Connected",
        "accounts.accountAssetsCard.deleteAsset": "Delete {{name}}",
        "accounts.accountAssetsCard.deleteAssetConfirm": "Delete asset \"{{name}}\"?",
        "accounts.accountAssetsCard.deleteFailed": "The asset could not be deleted.",
        "accounts.accountAssetsCard.editAsset": "Edit {{name}}",
        "accounts.accountAssetsCard.editRouter": "Edit router",
        "accounts.accountAssetsCard.invalidForm": "Enter a name, address and username.",
        "accounts.accountAssetsCard.loadFailed": "Assets could not be loaded.",
        "accounts.accountAssetsCard.offline": "Offline",
        "accounts.accountAssetsCard.openAsset": "Open {{name}}",
        "accounts.accountAssetsCard.saveFailed": "The router could not be saved.",
        "accounts.accountAssetsCard.statusUnavailable": "Status unavailable",
        "accounts.accountAttachmentsCard.approve": "Approve",
        "accounts.accountAttachmentsCard.deleteDocument": "Delete document",
        "accounts.accountAttachmentsCard.documents": "Documents",
        "accounts.accountAttachmentsCard.download": "Download",
        "accounts.accountAttachmentsCard.editExpiry": "Edit expiry",
        "accounts.accountAttachmentsCard.editExpiryDate": "Edit expiry date",
        "accounts.accountAttachmentsCard.expiresDate": "Expires {{date}}",
        "accounts.accountAttachmentsCard.expiryDate": "Expiry date",
        "accounts.accountAttachmentsCard.explainWhyNameIsRejectedThisReasonIsShownToTheWorker": "Explain why {{name}} is rejected. This reason is shown to the worker.",
        "accounts.accountAttachmentsCard.leaveThisEmptyToRemoveTheExpiryDate": "Leave this empty to remove the expiry date.",
        "accounts.accountAttachmentsCard.noDocumentsUploadedYet": "No documents uploaded yet.",
        "accounts.accountAttachmentsCard.reasonForRejection": "Reason for rejection",
        "accounts.accountAttachmentsCard.reject": "Reject",
        "accounts.accountAttachmentsCard.rejectDocument": "Reject document",
        "accounts.accountAttachmentsCard.thePdfCouldNotBeDisplayed": "The PDF could not be displayed.",
        "accounts.accountAttachmentsCard.unknownType": "Unknown type",
        "accounts.accountAttachmentsCard.updateTheExpiryDateForName": "Update the expiry date for {{name}}.",
        "accounts.accountAttachmentsCard.view": "View",
        "accounts.accountCreate.createAccount": "Create account",
        "accounts.accountDetail.accountCouldNotBeLoaded": "Account could not be loaded.",
        "accounts.accountDetail.accountSaved": "Account saved.",
        "accounts.accountDetail.confirmMerge": "Merge and delete current account",
        "accounts.accountDetail.merge": "Merge",
        "accounts.accountDetail.mergeInto": "Account that should remain",
        "accounts.accountDetail.mergeRelations": "Merge accounts",
        "accounts.accountDetail.mergeWarning": "{{source}} will be permanently deleted. All linked persons, invoices, quotes, recurring rules, expenses, projects, documents, assets and emails will be moved to the selected account. The selected account's existing details take precedence.",
        "accounts.accountDetail.merging": "Merging…",
        "accounts.accountDetail.noMergeTargets": "No other accounts are available in this administration.",
        "accounts.accountDetail.selectMergeTarget": "Select an account…",
        "accounts.accountDetailsCards.addAddress": "Add address",
        "accounts.accountDetailsCards.addBankAccount": "Add bank account",
        "accounts.accountDetailsCards.checkingKvkDetails": "Checking Chamber of Commerce details",
        "accounts.accountDetailsCards.checkingVatDetails": "Checking VAT details",
        "accounts.accountDetailsCards.companyNameAndAddressMatchTheKvkRegistration": "Company name and address match the Chamber of Commerce registration",
        "accounts.accountDetailsCards.companyNameAndAddressMatchTheVatRegistration": "Company name and address match the VAT registration",
        "accounts.accountDetailsCards.countDays": "{{count}} days",
        "accounts.accountDetailsCards.differs": "differs",
        "accounts.accountDetailsCards.edit": "Edit",
        "accounts.accountDetailsCards.hourlyRate": "Hourly rate",
        "accounts.accountDetailsCards.internalDefaultsUsedForApprovedProjectHoursWorkersCannotViewTheseAmounts": "Internal defaults used for approved project hours. Workers cannot view these amounts.",
        "accounts.accountDetailsCards.kvkCheckFailed": "Chamber of Commerce check failed",
        "accounts.accountDetailsCards.kvkCheckedAt": "Chamber of Commerce data checked on {{date}}",
        "accounts.accountDetailsCards.kvkDetailsDiffer": "Chamber of Commerce details differ",
        "accounts.accountDetailsCards.kvkDetailsMatch": "Chamber of Commerce details match",
        "accounts.accountDetailsCards.kvkNumberIsInvalid": "Chamber of Commerce number is invalid",
        "accounts.accountDetailsCards.kvkNumberIsValidButTheCompanyNameOrAddressDiffers": "Chamber of Commerce number is valid, but the company name or address differs",
        "accounts.accountDetailsCards.matches": "matches",
        "accounts.accountDetailsCards.noAddressSaved": "No address saved.",
        "accounts.accountDetailsCards.noBankAccountSaved": "No bank account saved.",
        "accounts.accountDetailsCards.ibanIsInvalid": "IBAN is invalid",
        "accounts.accountDetailsCards.notReturned": "Not returned",
        "accounts.accountDetailsCards.ofHourlyRate": "of hourly rate",
        "accounts.accountDetailsCards.primary": "Primary",
        "accounts.accountDetailsCards.primaryAddress": "Primary address",
        "accounts.accountDetailsCards.primaryBankAccount": "Primary bank account",
        "accounts.accountDetailsCards.registeredAddress": "Registered address:",
        "accounts.accountDetailsCards.registeredCompany": "Registered company:",
        "accounts.accountDetailsCards.reverseChargeVatByDefault": "Reverse-charge VAT by default",
        "accounts.accountDetailsCards.savedToRegistration": "Saved → registration",
        "accounts.accountDetailsCards.useRegisteredDetails": "Use registered details",
        "accounts.accountDetailsCards.vatCheckFailed": "VAT check failed",
        "accounts.accountDetailsCards.vatDetailsDiffer": "VAT details differ",
        "accounts.accountDetailsCards.vatDetailsMatch": "VAT details match",
        "accounts.accountDetailsCards.vatNumberIsInvalid": "VAT number is invalid",
        "accounts.accountDetailsCards.vatNumberIsValidButTheCompanyNameOrAddressDiffers": "VAT number is valid, but the company name or address differs",
        "accounts.accountExpensesCard.noExpensesLinkedToThisAccount": "No expenses linked to this account.",
        "accounts.accountFormCard.accountDetails": "Account details",
        "accounts.accountFormCard.accountName": "Account name",
        "accounts.accountFormCard.addition": "Addition",
        "accounts.accountFormCard.addresses": "Addresses",
        "accounts.accountFormCard.bankAccount": "Bank account",
        "accounts.accountFormCard.bankAccounts": "Bank accounts",
        "accounts.accountFormCard.chamberOfCommerceNumber": "Chamber of Commerce number",
        "accounts.accountFormCard.country": "Country",
        "accounts.accountFormCard.currency": "Currency",
        "accounts.accountFormCard.hourlyRateEuroPerHour": "Hourly rate (€ per hour)",
        "accounts.accountFormCard.internalDefaultsForApprovedProjectHours": "Internal defaults for approved project hours.",
        "accounts.accountFormCard.invoiceEmail": "Invoice email",
        "accounts.accountFormCard.kvkNumberCouldNotBeChecked": "Chamber of Commerce number could not be checked.",
        "accounts.accountFormCard.kvkNumberIsNotValid": "Chamber of Commerce number is not valid.",
        "accounts.accountFormCard.kvkNumberVerifiedAddressDetailsWereFilledIn": "Chamber of Commerce number verified; address details were filled in.",
        "accounts.accountFormCard.legalName": "Legal name",
        "accounts.accountFormCard.paymentDeadlineDays": "Payment deadline (days)",
        "accounts.accountFormCard.postalCode": "Postal code",
        "accounts.accountFormCard.reverseChargeVatByDefaultOnInvoicesForThisAccount": "Reverse-charge VAT by default on invoices for this account",
        "accounts.accountFormCard.selectTenant": "Select tenant…",
        "accounts.accountFormCard.separateNamesWithCommas": "Separate names with commas",
        "accounts.accountFormCard.tradeNames": "Trade names",
        "accounts.accountFormCard.vatNumberCouldNotBeChecked": "VAT number could not be checked.",
        "accounts.accountFormCard.vatNumberVerifiedAddressDetailsWereFilledIn": "VAT number verified; address details were filled in.",
        "accounts.accountFormCard.workerRates": "Worker rates",
        "accounts.accountInvoicesCard.noInvoicesLinkedToThisAccount": "No invoices linked to this account.",
        "accounts.accountInvoicesCard.showCountMoreInvoices": "Show {{count}} more invoices",
        "accounts.accountPersonsCard.addPerson": "Add person",
        "accounts.accountPersonsCard.alreadyLinked": "Already linked to this account",
        "accounts.accountPersonsCard.contactAlreadyInUse": "This email address or phone number is already in use. Link an existing person instead.",
        "accounts.accountPersonsCard.couldNotCreatePerson": "Could not create this person. Please try again.",
        "accounts.accountPersonsCard.couldNotLinkPerson": "Could not link this person. Please try again.",
        "accounts.accountPersonsCard.couldNotLoadPersons": "Could not load persons. Please try again before creating a person.",
        "accounts.accountPersonsCard.createAndLink": "Create and link",
        "accounts.accountPersonsCard.linkExistingPerson": "Link existing person",
        "accounts.accountPersonsCard.linkPerson": "Link {{name}}",
        "accounts.accountPersonsCard.noMatchingPersons": "No matching persons",
        "accounts.accountPersonsCard.noPersonsLinkedYet": "No persons linked yet.",
        "accounts.accountPersonsCard.removeAsRepresentative": "Remove as representative",
        "accounts.accountPersonsCard.representative": "Representative",
        "accounts.accountPersonsCard.retryLoadingPersons": "Retry loading persons",
        "accounts.accountPersonsCard.selectPerson": "Select person…",
        "accounts.accountPersonsCard.setAsRepresentative": "Set as representative",
        "accounts.accountProjectsCard.noProjectsLinkedToThisAccount": "No projects linked to this account.",
        "accounts.accountQuotesCard.noQuotesLinkedToThisAccount": "No quotes linked to this account.",
        "accounts.accountRecentEmailsCard.composeEmail": "Compose email",
        "accounts.accountRecentEmailsCard.noSentEmailsFoundForThisAccount": "No sent emails found for this account.",
        "accounts.accountRecentEmailsCard.noSubject": "(No subject)",
        "accounts.accountRecentEmailsCard.sentEmailsCouldNotBeLoaded": "Sent emails could not be loaded.",
        "accounts.accountRecentEmailsCard.unknownRecipient": "Unknown recipient",
        "accounts.accountRecurringsCard.addRecurring": "Add recurring",
        "accounts.accountRecurringsCard.deleteRecurringName": "Delete recurring \"{{name}}\"?",
        "accounts.accountRecurringsCard.editNamed": "Edit {{name}}",
        "accounts.accountRecurringsCard.editRecurring": "Edit recurring",
        "accounts.accountRecurringsCard.noRecurringsConfiguredForThisAccount": "No recurrings configured for this account.",
        "accounts.accountRecurringsCard.saveRecurring": "Save recurring",
        "accounts.accountRecurringsCard.unit": "Unit",
        "accounts.accounts.accountOverview": "Account overview",
        "accounts.accounts.clientDistribution": "Client distribution",
        "accounts.accounts.clientDistributionShare": "{{name}} {{percentage}}% ({{hours}} h)",
        "accounts.accounts.customersAndSuppliersInOneRelationshipOverview": "Customers and suppliers in one relationship overview.",
        "accounts.accounts.hoursShort": "{{hours}} h",
        "accounts.accounts.loadingAccounts": "Loading accounts…",
        "accounts.accounts.noHoursRegistered": "No hours registered",
        "accounts.accounts.noResponsible": "No responsible",
        "accounts.accounts.approvedDocument": "{{approved}}/{{total}} document approved",
        "accounts.accounts.approvedDocuments": "{{approved}}/{{total}} documents approved",
        "accounts.accounts.pendingDocument": "{{count}} pending document",
        "accounts.accounts.pendingDocuments": "{{count}} pending documents",
        "accounts.accounts.searchAccounts": "Search accounts",
        "accounts.accounts.searchNameEmailOrVatNumber": "Search name, email or VAT number…",
        "accounts.accounts.suppliers": "Suppliers",
        "accounts.accounts.withoutRole": "Without role",
        "accounts.accounts.unknownLocation": "Unknown location",
        "accounts.invoiceIntervalField.cronExpression": "Cron expression",
        "accounts.invoiceIntervalField.cronExpression.2218a7d": "cron expression",
        "accounts.invoiceIntervalField.customSchedule": "Custom schedule",
        "accounts.invoiceIntervalField.invoiceInterval": "Invoice interval",
        "accounts.invoiceIntervalField.invoiceIntervalPreset": "Invoice interval preset",
        "accounts.invoiceIntervalField.timezone": "Time zone",
        "authentication.login.donTTryToHackThisYouWillBeEatenByOurInterns": "Don't try to hack this, you will be eaten by our interns.",
        "authentication.login.emailAddress": "Email-address",
        "authentication.login.login": "Login",
        "authentication.login.logIn": "Log In",
        "authentication.login.signIn": "Sign in",
        "common.accessLevel": "Access level",
        "common.accounts": "Accounts",
        "common.add": "Add",
        "common.addCheck": "Add check",
        "common.addExpense": "Add expense",
        "common.addNewCustomer": "Add new customer",
        "common.addNewService": "Add new service",
        "common.address": "Address",
        "common.addUser": "Add user",
        "common.adminConsole.closeConsole": "Close console",
        "common.adminConsole.consoleCommand": "Console command",
        "common.adminConsole.officeConsole": "Office console",
        "common.adminConsole.working": "Working…",
        "common.amount": "Amount",
        "common.belgium": "Belgium",
        "common.billing": "Billing",
        "common.body": "Body",
        "common.budget": "Budget",
        "common.cancel": "Cancel",
        "common.checkNeedsANameTargetAndType": "Check needs a name, target and type",
        "common.checks": "Checks",
        "common.chooseOne": "Choose one...",
        "common.chooseTenant": "Choose tenant",
        "common.city": "City",
        "common.close": "Close",
        "common.compose": "Compose",
        "common.conversations": "Conversations",
        "common.country": "Country:",
        "common.created": "Created",
        "common.customer": "Customer",
        "common.customers": "Customers",
        "common.date": "Date",
        "common.dateOfBirth": "Date of birth",
        "common.defaultPaymentTerm": "Default payment term",
        "common.delete": "Delete",
        "common.deleteCheck": "Delete check",
        "common.deleteNameThisCannotBeUndone": "Delete {{name}}? This cannot be undone.",
        "common.description": "Description",
        "common.details": "Details",
        "common.draft": "Draft",
        "common.dropzoneCustom.dropFileSHereOrClickToUpload": "Drop file(s) here or click to upload.",
        "common.email": "Email",
        "common.emailAddress": "Email address",
        "common.expense": "Expense",
        "common.expenses": "Expenses",
        "common.expensesHasFailedCheckYourCredentials": "Expenses has failed, check your credentials",
        "common.firstName": "First name",
        "common.fixedAmountPerHour": "Fixed amount per hour",
        "common.fixedDeadline": "Fixed deadline",
        "common.france": "France",
        "common.from": "From:",
        "common.germany": "Germany",
        "common.invoice": "Invoice",
        "common.invoices": "Invoices",
        "common.label": "Label",
        "common.languageDropdown.language": "Language",
        "common.lastName": "Last name",
        "common.lastQCard.ex": "ex.",
        "common.lastQCard.expenseTaxes": "expense taxes",
        "common.lastQCard.lastQuarter": "Last quarter",
        "common.ledgerAccount": "Ledger account",
        "common.link": "Link",
        "common.loginHasFailedCheckYourCredentials": "Login has failed, check your credentials",
        "common.message": "Message",
        "common.mfaActive": "MFA active",
        "common.mfaInactive": "MFA inactive",
        "common.name": "Name",
        "common.nameAndRegionAreMandatory": "Name & region are mandatory",
        "common.nameAndTotalAreMandatory": "Name & total are mandatory",
        "common.new": "New",
        "common.newAccount": "New account",
        "common.newProject": "New project",
        "common.nextRun": "Next run",
        "common.noAccountsFound": "No accounts found.",
        "common.noConversationsFound": "No conversations found",
        "common.noEmail": "No email",
        "common.noName": "No name",
        "common.none": "None",
        "common.number": "Number",
        "common.onBehalfOf": "On behalf of",
        "common.open": "Open",
        "common.orCreateANewPerson": "or create a new person",
        "common.outstandingCard.countInvoices": "{{count}} invoices",
        "common.overdue": "Overdue",
        "common.paid": "Paid",
        "common.password": "Password",
        "common.payWhenPaid": "Pay when paid",
        "common.percentageOfHourlyRate": "Percentage of hourly rate",
        "common.perHour": "per hour",
        "common.personNeedsAName": "Person needs a name",
        "common.persons": "Persons",
        "common.phone": "Phone",
        "common.platformFee": "Platform fee",
        "common.platformFeeType": "Platform fee type",
        "common.previewUnavailable": "Preview unavailable",
        "common.price": "Price",
        "common.profile": "Profile",
        "common.profileMenu.logout": "Logout",
        "common.projects": "Projects",
        "common.pullToRefresh.pullToRefresh": "Pull to refresh",
        "common.pullToRefresh.refreshing": "Refreshing...",
        "common.pullToRefresh.releaseToRefresh": "Release to refresh",
        "common.qty": "Qty",
        "common.quote": "Quote",
        "common.recurringItems": "Recurring items",
        "common.region": "Region",
        "common.remaining": "remaining",
        "common.responsible": "Responsible",
        "common.revenue": "Revenue",
        "common.rightbar.boxed": "Boxed",
        "common.rightbar.brand": "Brand",
        "common.rightbar.compact": "Compact",
        "common.rightbar.dark": "Dark",
        "common.rightbar.default": "Default",
        "common.rightbar.fixed": "Fixed",
        "common.rightbar.fluid": "Fluid",
        "common.rightbar.horizontal": "Horizontal",
        "common.rightbar.layoutMode": "Layout Mode",
        "common.rightbar.layoutPosition": "Layout Position",
        "common.rightbar.layouts": "Layouts",
        "common.rightbar.layoutWidth": "Layout Width",
        "common.rightbar.light": "Light",
        "common.rightbar.scrollable": "Scrollable",
        "common.rightbar.sidebarColor": "Sidebar Color",
        "common.rightbar.sidebarSize": "Sidebar Size",
        "common.rightbar.smallIconView": "Small (Icon View)",
        "common.rightbar.themeCustomizer": "Theme Customizer",
        "common.rightbar.topbarColor": "Topbar Color",
        "common.rightbar.vertical": "Vertical",
        "common.role": "Role",
        "common.roles": "Roles",
        "common.save": "Save",
        "common.saving": "Saving…",
        "common.search": "Search...",
        "common.searchAccounts": "Search accounts…",
        "common.send": "Send",
        "common.sidebarContent.dashboard": "Dashboard",
        "common.sidebarContent.menu": "Menu",
        "common.status": "Status",
        "common.statusPage": "Status page",
        "common.street": "Street",
        "common.subject": "Subject",
        "common.supplier": "Supplier",
        "common.target": "Target",
        "common.tax": "Tax",
        "common.taxes": "Taxes",
        "common.technical": "Technical",
        "common.tenant": "Tenant",
        "common.tenants": "Tenants",
        "common.theNetherlands": "The Netherlands",
        "common.tickets": "Tickets",
        "common.to": "To:",
        "common.total": "Total",
        "common.type": "Type",
        "common.unitedKingdom": "United Kingdom",
        "common.unknown": "Unknown",
        "common.unknownAccount": "Unknown account",
        "common.unknownSupplier": "Unknown supplier",
        "common.uom": "Uom",
        "common.users": "Users",
        "common.vat": "VAT",
        "common.vatNumber": "VAT number",
        "common.vatNumberIsNotValid": "VAT number is not valid.",
        "common.vatRatePercentage": "VAT rate (%)",
        "common.worker": "Worker",
        "common.zip": "Zip",
        "customer.computerRow.firmware": "firmware",
        "customer.computerRow.latestVersionVersion": "Latest version: {{version}}",
        "customer.computerRow.loadingRouterStatus": "Loading router status",
        "customer.computersCard.assets": "Managed devices",
        "customer.computersCard.interfacesOptionalEGWanEther1BackupLte1": "Interfaces (optional, e.g. WAN=ether1, Backup=lte1)",
        "customer.computersCard.noAssetsLinked": "No assets linked.",
        "customer.computersCard.passwordLeaveEmptyToKeepCurrent": "Password (leave empty to keep current)",
        "customer.computersCard.port": "Port",
        "customer.computersCard.router": "Router",
        "customer.computersCard.saveRouter": "Save router",
        "customer.computersCard.updateRouter": "Update router",
        "customer.computersCard.username": "Username",
        "customer.computersCard.useTls": "Use TLS",
        "customer.computersCard.webUrlOptional": "Web URL (optional)",
        "customer.customerAddForm.addCustomer": "Add customer",
        "customer.customerAddForm.nameEmailAndTenantAreMandatory": "Name, email and tenant are mandatory",
        "customer.customerDatesCard.amountOfDays": "Amount of days",
        "customer.customerDatesCard.autoClose": "Auto-Close",
        "customer.customerDatesCard.defaultDeadlineInDays": "Default deadline (in days)",
        "customer.customerDatesCard.intervalCronjob": "Interval (cronjob)",
        "customer.customerDatesCard.value": "Value",
        "customer.customerEditForm.editCustomer": "Edit customer",
        "customer.customerEditForm.nameIsMandatory": "Name is mandatory",
        "customer.customerEditForm.selectCountry": "Select country",
        "customer.customerEmailCard.fromAddress": "From address",
        "customer.customerEmailCard.fromName": "From name",
        "customer.customerEmailCard.noEmailsFound": "No emails found",
        "customer.customerPersonAdd.insteadLinkName": "Instead link {{name}}",
        "customer.customerPersonChange.deletePerson": "Delete person",
        "customer.customerPersonRow.mfaActive": "MFA: Active",
        "customer.customerPersonRow.mfaInactive": "MFA: Inactive",
        "customer.customerPersonRow.noAuthLogin": "No auth login",
        "customer.customerRecurringAdd.everyMonth": "Every month",
        "customer.customerRecurringAdd.everyQuarter": "Every quarter",
        "customer.customerRecurringAdd.everyYear": "Every year",
        "customer.customerRecurringAdd.interval": "Interval",
        "customer.customerRecurringAdd.recurringNeedsANamePriceIntervalAmountAndVatRateBetween0PercentageAnd100Percentage": "Recurring needs a name, price, interval, amount and VAT rate between 0% and 100%",
        "customer.customerVatCheckCard.vatCheck": "VAT check",
        "customer.personManagementCard.addAnotherPerson": "Add another person",
        "customer.personManagementCard.createAndLinkPerson": "Create and link person",
        "customer.personManagementCard.existingPerson": "Existing person",
        "customer.personManagementCard.function": "Function",
        "customer.personManagementCard.noContactsLinkedYet": "No contacts linked yet.",
        "customer.personManagementCard.selectAPerson": "Select a person…",
        "customer.recurringManagementCard.addAnotherRecurring": "Add another recurring",
        "dashboard.activeProjectsOverview.active": "Active",
        "dashboard.activeProjectsOverview.activeProjects": "Active projects",
        "dashboard.activeProjectsOverview.allProjects": "All projects",
        "dashboard.activeProjectsOverview.loadingProjects": "Loading projects…",
        "dashboard.activeProjectsOverview.openProject": "Open project",
        "dashboard.activeProjectsOverview.percentageOfTheDuration": "% of the duration",
        "dashboard.activeProjectsOverview.projectsCouldNotBeLoaded": "Projects could not be loaded.",
        "dashboard.activeProjectsOverview.showAll": "Show all",
        "dashboard.activeProjectsOverview.showFewer": "Show fewer",
        "dashboard.activeProjectsOverview.thereAreCurrentlyNoActiveProjects": "There are currently no active projects.",
        "dashboard.assetServicesCard.dueAssetServices": "Asset services due",
        "dashboard.assetServicesCard.loadFailed": "Asset services could not be loaded.",
        "dashboard.assetServicesCard.loading": "Loading asset services…",
        "dashboard.assetServicesCard.noneDue": "No asset services are currently due.",
        "dashboard.editor.addWidget": "Add widget",
        "dashboard.editor.configureWidget": "Configure {{name}}",
        "dashboard.editor.customize": "Customize dashboard",
        "dashboard.editor.dragWidget": "Move {{name}}",
        "dashboard.editor.duplicateWidget": "Duplicate {{name}}",
        "dashboard.editor.emptyDescription": "Add one or more widgets to create your personal overview.",
        "dashboard.editor.emptyTitle": "Your dashboard is empty",
        "dashboard.editor.gridColumns": "Responsive grid: {{count}} columns",
        "dashboard.editor.loadFailed": "Your dashboard configuration could not be loaded.",
        "dashboard.editor.loading": "Loading your dashboard…",
        "dashboard.editor.noSettings": "This widget has no content settings.",
        "dashboard.editor.removeWidget": "Remove {{name}}",
        "dashboard.editor.saveFailed": "The dashboard could not be saved.",
        "dashboard.editor.widgetActions": "Actions for {{name}}",
        "dashboard.openInvoicesCard.accountNamesUnavailable": "Customer names could not be loaded.",
        "dashboard.openInvoicesCard.due": "Due {{date}}",
        "dashboard.openInvoicesCard.empty": "There are no open invoices.",
        "dashboard.openInvoicesCard.openInvoices": "Open all invoices",
        "dashboard.openInvoicesCard.overdue": "Overdue since {{date}}",
        "dashboard.openInvoicesCard.payWhenPaid": "Pay when paid",
        "dashboard.openInvoicesCard.title": "Open invoices",
        "dashboard.openInvoicesCard.unnamed": "Unnamed invoice",
        "dashboard.pendingDocumentsCard.documents": "{{count}} document(s)",
        "dashboard.pendingDocumentsCard.empty": "There are no documents awaiting approval.",
        "dashboard.pendingDocumentsCard.loadFailed": "Documents awaiting approval could not be loaded.",
        "dashboard.pendingDocumentsCard.loading": "Loading documents awaiting approval…",
        "dashboard.pendingDocumentsCard.openAccounts": "Open all accounts",
        "dashboard.pendingDocumentsCard.title": "Documents to approve",
        "dashboard.pendingHoursCard.empty": "There are no hours awaiting approval.",
        "dashboard.pendingHoursCard.entries": "{{count}} hour entries",
        "dashboard.pendingHoursCard.loadFailed": "Hours awaiting approval could not be loaded.",
        "dashboard.pendingHoursCard.loading": "Loading hours awaiting approval…",
        "dashboard.pendingHoursCard.oldest": "Oldest: {{date}}",
        "dashboard.pendingHoursCard.openProjects": "Open all projects",
        "dashboard.pendingHoursCard.title": "Hours to approve",
        "dashboard.upcomingAssetServicesCard.empty": "No asset services are scheduled in the next {{count}} days.",
        "dashboard.upcomingAssetServicesCard.loadFailed": "Upcoming asset services could not be loaded.",
        "dashboard.upcomingAssetServicesCard.loading": "Loading upcoming asset services…",
        "dashboard.upcomingAssetServicesCard.openAssets": "Open all assets",
        "dashboard.upcomingAssetServicesCard.title": "Upcoming asset services",
        "dashboard.workerClientBalanceCard.empty": "No registered hours were found in this period.",
        "dashboard.workerClientBalanceCard.intro": "Workers with the most concentrated distribution are shown first, over the last {{count}} days.",
        "dashboard.workerClientBalanceCard.loadFailed": "The hour distribution could not be loaded.",
        "dashboard.workerClientBalanceCard.loading": "Loading hour distribution…",
        "dashboard.workerClientBalanceCard.openProjects": "Open all projects",
        "dashboard.workerClientBalanceCard.signalOnly": "This hour distribution is a signal only. All circumstances together determine the employment relationship under the Wet DBA.",
        "dashboard.workerClientBalanceCard.title": "Hour distribution across clients",
        "dashboard.workerClientBalanceCard.total": "{{hours}} total",
        "dashboard.widgets.activeProjects.description": "Current projects with duration, progress and staffing.",
        "dashboard.widgets.activeProjects.title": "Active projects",
        "dashboard.widgets.assetServices.description": "Maintenance intervals that are due or overdue.",
        "dashboard.widgets.assetServices.title": "Asset services due",
        "dashboard.widgets.openInvoices.description": "Final invoices with an outstanding amount.",
        "dashboard.widgets.openInvoices.title": "Open invoices",
        "dashboard.widgets.orphanedPayments.description": "Incoming payments that are not linked to an invoice.",
        "dashboard.widgets.orphanedPayments.title": "Orphaned payments",
        "dashboard.widgets.outstanding.description": "The total outstanding invoice amount.",
        "dashboard.widgets.outstanding.title": "Outstanding",
        "dashboard.widgets.pendingDocuments.description": "Documents from workers that are awaiting approval.",
        "dashboard.widgets.pendingDocuments.title": "Documents to approve",
        "dashboard.widgets.pendingHours.description": "Registered hours that are awaiting approval.",
        "dashboard.widgets.pendingHours.title": "Hours to approve",
        "dashboard.widgets.recentCalls.description": "The most recently received telephone calls.",
        "dashboard.widgets.recentCalls.title": "Recent calls",
        "dashboard.widgets.revenue.description": "Revenue for this week, this month, this quarter or this year.",
        "dashboard.widgets.revenue.title": "Revenue",
        "dashboard.widgets.salesAnalytics.description": "Revenue and expenses over a configurable period.",
        "dashboard.widgets.salesAnalytics.title": "Revenue analytics",
        "dashboard.widgets.settings.items": "Number of items",
        "dashboard.widgets.settings.daysBack": "Days back",
        "dashboard.widgets.settings.daysAhead": "Days ahead",
        "dashboard.widgets.settings.months": "Number of months",
        "dashboard.widgets.settings.period": "Period",
        "dashboard.widgets.settings.periodDays": "Period in days",
        "dashboard.widgets.settings.projects": "Number of projects",
        "dashboard.widgets.settings.thisMonth": "This month",
        "dashboard.widgets.settings.thisQuarter": "This quarter",
        "dashboard.widgets.settings.thisWeek": "This week",
        "dashboard.widgets.settings.thisYear": "This year",
        "dashboard.widgets.upcomingAssetServices.description": "Enabled asset services scheduled within a configurable number of days.",
        "dashboard.widgets.upcomingAssetServices.title": "Upcoming asset services",
        "dashboard.widgets.unreadEmail.description": "The most recent unread incoming conversations.",
        "dashboard.widgets.unreadEmail.title": "Unread email",
        "dashboard.widgets.workerClientBalance.description": "Distribution of workers' registered hours across clients as a Wet DBA signal.",
        "dashboard.widgets.workerClientBalance.title": "Hour distribution across clients",
        "dashboard.orphanedPaymentsCard.noOrphanedPaymentsFound": "No orphaned payments found.",
        "dashboard.orphanedPaymentsCard.orphanedPayments": "Orphaned payments",
        "dashboard.orphanedPaymentsCard.showAll": "Show all orphaned payments",
        "dashboard.orphanedPaymentsCard.showSuggested": "Show suggested payments",
        "dashboard.revenueCard.previousMonth": "Previous month",
        "dashboard.revenueCard.previousWeek": "Previous week",
        "dashboard.revenueCard.previousYear": "Previous year",
        "dashboard.recentCallsCard.answered": "Answered",
        "dashboard.recentCallsCard.blocked": "Blocked",
        "dashboard.recentCallsCard.enqueued": "Enqueued",
        "dashboard.recentCallsCard.leftQueue": "Left queue",
        "dashboard.recentCallsCard.noCallsFound": "No calls found.",
        "dashboard.recentCallsCard.outOfOffice": "Out of office",
        "dashboard.recentCallsCard.recentCalls": "Recent calls",
        "dashboard.salesAnalytics.analytics": "Analytics",
        "email.emailCard.cc": "Cc:",
        "email.channel.whatsapp": "WhatsApp",
        "email.attachment.loading": "Loading PDF…",
        "email.attachment.download": "Download PDF",
        "email.attachment.loadFailed": "This PDF could not be displayed. Close the preview and try again.",
        "email.emailCard.actions": "Message actions",
        "email.emailCard.holdToDelete": "Hold for 2 seconds to delete",
        "email.emailCard.deliveryFailed": "Delivery failed.",
        "email.emailCard.queued": "Queued for sending",
        "email.emailCard.retrying": "Retrying delivery",
        "email.emailCard.failureReason": "Reason: {{reason}}",
        "email.emailCard.failureReasonUnavailable": "No failure reason is available for this email.",
        "email.emailCard.hideQuoted": "Hide quoted",
        "email.emailCard.markAsRead": "Mark as read",
        "email.markAsSpam": "Mark as spam",
        "email.spamFailed": "Moving to spam failed. The message remains in Office. Please try again.",
        "email.emailCard.read": "Read",
        "email.emailCard.reply": "Reply",
        "email.emailCard.showQuoted": "Show quoted",
        "email.emailCard.ticket": "Ticket",
        "email.emailCard.unread": "Unread",
        "email.emailCompose.chooseCc": "Choose CC",
        "email.emailCompose.chooseInvoice": "Choose invoice",
        "email.composer.context": "Message context",
        "email.composer.chooseTenant": "Choose tenant",
        "email.composer.unavailableTenant": "Original tenant",
        "email.composer.unavailableAccount": "Original account",
        "email.composer.noAccount": "No account linked",
        "email.composer.optional": "(optional)",
        "email.composer.accountHelp": "This account links the conversation. The recipient stays as selected.",
        "email.composer.invoiceLinked": "Linked to an invoice",
        "email.composer.replyingTo": "Replying to",
        "email.composer.showOriginal": "Show original message",
        "email.composer.hideOriginal": "Hide original message",
        "email.composer.originalMessage": "Original message",
        "email.composer.reply": "Reply",
        "email.composer.newMessage": "New message",
        "email.composer.addCc": "Add CC",
        "email.composer.loading": "Loading contacts and message context…",
        "email.composer.loadingFailed": "Could not load the composer. Please try again.",
        "email.composer.retry": "Try again",
        "email.composer.sending": "Sending…",
        "email.composer.sendFailed": "Could not send. Your message and attachments have been kept.",
        "email.composer.ready": "Ready to send",
        "email.composer.queued": "Your message has been queued for sending.",
        "email.composer.mailboxes": "Mailboxes",
        "email.composer.recipientPlaceholder": "Search a name or enter an email address",
        "email.composer.noContacts": "No matching contacts",
        "email.composer.useAddress": "Use {{address}}",
        "email.composer.attachments": "Attachments",
        "email.composer.addAttachment": "Add attachment",
        "email.composer.addInvoice": "Add invoice",
        "email.composer.dropAttachments": "Drop files here to attach them.",
        "email.composer.preparingAttachment": "Preparing PDF…",
        "email.composer.attachmentFailed": "Could not prepare this attachment. Remove it and try again.",
        "email.composer.removeAttachment": "Remove {{name}}",
        "email.composer.loadingInvoices": "Loading invoices…",
        "email.composer.invoicesFailed": "Could not load invoices.",
        "email.composer.noInvoices": "No invoices available for this account and tenant.",
        "email.composer.recipientRequired": "Choose a recipient to send.",
        "email.composer.recipientInvalid": "Enter a valid email address for the recipient.",
        "email.composer.ccInvalid": "Check the email addresses in CC.",
        "email.composer.tenantRequired": "Choose a tenant in the message context.",
        "email.composer.attachmentsReading": "Please wait until all attachments are ready.",
        "email.composer.attachmentsFailed": "Remove the failed attachment and add it again.",
        "email.composer.messageRequired": "Enter a message to send.",
        "email.composer.clearRecipients": "Clear recipients",
        "email.composer.contactResults": "{{count}} matching contacts.",
        "email.composer.menuGuidance": "Use the arrow keys to choose a contact. Press Enter to select and Escape to close.",
        "email.composer.inputGuidance": "Type to search or enter an email address. Backspace removes the selected recipient.",
        "email.composer.recipientsCleared": "Recipients cleared.",
        "email.composer.recipientRemoved": "{{address}} removed.",
        "email.composer.recipientSelected": "{{address}} selected.",
        "email.composer.removeRecipient": "Remove {{address}}",
        "email.emailInbox.loadingOlder": "Loading older emails",
        "email.emailInbox.searching": "Searching emails…",
        "email.emailInbox.resultsUntil": "These are the results back to {{date}}",
        "email.emailInbox.searchFailed": "Email search failed. Results found so far are retained.",
        "email.emailInbox.retrySearch": "Retry search",
        "email.emailInbox.searchFurther": "Search further",
        "email.emailInbox.noSearchResults": "No emails found.",
        "email.emailInbox.selected": "selected",
        "email.emailSideBar.inbox": "Inbox",
        "email.emailSideBar.labels": "Labels",
        "email.emailSideBar.sent": "Sent",
        "email.emailSideBar.starred": "Starred",
        "email.emailView.emails": "Emails",
        "email.unreadEmailCard.noUnreadConversations": "No unread conversations.",
        "email.unreadEmailCard.unreadConversations": "Unread conversations",
        "expenses.expenseAddButton.cancelAddingExpense": "Cancel adding expense",
        "expenses.expenseAddButton.chooseTenant": "Choose tenant…",
        "expenses.expenseAddButton.continue": "Continue",
        "expenses.expenseAddForm.addNewExpense": "Add new expense",
        "expenses.expenseAddForm.orChooseExistingSupplier": "Or choose existing supplier:",
        "expenses.expenseAddForm.supplierVatNumber": "Supplier VAT number",
        "expenses.expenseDetail.allExpensesToName": "All expenses to {{name}}",
        "expenses.expenseDetail.allExtractedData": "All extracted data",
        "expenses.expenseDetail.acceptMatch": "Attach and apply",
        "expenses.expenseDetail.applyOcr": "Apply OCR",
        "expenses.expenseDetail.applyOcrFailed": "The selected OCR values could not be saved. Please try again.",
        "expenses.expenseDetail.attachments": "Attachments",
        "expenses.expenseDetail.changesToApply": "Changes that will be applied",
        "expenses.expenseDetail.chooseOcrFields": "Choose the values to apply",
        "expenses.expenseDetail.confidence": "Confidence",
        "expenses.expenseDetail.confirmApplyOcr": "Confirm and apply",
        "expenses.expenseDetail.currentValue": "Current value",
        "expenses.expenseDetail.deleteAttachment": "Delete attachment",
        "expenses.expenseDetail.deleteAttachmentFailed": "The attachment could not be deleted. Please try again.",
        "expenses.expenseDetail.deleteAttachmentName": "Delete {{name}}",
        "expenses.expenseDetail.evidence": "Evidence",
        "expenses.expenseDetail.extractedValue": "Extracted value",
        "expenses.expenseDetail.loadAttachmentsFailed": "The receipts and attachments could not be loaded. Please try again.",
        "expenses.expenseDetail.invoiceMatches": "Suggested invoice matches",
        "expenses.expenseDetail.match": "match",
        "expenses.expenseDetail.noAttachments": "No receipts or attachments have been added yet.",
        "expenses.expenseDetail.openInNewTab": "Open in new tab",
        "expenses.expenseDetail.ocrStatus": "OCR: {{status}}",
        "expenses.expenseDetail.ocrField": "Field",
        "expenses.expenseDetail.ocrFieldIban": "IBAN",
        "expenses.expenseDetail.ocrFieldInvoiceDate": "Invoice date",
        "expenses.expenseDetail.ocrFieldInvoiceNumber": "Invoice number",
        "expenses.expenseDetail.ocrFieldKvkNumber": "Chamber of Commerce number",
        "expenses.expenseDetail.ocrFieldSupplierEmail": "Supplier email",
        "expenses.expenseDetail.ocrFieldSupplierName": "Supplier name",
        "expenses.expenseDetail.ocrFieldTax": "VAT amount",
        "expenses.expenseDetail.ocrFieldTotal": "Total amount",
        "expenses.expenseDetail.ocrFieldVatNumber": "VAT number",
        "expenses.expenseDetail.ocrReviewTitle": "Review OCR — {{name}}",
        "expenses.expenseDetail.ocrWarnings": "OCR warnings",
        "expenses.expenseDetail.noOcrChangesToApply": "No extracted values meet the rules for automatic application.",
        "expenses.expenseDetail.noOcrFieldsSelected": "Select one or more values below. Nothing will change until you apply the selection.",
        "expenses.expenseDetail.ocrFieldsSelected": "{{count}} value(s) selected. Only these values will be changed.",
        "expenses.expenseDetail.applySelectedOcr": "Apply selected ({{count}})",
        "expenses.expenseDetail.selectOcrField": "Apply {{field}}",
        "expenses.expenseDetail.receiptsAndAttachments": "Receipts and attachments",
        "expenses.expenseDetail.supplierName": "Supplier name",
        "expenses.expenseDetail.supplierVat": "Supplier VAT",
        "expenses.expenseDetail.uploadAttachmentFailed": "The attachment could not be uploaded. Please try again.",
        "expenses.expenseDetail.uploadReceipt": "Add a receipt or another attachment",
        "expenses.expenseDetail.reviewOcr": "Review OCR",
        "expenses.expenseDetail.taxLines": "VAT lines",
        "expenses.expenseDetail.viewAttachment": "View",
        "expenses.expenseDetail.viewAttachmentFailed": "The attachment could not be opened. Please try again.",
        "expenses.expenseDetail.viewAttachmentName": "View {{name}}",
        "expenses.expenseEditForm.editExpense": "Edit expense",
        "expenses.expenseEditForm.saveEdit": "Save edit",
        "expenses.expenseRowSupplier.currentExpense": "Current expense",
        "expenses.expenses.expenseOverview": "Expense overview",
        "expenses.expenses.expensesSuppliersAndLedgerAllocation": "Expenses, suppliers and ledger allocation.",
        "expenses.expenses.noExpensesFound": "No expenses found.",
        "expenses.expenses.searchExpenseOrSupplier": "Search expense or supplier…",
        "expenses.expenses.searchExpenses": "Search expenses",
        "expenses.expenseSuggestedEmails.onlyConversationsWithAttachmentsAreShown": "Only conversations with attachments are shown",
        "expenses.expenseSuggestedEmails.suggestedConversations": "Suggested conversations",
        "expenses.supplierDetail.alternativeNames": "Alternative names",
        "expenses.supplierDetail.editSupplier": "Edit supplier",
        "expenses.supplierDetail.linkToExistingSupplier": "Link to existing supplier",
        "expenses.supplierDetail.saveSupplier": "Save supplier",
        "expenses.supplierDetail.saving": "Saving...",
        "expenses.supplierDetail.supplierCouldNotBeSaved": "Supplier could not be saved",
        "expenses.supplierDetail.supplierNotFound": "Supplier not found.",
        "expenses.supplierDetail.supplierSaved": "Supplier saved",
        "expenses.supplierDetail.totalAllTime": "Total all time",
        "expenses.supplierDetail.totalThisQuarter": "Total this quarter",
        "expenses.supplierDetail.totalThisYear": "Total this year",
        "expenses.supplierDetail.transactions": "Transactions",
        "expenses.supplierDetail.vatThisQuarter": "VAT this quarter",
        "expenses.supplierDetail.vatThisYear": "VAT this year",
        "invoice.invoiceAddButton.chooseACustomer": "Choose a customer",
        "invoice.invoiceAddButton.chooseACustomer.e590cbb": "Choose a customer.",
        "invoice.invoiceAddButton.createInvoice": "Create invoice",
        "invoice.invoiceAddButton.createQuote": "Create quote",
        "invoice.invoiceAddButton.newInvoiceOrQuote": "New invoice or quote",
        "invoice.invoiceAddButton.newInvoiceQuote": "New invoice / quote",
        "invoice.invoiceAddButton.paymentDetailsAlwaysComeFromTheTenant": "Payment details always come from the tenant.",
        "invoice.invoiceAddButton.tenantDefault": "Tenant (default)",
        "invoice.invoiceContentAddCard.addContent": "Add line",
        "invoice.invoiceContentAddCard.instructions": "Select a service or add a custom line",
        "invoice.invoiceContentAddCard.service": "Service",
        "invoice.invoiceContentAddCard.noTypeFound": "No type found",
        "invoice.invoiceContentAddCard.searchOrEnterAType": "Search or enter a type...",
        "invoice.invoiceContentAddCard.typeNameAmountPriceAndAVatRateBetween0PercentageAnd100PercentageAreMandatory": "Type, name, amount, price and a VAT rate between 0% and 100% are mandatory",
        "invoice.invoiceContentAddCard.useValue": "Use \"{{value}}\"",
        "invoice.invoiceContentAddCard.vatPercentage": "VAT %",
        "invoice.invoiceContentCard.item": "Item",
        "invoice.invoiceContentCard.reverseCharged": "Reverse charged",
        "invoice.invoiceContentCard.subtotal": "Subtotal",
        "invoice.invoiceContentCard.vatReverseCharged": "VAT reverse charged",
        "invoice.invoiceEmails.sentMailsCouldNotBeLoaded": "Sent emails could not be loaded.",
        "invoice.invoiceEmails.sentMails": "Sent mails",
        "invoice.invoiceInfoSummaryCard.download": "Download",
        "invoice.invoiceInfoSummaryCard.invoiceNumber": "Invoice number",
        "invoice.invoiceInfoSummaryCard.link": "link",
        "invoice.invoiceInfoSummaryCard.payLink": "Pay-link",
        "invoice.invoiceInfoSummaryCard.paymentDeadline": "Payment deadline",
        "invoice.invoiceInfoSummaryCard.pdfDownload": "Pdf download",
        "invoice.invoiceRowIndex.deadline": "Deadline",
        "invoice.invoiceRowIndex.invoice": "invoice",
        "invoice.invoiceRowIndex.paymentTerm": "Payment term",
        "invoice.invoiceRowIndex.viewName": "View {{name}}",
        "invoice.invoices.drafts": "Drafts",
        "invoice.invoices.invoiceOverview": "Invoice overview",
        "invoice.invoices.invoicesQuotesAndPaymentStatus": "Invoices, quotes and payment status.",
        "invoice.invoices.noInvoicesFound": "No invoices found.",
        "invoice.invoices.quotes": "Quotes",
        "invoice.invoices.searchInvoiceOrAccount": "Search invoice or account…",
        "invoice.invoices.searchInvoices": "Search invoices",
        "invoice.invoices.unpaid": "Unpaid",
        "invoice.invoiceStatusCard.addManualPayment": "Add manual payment",
        "invoice.invoiceStatusCard.convertToInvoice": "Convert to invoice",
        "invoice.invoiceStatusCard.convertToQuote": "Convert to quote",
        "invoice.invoiceStatusCard.deleteDraft": "Delete draft",
        "invoice.invoiceStatusCard.deleteQuote": "Delete quote",
        "invoice.invoiceStatusCard.enterAnAmountGreaterThanZero": "Enter an amount greater than zero.",
        "invoice.invoiceStatusCard.enterAPaymentDate": "Enter a payment date.",
        "invoice.invoiceStatusCard.finalizeInvoice": "Finalize invoice",
        "invoice.invoiceStatusCard.ibanOptional": "IBAN (optional)",
        "invoice.invoiceStatusCard.notPaid": "Not paid",
        "invoice.invoiceStatusCard.savePayment": "Save payment",
        "invoice.invoiceStatusCard.thePaymentCouldNotBeAdded": "The payment could not be added.",
        "persons.personDetail.accountRelationLinked": "Account relation linked.",
        "persons.personDetail.accountRelationRemoved": "Account relation removed.",
        "persons.personDetail.addAccountRelation": "Add account relation",
        "persons.personDetail.authentication": "Authentication",
        "persons.personDetail.authenticationCreatedThePasswordWasSentToEmail": "Authentication created. The password was sent to {{email}}.",
        "persons.personDetail.backToPersons": "Back to persons",
        "persons.personDetail.call": "Call",
        "persons.personDetail.couldNotCreateAuthentication": "Could not create authentication.",
        "persons.personDetail.couldNotLinkThisAccount": "Could not link this account.",
        "persons.personDetail.couldNotLoadPerson": "Could not load this person's details. Please try again.",
        "persons.persons.couldNotLoadPersons": "Could not load the persons. Please try again.",
        "persons.personDetail.couldNotRemoveThisRelation": "Could not remove this relation.",
        "persons.personDetail.couldNotSaveThisPerson": "Could not save this person.",
        "persons.personDetail.customerPortalLanguage": "Customer portal language",
        "persons.personDetail.emailAddressVerified": "Email address verified",
        "persons.personDetail.emailAddressVerifiedHelp": "Allows this person to create hosted DNS zones in Sheepname.",
        "persons.personDetail.firstNameIsRequired": "First name is required.",
        "persons.personDetail.loadingPerson": "Loading person...",
        "persons.personDetail.loadingRelations": "Loading relations…",
        "persons.personDetail.noAccountRelationsLinkedYet": "No account relations linked yet.",
        "persons.personDetail.noAuthentication": "No authentication",
        "persons.personDetail.noMatchingAccounts": "No matching accounts",
        "persons.personDetail.noTitleSpecified": "No title specified",
        "persons.personDetail.personDetailsAndAccountRelations": "Person details and account relations.",
        "persons.personDetail.personNotFound": "Person not found",
        "persons.personDetail.personSaved": "Person saved.",
        "persons.personDetail.reset": "Reset",
        "persons.personDetail.titleFunction": "Title / function",
        "persons.persons.loadingPersons": "Loading persons...",
        "persons.persons.manageContactsAndTheirLinkedRelations": "Manage contacts and their linked relations.",
        "persons.persons.noPersonsFound": "No persons found.",
        "persons.persons.noRelations": "No relations",
        "persons.persons.personOverview": "Person overview",
        "persons.persons.searchByNameEmailPhoneOrRelation": "Search by name, email, phone or relation...",
        "persons.persons.searchPersons": "Search persons",
        "persons.persons.statusUnavailable": "Status unavailable",
        "persons.persons.theAuthenticationServiceReturnedNoStatus": "The authentication service returned no status",
        "persons.persons.withMfa": "With MFA",
        "persons.persons.withoutLogin": "Without login",
        "persons.persons.withoutMfa": "Without MFA",
        "projects.contractTemplateEditor.contractTemplates": "Contract templates",
        "projects.contractTemplateEditor.deleteField": "Delete field",
        "projects.contractTemplateEditor.emailAfterSigning": "Email after signing",
        "projects.contractTemplateEditor.fieldSettings": "Field settings",
        "projects.contractTemplateEditor.fontSize": "Font size",
        "projects.contractTemplateEditor.heightPercentage": "Height %",
        "projects.contractTemplateEditor.keepFields": "Keep fields",
        "projects.contractTemplateEditor.loadingTemplateForTheSelectedTenant": "Loading template for the selected tenant…",
        "projects.contractTemplateEditor.manageTheWorkerContractAndResponsibleContractSeparatelyForEachWorkerProjectRelationship": "Manage the worker contract and responsible contract separately for each worker-project relationship.",
        "projects.contractTemplateEditor.next": "Next",
        "projects.contractTemplateEditor.pagePageCount": "Page {{page}} / {{count}}",
        "projects.contractTemplateEditor.pdfFilename": "PDF filename",
        "projects.contractTemplateEditor.prefillData": "Prefill data",
        "projects.contractTemplateEditor.prefillField": "Prefill field",
        "projects.contractTemplateEditor.previous": "Previous",
        "projects.contractTemplateEditor.preservedFieldsKeepTheirPageAndPosition": "Preserved fields keep the same page and position. Check their placement after upload.",
        "projects.contractTemplateEditor.removeFields": "Remove fields",
        "projects.contractTemplateEditor.repeatOnEveryPage": "Repeat on every page",
        "projects.contractTemplateEditor.replacePdf": "Replace PDF",
        "projects.contractTemplateEditor.replacePdfFieldsQuestion": "This template already contains fields. Would you like to keep them on the new PDF?",
        "projects.contractTemplateEditor.saveTemplate": "Save template",
        "projects.contractTemplateEditor.selectAFieldOnThePdfToConfigureIt": "Select a field on the PDF to configure it.",
        "projects.contractTemplateEditor.signatureField": "Signature field",
        "projects.contractTemplateEditor.signatureCopy": "Signature copy",
        "projects.contractTemplateEditor.signatureCopyField": "Signature copy field",
        "projects.contractTemplateEditor.templateFor": "Template for",
        "projects.contractTemplateEditor.templateName": "Template name",
        "projects.contractTemplateEditor.uploadPdf": "Upload PDF",
        "projects.contractTemplateEditor.uploadTheBaseContractAsAPdf": "Upload the base contract as a PDF",
        "projects.contractTemplateEditor.widthPercentage": "Width %",
        "projects.contractTemplateEditor.workerSignature": "Worker signature",
        "projects.contractTemplateEditor.youCanThenPlaceFieldsDirectlyOnThePage": "You can then place fields directly on the page.",
        "projects.projectBudgetProgress.costsWithoutAConfiguredBudget": "Costs without a configured budget",
        "projects.projectBudgetProgress.invoicedCosts": "Invoiced costs",
        "projects.projectBudgetProgress.noBudgetUsedYet": "No budget used yet",
        "projects.projectBudgetProgress.overBudget": "over budget",
        "projects.projectBudgetProgress.percentagePercentageOfTheBudgetUsed": "{{percentage}}% of the budget used",
        "projects.projectCreate.budgetEur": "Budget (EUR)",
        "projects.projectCreate.chooseATenant": "Choose a tenant…",
        "projects.projectCreate.createProject": "Create project",
        "projects.projectCreate.creating": "Creating…",
        "projects.projectCreate.endDate": "End date",
        "projects.projectCreate.endDateMustBeOnOrAfterTheStartDate": "End date must be on or after the start date.",
        "projects.projectCreate.enterAValidNonNegativeBudget": "Enter a valid non-negative budget.",
        "projects.projectCreate.enterTheAmountInEurosItIsStoredAccuratelyInCents": "Enter the amount in euros; it is stored accurately in cents.",
        "projects.projectCreate.forExampleOfficeRenovation": "For example: Office renovation",
        "projects.projectCreate.projectCouldNotBeCreated": "Project could not be created.",
        "projects.projectCreate.projectDetails": "Project details",
        "projects.projectCreate.selectWorkersAndProjectResponsibles": "Select workers and project responsibles.",
        "projects.projectCreate.startDate": "Start date",
        "projects.projectCreate.tenantNameStartDateAndEndDateAreRequired": "Tenant, name, start date and end date are required.",
        "projects.projectCreate.tenantsOrAccountsCouldNotBeLoaded": "Tenants or accounts could not be loaded.",
        "projects.projectCreate.tenantsCouldNotBeLoaded": "Tenants could not be loaded.",
        "projects.projectDetail.accountDefault": "Account default:",
        "projects.projectDetail.addToProject": "Add to project",
        "projects.projectDetail.addWorker": "Add worker",
        "projects.projectDetail.addressSearchFailed": "The address search is temporarily unavailable.",
        "projects.projectDetail.addressSearchPlaceholder": "Street, number, city or postcode",
        "projects.projectDetail.agreement": "Agreement",
        "projects.projectDetail.budgetEuro": "Budget (€)",
        "projects.projectDetail.cancel": "Cancel",
        "projects.projectDetail.checkTheProjectNameAndProjectPeriod": "Check the project name and project period.",
        "projects.projectDetail.chooseAnAccount": "Choose an account…",
        "projects.projectDetail.clear": "Clear",
        "projects.projectDetail.clickTheMapOrDragThePin": "Click the map or drag the pin.",
        "projects.projectDetail.contract": "Contract",
        "projects.projectDetail.customHourlyRate": "Custom hourly rate",
        "projects.projectDetail.customPlatformFee": "Custom platform fee",
        "projects.projectDetail.customPlatformFeeType": "Custom platform fee type",
        "projects.projectDetail.customRates": "Custom rates",
        "projects.projectDetail.deleteThisDocument": "Delete this document?",
        "projects.projectDetail.documentCouldNotBeDeleted": "Document could not be deleted.",
        "projects.projectDetail.documentCouldNotBeOpened": "Document could not be opened.",
        "projects.projectDetail.documentCouldNotBeUploaded": "Document could not be uploaded.",
        "projects.projectDetail.documentUploaded": "Document uploaded.",
        "projects.projectDetail.edit": "Edit",
        "projects.projectDetail.end": "End",
        "projects.projectDetail.endDate": "End date",
        "projects.projectDetail.fixedAmountPerHour": "Fixed amount per hour",
        "projects.projectDetail.forExampleEngineerOrProjectLead": "For example: engineer or project lead",
        "projects.projectDetail.noContractsOrAgreementsYet": "No contracts or agreements yet.",
        "projects.projectDetail.noAddressesFound": "No matching addresses found.",
        "projects.projectDetail.notAssignedYet": "Not assigned yet",
        "projects.projectDetail.noWorkersLinkedYet": "No workers linked yet.",
        "projects.projectDetail.onlyPdfDocumentsAreAllowed": "Only PDF documents are allowed.",
        "projects.projectDetail.other": "Other",
        "projects.projectDetail.percentageOfHourlyRate": "Percentage of hourly rate",
        "projects.projectDetail.percentagePercentageOfTheDurationElapsed": "{{percentage}}% of the duration elapsed",
        "projects.projectDetail.perHour": "per hour",
        "projects.projectDetail.projectCompleted": "Project completed",
        "projects.projectDetail.projectCouldNotBeLoaded": "Project could not be loaded.",
        "projects.projectDetail.projectCouldNotBeSaved": "Project could not be saved.",
        "projects.projectDetail.projectDetailsSaved": "Project details saved.",
        "projects.projectDetail.projectHasNotStartedYet": "Project has not started yet",
        "projects.projectDetail.projectLocationCouldNotBeSaved": "Project location could not be saved.",
        "projects.projectDetail.projects": "Projects",
        "projects.projectDetail.projectSpecificRoleAvailableInContractTemplatesAsField": "Project-specific role; available in contract templates as {{field}}.",
        "projects.projectDetail.radiusAroundThePin": "Radius around the pin",
        "projects.projectDetail.removeWorkerProjectRelation": "Remove from project",
        "projects.projectDetail.removeWorkerProjectRelationConfirm": "Remove {{name}} from this project? The related contracts and registered hours will also be permanently deleted.",
        "projects.projectDetail.removeWorkerProjectRelationFor": "Remove {{name}} from this project",
        "projects.projectDetail.responsibleAccount": "Responsible account",
        "projects.projectDetail.responsibleAccountCouldNotBeSaved": "Responsible account could not be saved.",
        "projects.projectDetail.responsibleAccountSaved": "Responsible account saved.",
        "projects.projectDetail.saveLocation": "Save location",
        "projects.projectDetail.searchAddress": "Search by address",
        "projects.projectDetail.start": "Start",
        "projects.projectDetail.startDate": "Start date",
        "projects.projectDetail.theHoursOverviewCouldNotBeRefreshed": "The hours overview could not be refreshed.",
        "projects.projectDetail.ultimatelyResponsibleForThisProject": "Ultimately responsible for this project.",
        "projects.projectDetail.visibleInternallyOnlyWithoutAnOverrideTheAccountRatesApply": "Visible internally only. Without an override, the account rates apply.",
        "projects.projectDetail.workerCouldNotBeAdded": "Worker could not be added.",
        "projects.projectDetail.noWorkerRoleAssigned": "No role assigned",
        "projects.projectDetail.workerProjectSettingsCouldNotBeSaved": "Worker project settings could not be saved.",
        "projects.projectDetail.workerProjectSettingsSaved": "Worker project settings saved.",
        "projects.projectDetail.workerProjectRelationCouldNotBeRemoved": "The worker-project relation could not be removed.",
        "projects.projectDetail.workerProjectRelationRemoved": "{{name}} was removed from the project together with the related contracts.",
        "projects.projectDetail.workerRole": "worker role",
        "projects.projectDetail.workerRoleRequiredForContracts": "Required. This role is immediately included in generated contracts.",
        "projects.projectHoursOverview.allWorkersRemainVisibleEvenWhenTheyHaveNotEnteredAnythingThisWeek": "All workers remain visible, even when they have not entered anything this week.",
        "projects.projectHoursOverview.approved": "Approved",
        "projects.projectHoursOverview.hoursEntered": "Hours entered",
        "projects.projectHoursOverview.nextWeek": "Next week",
        "projects.projectHoursOverview.noHours": "No hours",
        "projects.projectHoursOverview.noHoursEntered": "No hours entered",
        "projects.projectHoursOverview.notStartedYet": "Not started yet",
        "projects.projectHoursOverview.noWorkersLinkedYet": "No workers linked yet.",
        "projects.projectHoursOverview.outsideProjectPeriod": "Outside project period",
        "projects.projectHoursOverview.outsideTheProjectPeriod": "Outside the project period",
        "projects.projectHoursOverview.pending": "pending",
        "projects.projectHoursOverview.pendingApproval": "Pending approval",
        "projects.projectHoursOverview.previousWeek": "Previous week",
        "projects.projectHoursOverview.refresh": "Refresh",
        "projects.projectHoursOverview.thisWeek": "This week",
        "projects.projectHoursOverview.thisWeekHasNotStartedYet": "This week has not started yet",
        "projects.projectHoursOverview.total": "Total",
        "projects.projectHoursOverview.totalThisWeek": "total this week",
        "projects.projectInvoicesCard.noHoursHaveBeenInvoicedForThisProjectYet": "No hours have been invoiced for this project yet.",
        "projects.projectPayoutOverview.checkAmount": "Check amount",
        "projects.projectPayoutOverview.currencyNotSupported": "{{count}} payout(s) use a currency other than EUR and cannot be included in a SEPA payment file.",
        "projects.projectPayoutOverview.downloadFailed": "The payment file could not be downloaded.",
        "projects.projectPayoutOverview.downloadPaymentFile": "Download payment file",
        "projects.projectPayoutOverview.draftInvoices": "{{count}} payout(s) still contain a draft invoice.",
        "projects.projectPayoutOverview.excluded": "Excluded",
        "projects.projectPayoutOverview.explanation": "The SEPA file combines all projects in the selected week and contains one bank transfer per worker invoice. The platform fee is deducted and the worker invoice name is used as the payment reference.",
        "projects.projectPayoutOverview.feeMissing": "Fee missing",
        "projects.projectPayoutOverview.gross": "Gross",
        "projects.projectPayoutOverview.hoursPending": "Hours pending",
        "projects.projectPayoutOverview.ibanMissing": "IBAN missing",
        "projects.projectPayoutOverview.invalidNetAmount": "{{count}} payout(s) have a net amount of zero or less.",
        "projects.projectPayoutOverview.invoiceWeekMismatch": "The following invoice names do not match selected week {{week}}:",
        "projects.projectPayoutOverview.includePayment": "Include payment {{payment}}",
        "projects.projectPayoutOverview.includePaymentColumn": "Include in payment file",
        "projects.projectPayoutOverview.lastWeek": "Last week",
        "projects.projectPayoutOverview.markAsPaid": "Mark as paid",
        "projects.projectPayoutOverview.markPaidFailed": "Not all selected invoices could be marked as paid. Saved payments have been kept; try again to finish the remaining invoices.",
        "projects.projectPayoutOverview.missingPlatformFee": "{{count}} worker invoice(s) do not have a matching platform-fee invoice.",
        "projects.projectPayoutOverview.multipleTenants": "Projects from different tenants cannot be combined in one payment file.",
        "projects.projectPayoutOverview.net": "Net",
        "projects.projectPayoutOverview.netToPay": "net to pay",
        "projects.projectPayoutOverview.nextWeek": "Next week",
        "projects.projectPayoutOverview.noInvoice": "No invoice",
        "projects.projectPayoutOverview.noPayments": "No project invoices or pending hours were found for this week.",
        "projects.projectPayoutOverview.notEntered": "Not entered",
        "projects.projectPayoutOverview.pendingHours": "{{count}} hour entry/entries are still pending approval.",
        "projects.projectPayoutOverview.plannedFor": "Planned payment: {{date}}",
        "projects.projectPayoutOverview.platformFee": "Platform fee",
        "projects.projectPayoutOverview.previousWeek": "Previous week",
        "projects.projectPayoutOverview.ready": "{{count}} payment(s) are ready for the SEPA payment file.",
        "projects.projectPayoutOverview.readyForPayment": "Ready for payment",
        "projects.projectPayoutOverview.selectAllPayments": "All payments",
        "projects.projectPayoutOverview.tenantIbanMissing": "Enter a valid payout IBAN in the tenant billing settings before downloading a payment file.",
        "projects.projectPayoutOverview.title": "Weekly payment overview for all projects",
        "projects.projectPayoutOverview.weekLabel": "Week {{week}}, {{year}}",
        "projects.projectPayoutOverview.workerInvoice": "Worker invoice",
        "projects.projectPayoutOverview.workerPaidFeeUnpaid": "The worker invoice is paid, but the platform-fee invoice is still unpaid.",
        "projects.projectPayoutOverview.workersWithInvalidIban": "{{count}} worker(s) have an invalid IBAN: {{workers}}.",
        "projects.projectPayoutOverview.workersWithoutIban": "{{count}} worker(s) have not entered an IBAN: {{workers}}.",
        "projects.projectPayments.backToProjects": "Back to projects",
        "projects.projectPayments.description": "Create one weekly payment file for worker invoices across all projects.",
        "projects.projectPayments.loadFailed": "The weekly payment overview could not be loaded.",
        "projects.projectPayments.loading": "Loading weekly payments…",
        "projects.projectPayments.title": "Weekly payments",
        "projects.projects.active": "Active",
        "projects.projects.completed": "Completed",
        "projects.projects.contractTemplate": "Contract template",
        "projects.projects.loadingProjects": "Loading projects…",
        "projects.projects.noProjectsFound": "No projects found.",
        "projects.projects.noWorkers": "No workers",
        "projects.projects.projectOverview": "Project overview",
        "projects.projects.projectsWorkersAndContractStatus": "Projects, workers and contract status.",
        "projects.projects.searchProjects": "Search projects",
        "projects.projects.searchProjects.1334959": "Search projects…",
        "projects.projects.upcoming": "Upcoming",
        "projects.projects.weeklyPayments": "Weekly payments",
        "services.addServiceForm.addingServiceHasFailed": "Adding service has failed",
        "services.checksStatusCard.checksStatus": "Checks status",
        "services.serviceDetailPage.editService": "Edit service",
        "services.serviceDetailPage.liveGraphic": "Live graphic",
        "services.serviceEditForm.savingServiceHasFailed": "Saving service has failed",
        "services.serviceStatusBanner.allSystemsOperational": "All systems operational",
        "services.serviceStatusBanner.minorServiceDisruptions": "Minor service disruptions",
        "taxes.taxes.expensesEx": "Expenses ex",
        "taxes.taxes.expensesIncl": "Expenses incl",
        "taxes.taxes.noExpensesFound": "No expenses found",
        "taxes.taxes.noYearsFound": "No years found",
        "taxes.taxes.perGrootboekregel": "per grootboekregel",
        "taxes.taxes.perQuarter": "per quarter",
        "taxes.taxes.quarter": "Quarter",
        "taxes.taxes.revenueEx": "Revenue ex",
        "taxes.taxes.revenueIncl": "Revenue incl",
        "taxes.taxes.totalIncl": "Total incl",
        "taxes.taxes.vatExpenses": "VAT expenses",
        "taxes.taxes.vatRevenue": "VAT revenue",
        "taxes.taxes.year": "Year",
        "tenants.index.addNewTenant": "Add new tenant",
        "tenants.tenantAddForm.addingTenancyHasFailedCheckDataAndTryAgain": "Adding tenancy has failed, check data and try again",
        "tenants.tenantAddForm.addTenant": "Add Tenant",
        "tenants.tenantAddForm.nameCanTBeEmpty": "Name can't be empty",
        "tenants.tenantAttachmentRequirements.add": "Add",
        "tenants.tenantAttachmentRequirements.attachmentRequirementsCouldNotBeLoaded": "Attachment requirements could not be loaded.",
        "tenants.tenantAttachmentRequirements.attachmentRequirementsSaved": "Attachment requirements saved.",
        "tenants.tenantAttachmentRequirements.attachmentTypeDescription": "Attachment type description",
        "tenants.tenantAttachmentRequirements.attachmentTypeName": "Attachment type name",
        "tenants.tenantAttachmentRequirements.chooseWhichApprovedDocumentsWorkersNeedBeforeTheyCanEnterHours": "Choose which approved documents workers need before they can enter hours.",
        "tenants.tenantAttachmentRequirements.expiryDateRequired": "Expiry date required",
        "tenants.tenantAttachmentRequirements.forExampleChamberOfCommerceExtract": "For example: Chamber of Commerce extract",
        "tenants.tenantAttachmentRequirements.instructionsShownInTheCustomerPortal": "Instructions shown in the customer portal",
        "tenants.tenantAttachmentRequirements.inputMethod": "How the worker provides this document",
        "tenants.tenantAttachmentRequirements.uploadDocument": "Upload a document",
        "tenants.tenantAttachmentRequirements.completeForm": "Complete a form",
        "tenants.tenantAttachmentRequirements.declarations": "Declarations",
        "tenants.tenantAttachmentRequirements.oneDeclarationPerLine": "One declaration per line",
        "tenants.tenantAttachmentRequirements.noDocumentTypesConfigured": "No document types configured.",
        "tenants.tenantAttachmentRequirements.removeAttachmentType": "Remove attachment type",
        "tenants.tenantAttachmentRequirements.requiredForHourRegistration": "Required for hour registration",
        "tenants.tenantAttachmentRequirements.saveRequirements": "Save requirements",
        "tenants.tenantDetail.manageBillingRequirementsAccessAndActivityForThisTenant": "Manage billing, requirements, access and activity for this tenant.",
        "tenants.tenantInvoiceSettings.invoiceNameTemplateCouldNotBeSaved": "Invoice name template could not be saved.",
        "tenants.tenantInvoiceSettings.invoiceNameTemplateSaved": "Invoice name template saved.",
        "tenants.tenantInvoiceSettings.invoiceNumberPreview": "Invoice number preview",
        "tenants.tenantInvoiceSettings.invoicePrefix": "Invoice prefix",
        "tenants.tenantInvoiceSettings.invoicePrefixHelp": "Use letters and numbers only. Final invoice numbers always end in a four-digit sequence.",
        "tenants.tenantInvoiceSettings.invoiceReminders": "Send invoice reminder emails",
        "tenants.tenantInvoiceSettings.invoiceRemindersHelp": "Turn this off to stop all automatic reminder and collection emails for this tenant. Pay-when-paid invoices never receive reminders.",
        "tenants.tenantInvoiceSettings.nameTemplate": "Name template",
        "tenants.tenantInvoiceSettings.placeholders": "Placeholders",
        "tenants.tenantInvoiceSettings.presets": "Presets",
        "tenants.tenantInvoiceSettings.preview": "Preview",
        "tenants.tenantInvoiceSettings.settingsCouldNotBeSaved": "Invoice settings could not be saved.",
        "tenants.tenantInvoiceSettings.settingsSaved": "Invoice settings saved.",
        "tenants.tenantInvoiceSettings.weekProject": "Week + project",
        "tenants.tenantInvoiceSettings.withoutAProjectNameAProjectTemplateAutomaticallyFallsBackToYearMonth": "Without a project name, a project template automatically falls back to year-month.",
        "tenants.tenantInvoiceSettings.yearMonth": "Year-month",
        "tenants.tenantURLSettings.account": "Account portal URL",
        "tenants.tenantURLSettings.defaultHelp": "An empty account portal URL uses the Galactic Group default. The payment portal URL may be left empty.",
        "tenants.tenantURLSettings.help": "These base URLs are used for account and payment links in automated emails and invoices.",
        "tenants.tenantURLSettings.payment": "Payment portal URL",
        "tenants.tenantURLSettings.saveFailed": "Portal URLs could not be saved.",
        "tenants.tenantURLSettings.saved": "Portal URLs saved.",
        "tenants.tenantURLSettings.title": "Portal URLs",
        "tenants.tenantOverviewCard.pushSubscriptions": "Push subscriptions",
        "tenants.tenantPushNotifications.disabledForThisTenant": "Disabled for this tenant",
        "tenants.tenantPushNotifications.enabledForThisTenant": "Enabled for this tenant",
        "tenants.tenantPushNotifications.pushNotificationsCouldNotBeChanged": "Push notifications could not be changed",
        "tenants.tenantTab.noItemFound": "No {{item}} found.",
        "tenants.tenantTab.noRole": "No role",
        "tenants.tenantTab.noTicketsForThisTenant": "No tickets for this tenant.",
        "tenants.tenantTab.showCountMoreItem": "Show {{count}} more {{item}}",
        "tenants.tenantTab.untitledExpense": "Untitled expense",
        "tenants.tenantTab.untitledInvoice": "Untitled invoice",
        "tenants.tenantUsers.noUsersAvailable": "No users available.",
        "user.managedUserForm.accountActivated": "Account activated",
        "user.managedUserForm.aPasswordIsRequiredForANewUser": "A password is required for a new user.",
        "user.managedUserForm.confirmPassword": "Confirm password",
        "user.managedUserForm.leaveBothFieldsEmptyToKeepTheCurrentPassword": "Leave both fields empty to keep the current password.",
        "user.managedUserForm.nameEmailAndRegionAreRequired": "Name, email and region are required.",
        "user.managedUserForm.newPassword": "New password",
        "user.managedUserForm.phoneNumber": "Phone number",
        "user.managedUserForm.selectARegion": "Select a region",
        "user.managedUserForm.thePasswordMustContainAtLeast8Characters": "The password must contain at least 8 characters.",
        "user.managedUserForm.thePasswordsDoNotMatch": "The passwords do not match.",
        "user.managedUserForm.theUserCouldNotBeSaved": "The user could not be saved.",
        "user.userDetail.backToUsers": "Back to users",
        "user.userDetail.device": "Device",
        "user.userDetail.devicesAndSessions": "Devices and sessions",
        "user.userDetail.ipAddress": "IP address",
        "user.userDetail.loadingUser": "Loading user...",
        "user.userDetail.mfaMethod": "MFA method",
        "user.userDetail.mfaStatus": "MFA status",
        "user.userDetail.noActiveSessionsFound": "No active sessions found.",
        "user.userDetail.noBrowserInformationStored": "No browser information stored",
        "user.userDetail.noIpAddressStored": "No IP address stored",
        "user.userDetail.security": "Security",
        "user.userDetail.signedIn": "Signed in",
        "user.userDetail.unknownDevice": "Unknown device",
        "user.userDetail.userNotFound": "User not found",
        "user.userDetail.userSavedSuccessfully": "User saved successfully.",
        "user.userProfile.activatedValue": "Activated: {{value}}",
        "user.userProfile.emailValue": "Email: {{value}}",
        "user.userProfile.no": "No",
        "user.userProfile.phoneValue": "Phone: {{value}}",
        "user.userProfile.regionValue": "Region: {{value}}",
        "user.userProfile.yes": "Yes",
        "user.userProfiles.accessActivationAndRegionalSettings": "Access, activation and regional settings.",
        "user.userProfiles.searchNameEmailOrRegion": "Search name, email or region…",
        "user.userProfiles.searchUsers": "Search users",
        "user.userProfiles.userOverview": "User overview",
        "user.userProfilesTable.access": "Access",
        "user.userProfilesTable.accounts": "accounts",
        "user.userProfilesTable.noUsersFound": "No users found.",
        "accounts.accountAttachmentsCard.approvalFailed": "The document could not be approved.",
        "accounts.accountAttachmentsCard.deleteFailed": "The document could not be deleted.",
        "accounts.accountAttachmentsCard.expirySaveFailed": "The document expiry date could not be saved.",
        "accounts.accountAttachmentsCard.loadFailed": "Documents could not be loaded.",
        "accounts.accountAttachmentsCard.noContent": "The document has no content.",
        "accounts.accountAttachmentsCard.openFailed": "The document could not be opened.",
        "accounts.accountAttachmentsCard.rejectionReasonRequired": "Enter a reason for rejection.",
        "accounts.accountAttachmentsCard.rejectionSaveFailed": "The document rejection could not be saved.",
        "accounts.accountAttachmentsCard.statusApproved": "Approved",
        "accounts.accountAttachmentsCard.statusPending": "Pending",
        "accounts.accountAttachmentsCard.statusRejected": "Rejected",
        "accounts.accountDetailsCards.accountInformation": "Account information",
        "accounts.accountDetailsCards.addressNumber": "Address {{number}}",
        "accounts.accountDetailsCards.bankAccountNumber": "Bank account {{number}}",
        "accounts.accountDetailsCards.billingParameters": "Billing parameters",
        "accounts.accountDetailsCards.chargeLineVatRates": "Charge line VAT rates",
        "accounts.accountDetailsCards.cocNumber": "CoC number",
        "accounts.accountDetailsCards.defaultVatTreatment": "Default VAT treatment",
        "accounts.accountDetailsCards.deleteAddressNumber": "Delete address {{number}}",
        "accounts.accountDetailsCards.deleteBankAccountNumber": "Delete bank account {{number}}",
        "accounts.accountDetailsCards.editSection": "Edit {{section}}",
        "accounts.accountDetailsCards.reverseCharged": "Reverse charged",
        "accounts.accountPersonsCard.lastName": "Last name",
        "accounts.accountRecurringsCard.deleteFailed": "Recurring could not be deleted.",
        "accounts.accountRecurringsCard.deleteNamed": "Delete {{name}}",
        "accounts.accountRecurringsCard.invalidForm": "Enter a name, valid amount, price, VAT rate and invoice interval.",
        "accounts.accountRecurringsCard.loadFailed": "Recurrings could not be loaded.",
        "accounts.accountRecurringsCard.saveFailed": "Recurring could not be saved.",
        "accounts.invoiceIntervalField.disabled": "No automatic invoicing",
        "accounts.invoiceIntervalField.disabledDescription": "Automatic invoicing is disabled.",
        "accounts.invoiceIntervalField.everyDay": "Every day at 09:00",
        "accounts.invoiceIntervalField.everyMonday": "Every Monday at 09:00",
        "accounts.invoiceIntervalField.everyMonth": "First day of every month at 09:00",
        "accounts.invoiceIntervalField.everyQuarter": "First day of every quarter at 09:00",
        "accounts.invoiceIntervalField.everyYear": "Every 1 January at 09:00",
        "accounts.invoiceIntervalField.invalid": "Invalid cron expression.",
        "common.bic": "BIC",
        "common.iban": "IBAN",
        "common.quotes": "Quotes",
        "common.title": "Title",
        "accounts.accountFormCard.saveAccount": "Save account",
        "accounts.accountRecentEmailsCard.recentlySentEmails": "Recently sent emails",
        "common.adminConsole.errors.commandRequired": "Enter a command.",
        "common.adminConsole.errors.commandUsage": "Usage: {{command}} {{resource}} <uuid>",
        "common.adminConsole.errors.invalidUuid": "Invalid UUID.",
        "common.adminConsole.errors.listUsage": "Usage: list {{resource}}s",
        "common.adminConsole.errors.unknownCommand": "Unknown command. Type 'help' for the available commands.",
        "common.adminConsole.errors.unknownResource": "Unknown entity '{{resource}}'. Use projects, accounts, invoices or persons.",
        "common.adminConsole.help.clear": "  clear                                  Clear the console",
        "common.adminConsole.help.delete": "  delete project|account|invoice|person <uuid> Delete one entity",
        "common.adminConsole.help.exit": "  exit                                   Close the console",
        "common.adminConsole.help.get": "  get project|account|invoice|person <uuid>    Show one entity",
        "common.adminConsole.help.heading": "Available commands:",
        "common.adminConsole.help.list": "  list projects|accounts|invoices|persons       Show all entities",
        "common.adminConsole.noId": "(no ID)",
        "common.adminConsole.noName": "(no name)",
        "common.adminConsole.noResourcesFound": "No {{resources}} found.",
        "common.adminConsole.projectDeleted": "Project {{id}} was fully deleted, including worker and responsible relations, hours, contracts and attachments.",
        "common.adminConsole.resourceDeleteFailed": "{{resource}} could not be deleted: {{error}}",
        "common.adminConsole.resourceDeleted": "{{resource}} {{id}} was deleted.",
        "common.adminConsole.resourceGetFailed": "{{resource}} could not be retrieved: {{error}}",
        "common.adminConsole.resourceList": "{{resources}} ({{count}}):\n{{entries}}",
        "common.adminConsole.resourceLoadFailed": "{{resource}} could not be loaded: {{error}}",
        "common.adminConsole.unknownError": "Unknown error",
        "common.adminConsole.welcome": "Office console. Type 'help' for the available commands.",
        "common.account": "Account",
        "common.attach": "Attach",
        "common.cc": "CC",
        "common.cpu": "CPU",
        "common.dashboard": "Dashboard",
        "common.duration.zeroHoursShort": "0h",
        "common.noSubject": "(No subject)",
        "common.pdf": "PDF",
        "common.person": "Person",
        "common.project": "Project",
        "common.theme.darkMode": "Dark mode",
        "common.theme.lightMode": "Light mode",
        "common.ticket": "Ticket",
        "common.totp": "TOTP",
        "common.units.millisecondsShort": "ms",
        "common.units.perSecondShort": "/s",
        "common.usa": "United States",
        "common.actions.checkKvk": "Check CoC",
        "common.actions.checkVat": "Check VAT",
        "common.actions.checking": "Checking…",
        "common.actions.createLogin": "Create login",
        "common.actions.creating": "Creating...",
        "common.actions.disable": "Disable",
        "common.actions.enable": "Enable",
        "common.actions.saveChanges": "Save changes",
        "common.actions.setPassword": "Set password",
        "common.actions.changePassword": "Change password",
        "common.actions.working": "Working...",
        "common.metrics.profit": "Profit",
        "common.period.lastWeek": "last week",
        "common.roles.customer": "Customer",
        "common.roles.supplier": "Supplier",
        "common.status.active": "Active",
        "common.status.completed": "Completed",
        "common.status.disabled": "Disabled",
        "common.status.draft": "Draft",
        "common.status.enabled": "Enabled",
        "common.status.inactive": "Inactive",
        "common.status.final": "Final",
        "common.status.open": "Open",
        "common.status.outstanding": "Outstanding",
        "common.status.overdue": "Overdue",
        "common.status.paid": "Paid",
        "common.status.payWhenPaid": "Pay when paid",
        "common.status.pending": "Pending",
        "common.status.sent": "Sent",
        "common.status.signed": "Signed",
        "common.status.unpaid": "Unpaid",
        "common.status.upcoming": "Upcoming",
        "common.units.day": "day",
        "common.units.days": "days",
        "common.units.worker": "worker",
        "common.units.workers": "workers",
        "invoice.labels.deadline": "Deadline",
        "invoice.labels.paymentTerm": "Payment term",
        "projects.hours.approved": "Approved",
        "projects.hours.pending": "Pending",
        "projects.hours.workerWithoutHours": "worker without hours",
        "projects.hours.workersWithoutHours": "workers without hours",
        "projects.location.cleared": "Project location cleared.",
        "projects.location.saved": "Project location saved.",
        "customer.computerRow.routerOs": "RouterOS",
        "dashboard.serviceStatusBanner.summary": "Status page summary",
        "email.emailRowInbox.selectSubject": "Select {{subject}}",
        "email.emailRowInbox.failed": "Failed",
        "invoice.invoiceContentAddCard.vatRateSuffix": "% VAT",
        "invoice.invoiceStatusCard.ibanExample": "NL00 BANK 0000 0000 00",
        "invoice.paymentMethods.ideal": "iDEAL",
        "invoice.paymentMethods.manual": "Manual",
        "persons.personDetail.linkedRelations": "Linked relations",
        "persons.personDetail.personDetails": "Person details",
        "persons.personDetail.unlinkAccount": "Unlink {{name}}",
        "persons.personDetail.viewAccount": "View {{name}}",
        "persons.persons.viewPerson": "View {{name}}",
        "projects.projectDetail.accountDefaultHourlyRate": "Account default: {{rate}} per hour",
        "projects.projectDetail.distanceKilometers": "{{distance}} kilometers",
        "projects.projectDetail.distanceMeters": "{{distance}} meters",
        "projects.projectDetail.fixedPlatformFee": "{{fee}} platform fee per hour",
        "projects.projectDetail.mapAttribution": "© OpenStreetMap contributors",
        "projects.projectDetail.percentagePlatformFee": "{{percentage}}% platform fee",
        "projects.projectDetail.projectDetails": "Project details",
        "projects.projectDetail.projectLocation": "Project location",
        "projects.projectDetail.projectPlanning": "Project planning",
        "projects.projectDetail.workerSettingsFor": "Worker project settings for {{name}}",
        "projects.projectDetail.workerSettingsTitle": "Worker project role and rate overrides",
        "projects.projectDetail.workers": "Workers",
        "projects.projectHoursOverview.title": "Hours overview",
        "services.checkTypes.http": "HTTP",
        "services.checkTypes.ping": "Ping",
        "services.removeServiceButton.deleteService": "Delete service",
        "taxes.quarters.q1": "Q1",
        "taxes.quarters.q2": "Q2",
        "taxes.quarters.q3": "Q3",
        "taxes.quarters.q4": "Q4",
        "tenants.tenantAttachmentRequirements.title": "Document requirements",
        "tenants.tenantCard.revenueThisQuarter": "Revenue this quarter",
        "tenants.tenantInvoiceSettings.title": "Invoice settings",
        "tenants.tenantOverviewCard.tenantId": "Tenant ID",
        "tenants.tenantOverviewCard.title": "Tenant details",
        "tenants.tenantPushNotifications.title": "Push notifications",
        "tenants.tenantTab.openAccount": "Open {{name}}",
        "user.userDetail.idValue": "ID: {{id}}",
        "projects.contractTemplateEditor.dataLoadFailed": "Template data could not be loaded.",
        "projects.contractTemplateEditor.loadFailed": "The template could not be loaded.",
        "projects.contractTemplateEditor.pdfRequired": "Upload a PDF file.",
        "projects.contractTemplateEditor.responsibleSaved": "Responsible contract template saved.",
        "projects.contractTemplateEditor.saveFailed": "The template could not be saved.",
        "projects.contractTemplateEditor.singleSignatureAllowed": "The contract can contain one signature field.",
        "projects.contractTemplateEditor.singleSignatureRequired": "Place exactly one signature field on the PDF.",
        "projects.contractTemplateEditor.workerSaved": "Worker contract template saved.",
        "pushNotifications.deviceScope": "For this device and tenant",
        "pushNotifications.unsupportedDevice": "Not supported on this device",
        "user.form.create": "Create user",
        "user.form.details": "User details",
        "user.form.edit": "Edit user",
        "user.roles.administrator": "Administrator",
        "user.roles.operator": "Operator",
        "user.roles.user": "User",
        "user.security.authenticatorApp": "Authenticator app",
        "user.security.createMfaQrCode": "Create MFA QR code",
        "user.security.creatingMfaQrCode": "Creating MFA QR code…",
        "user.security.downloadMfaQrCode": "Download QR code",
        "user.security.mfaQrCodeAlt": "MFA QR code for {{name}}",
        "user.security.mfaQrFailed": "The MFA QR code could not be created.",
        "user.security.mfaQrReady": "Send this QR code to the employee through a secure channel. No authenticator code needs to be verified in this step.",
        "user.regions.africa": "Africa",
        "user.regions.antarctica": "Antarctica",
        "user.regions.asia": "Asia",
        "user.regions.australia": "Australia",
        "user.regions.europe": "Europe",
        "user.regions.northAmerica": "North America",
        "user.regions.southAmerica": "South America",
        "ledgerAccounts.accountingCosts": "Accounting costs",
        "ledgerAccounts.administrationCosts": "Administration costs",
        "ledgerAccounts.bankCosts": "Bank costs",
        "ledgerAccounts.businessGifts": "Business gifts",
        "ledgerAccounts.carCosts": "Car costs",
        "ledgerAccounts.cleaningCosts": "Cleaning costs",
        "ledgerAccounts.depreciationCosts": "Depreciation costs",
        "ledgerAccounts.directProjectCosts": "Direct project costs",
        "ledgerAccounts.energyAndWater": "Energy and water",
        "ledgerAccounts.fairsAndEvents": "Fairs and events",
        "ledgerAccounts.finesAndAssessments": "Fines and additional assessments",
        "ledgerAccounts.fuel": "Fuel",
        "ledgerAccounts.hardwareAndEquipment": "Hardware and equipment",
        "ledgerAccounts.hiredPersonnel": "Hired personnel",
        "ledgerAccounts.hostingAndCloud": "Hosting and cloud",
        "ledgerAccounts.insurance": "Insurance",
        "ledgerAccounts.interestAndFinancing": "Interest and financing costs",
        "ledgerAccounts.inventoryDifferences": "Inventory differences",
        "ledgerAccounts.itMaintenance": "IT maintenance",
        "ledgerAccounts.legalAdvice": "Legal advice",
        "ledgerAccounts.marketingAndAdvertising": "Marketing and advertising",
        "ledgerAccounts.materials": "Purchases of materials",
        "ledgerAccounts.mileageAllowance": "Mileage allowance",
        "ledgerAccounts.noOptions": "No ledger account found",
        "ledgerAccounts.officeMaintenance": "Office maintenance",
        "ledgerAccounts.officeRent": "Office rent",
        "ledgerAccounts.officeSupplies": "Office supplies",
        "ledgerAccounts.otherAdvice": "Other advice",
        "ledgerAccounts.otherDirectPurchasing": "Other direct purchasing costs",
        "ledgerAccounts.otherGeneralCosts": "Other general costs",
        "ledgerAccounts.otherRevenueCost": "Cost of other revenue",
        "ledgerAccounts.parkingAndTolls": "Parking and tolls",
        "ledgerAccounts.paymentDifferences": "Payment differences",
        "ledgerAccounts.pensionCosts": "Pension costs",
        "ledgerAccounts.phoneAndInternet": "Phone and internet",
        "ledgerAccounts.postageAndPrinting": "Postage and printing",
        "ledgerAccounts.publicTransport": "Public transport",
        "ledgerAccounts.purchaseDiscounts": "Purchase discounts",
        "ledgerAccounts.representationCosts": "Representation costs",
        "ledgerAccounts.search": "Search ledger accounts...",
        "ledgerAccounts.smallPurchases": "Small purchases",
        "ledgerAccounts.socialSecurity": "Social security contributions",
        "ledgerAccounts.softwareAndLicences": "Software and licences",
        "ledgerAccounts.subcontractedWork": "Subcontracted work",
        "ledgerAccounts.subscriptionsAndMemberships": "Subscriptions and memberships",
        "ledgerAccounts.tradeGoods": "Purchases of trade goods",
        "ledgerAccounts.trainingCosts": "Training costs",
        "ledgerAccounts.transportAndShipping": "Transport and shipping costs",
        "ledgerAccounts.travelAndAccommodation": "Travel and accommodation costs",
        "ledgerAccounts.uncategorized": "Uncategorized",
        "ledgerAccounts.wagesAndSalaries": "Wages and salaries",
        "ledgerAccounts.websiteAndDomains": "Website and domains",
        "projects.contractTemplateEditor.defaults.newField": "Nieuw veld",
        "projects.contractTemplateEditor.defaults.responsibleBody": "Beste {{responsible.name}},\n\nIn de bijlage vindt u uw getekende contract voor {{project.name}} en {{worker.name}}.",
        "projects.contractTemplateEditor.defaults.responsibleFilename": "contract-{{project.name}}-{{worker.name}}-responsible.pdf",
        "projects.contractTemplateEditor.defaults.responsibleName": "Standaard responsible-contract",
        "projects.contractTemplateEditor.defaults.responsibleSubject": "Uw getekende contract voor {{project.name}} en {{worker.name}}",
        "projects.contractTemplateEditor.defaults.signatureField": "Handtekening werker",
        "projects.contractTemplateEditor.defaults.signatureCopyField": "Paraaf",
        "projects.contractTemplateEditor.defaults.workerBody": "Beste {{worker.name}},\n\nIn de bijlage vindt u uw getekende contract voor {{project.name}}.",
        "projects.contractTemplateEditor.defaults.workerFilename": "contract-{{project.name}}-{{worker.name}}.pdf",
        "projects.contractTemplateEditor.defaults.workerName": "Standaard worker-contract",
        "projects.contractTemplateEditor.defaults.workerSubject": "Uw getekende contract voor {{project.name}}",
    },
    nl: {
        "invoice.detail.pdf": "PDF",
        "invoice.detail.payment": "Betalingen",
    "invoice.detail.received": "Ontvangen",
    "common.showLess": "Minder tonen",
    "email.emailRowInbox.starSubject": "{{subject}} markeren met ster",
        "invoice.detail.noPayment": "Nog geen betaling geregistreerd",
        "invoice.detail.items": "Factuurregels",
        "invoice.detail.deleteItem": "{{name}} verwijderen",
        "invoice.paymentMethods.bank": "Bank",

        "taxModule.investment_sale": "Verkoopopbrengst investering",
        "taxModule.title": "Jaarrekening",
        "taxModule.report": "Jaarrekening",
        "taxModule.investment": "Investeringen",
        "taxModule.loan": "Leningen",
        "taxModule.participation": "Deelnemingen",
        "taxModule.journal": "Correcties",
        "taxModule.allocation": "Transactiekoppelingen",
        "taxModule.allocationListHelp": "Koppelingen zijn gegroepeerd per verwerkingstype en tonen de volledige opgeslagen transactie, ook na de verslagperiode.",
        "taxModule.groupCount": "{{count}} transactiekoppelingen",
        "taxModule.expenseSource": "Uitgave",
        "taxModule.paymentSource": "Ontvangst",
        "taxModule.bookyear": "Boekjaren",
        "taxModule.ledger": "Aftrekbaarheid",
        "taxModule.notes": "Toelichtingen",
        "taxModule.tenant": "Bedrijf",
        "taxModule.start": "Begindatum",
        "taxModule.end": "Einddatum",
        "taxModule.asof": "Peildatum",
        "taxModule.year": "Boekjaar",
        "taxModule.full": "Heel jaar",
        "taxModule.half": "Eerste halfjaar",
        "taxModule.free": "Vrije periode",
        "taxModule.download": "Jaarrekening downloaden",
        "taxModule.generating": "PDF genereren…",
        "taxModule.new": "Toevoegen",
        "taxModule.edit": "Bewerken",
        "taxModule.save": "Opslaan",
        "taxModule.cancel": "Annuleren",
        "taxModule.delete": "Verwijderen",
        "taxModule.remove": "Regel verwijderen",
        "taxModule.empty": "Nog geen registraties.",
        "taxModule.name": "Naam",
        "taxModule.choose": "Selecteer…",
        "taxModule.loading": "Laden…",
        "taxModule.failed": "De aanvraag is mislukt. Probeer het opnieuw.",
        "taxModule.saved": "Opgeslagen.",
        "taxModule.confirmDelete": "Deze registratie verwijderen?",
        "taxModule.acquired": "Aanschafdatum",
        "taxModule.inUse": "Ingebruiknamedatum",
        "taxModule.residual": "Restwaarde",
        "taxModule.months": "Looptijd in maanden",
        "taxModule.method": "Methode",
        "taxModule.linear": "Lineair",
        "taxModule.declining": "Degressief",
        "taxModule.annuity": "Annuïtair",
        "taxModule.bullet": "Aan het einde",
        "taxModule.rate": "Jaarpercentage",
        "taxModule.fiscalMonths": "Fiscale afschrijving in maanden (optioneel)",
        "taxModule.fiscalResidual": "Fiscale restwaarde (optioneel)",
        "taxModule.kia": "Komt in aanmerking voor KIA",
        "taxModule.expenses": "Gekoppelde uitgaven",
        "taxModule.search": "Transacties zoeken",
        "taxModule.searchPlaceholder": "Naam, tegenpartij, IBAN, datum of bedrag",
        "taxModule.noSourcesFound": "Geen passende transacties",
        "taxModule.net": "Exclusief ingevulde btw",
        "taxModule.cost": "Aanschafwaarde",
        "taxModule.value": "Boekwaarde / openstaande hoofdsom",
        "taxModule.depreciation": "Cumulatieve afschrijving",
        "taxModule.disposal": "Verkoop- of afboekdatum (optioneel)",
        "taxModule.proceeds": "Verkoopopbrengst exclusief btw",
        "taxModule.investmentHelp": "Eenmalig vastleggen. Afschrijvingen en boekwaarde lopen automatisch door in alle perioden. Gebruik gekoppelde aankoopuitgaven of een handmatige startwaarde.",
        "taxModule.investmentBasis": "Bron van de waarde",
        "taxModule.manualInitialValue": "Handmatige startwaarde (zonder aankooptransactie)",
        "taxModule.initialValue": "Startwaarde exclusief aftrekbare btw",
        "taxModule.initialAccount": "Tegenrekening startwaarde",
        "taxModule.initialValueHelp": "Vul de aanschafwaarde op de aanschafdatum in, bijvoorbeeld uit een inbreng- of openingsbalans. Kies de bijbehorende vermogens- of schuldrekening. Dit maakt geen bankbetaling of btw-vordering; afschrijving begint op de ingebruiknamedatum.",
        "taxModule.direction": "Richting",
        "taxModule.received": "Ontvangen lening",
        "taxModule.issued": "Verstrekte lening",
        "taxModule.counterparty": "Tegenpartij",
        "taxModule.principal": "Hoofdsom",
        "taxModule.initialPrincipal": "Beginhoofdsom",
        "taxModule.loanOpeningBalance": "Beginsaldo overgenomen zonder bankbetaling",
        "taxModule.loanOpeningBalanceHelp": "Gebruik dit voor een lening uit een eerdere administratie, bijvoorbeeld bij de inbreng van een eenmanszaak. De beginhoofdsom wordt tegen het ingebrachte eigen vermogen geboekt. Latere opnames en aflossingen volgen hun werkelijke betalingen.",
        "taxModule.balloon": "Slottermijn (optioneel)",
        "taxModule.installment": "Maandbedrag volgens contract inclusief rente (optioneel)",
        "taxModule.firstPaymentDate": "Datum eerste maandtermijn (optioneel)",
        "taxModule.balloonDate": "Vervaldatum slottermijn (optioneel)",
        "taxModule.loanContractHelp": "De slottermijn blijft openstaan tijdens de maandtermijnen. Laat de contractvelden leeg om de bedragen automatisch te berekenen. De eerste maandtermijn valt standaard één maand na de begindatum; de slottermijn op de laatste termijndatum. De laatste maandtermijn verrekent afronding en eventueel resterende aflossing boven de slottermijn.",
        "taxModule.scheduleSaveHelp": "Sla de wijzigingen op om het aflossingsschema bij te werken.",
        "taxModule.paymentAmount": "Termijnbedrag",
        "taxModule.balloonPart": "Waarvan slottermijn",
        "taxModule.remainingPrincipal": "Resterende hoofdsom",
        "taxModule.interest": "Rente",
        "taxModule.currentAccount": "Rekening-courant",
        "taxModule.movements": "Aanvullende mutaties",
        "taxModule.movementExpense": "Gekoppelde uitgave (optioneel)",
        "taxModule.movementPayment": "Gekoppelde ontvangst (optioneel)",
        "taxModule.movementLinkHelp": "Koppel de bijbehorende transactie om de betaling eenmaal mee te tellen. Datum en totaal komen uit de transactie; vul eventuele betaalde rente apart in. Gelijke datums en bedragen staan bovenaan.",
        "taxModule.loanMovementOwner": "Gekoppeld aan een mutatie in {{name}}. Wijzig deze koppeling bij de lening.",
        "taxModule.drawdown": "Opname / verstrekking",
        "taxModule.repayment": "Aflossing",
        "taxModule.amount": "Bedrag",
        "taxModule.date": "Datum",
        "taxModule.schedule": "Resterend aflossingsschema",
        "taxModule.shortTerm": "Binnen twaalf maanden",
        "taxModule.loanHelp": "Beginhoofdsom is het bedrag bij aanvang. Leg je alle verstrekkingen als mutaties vast? Vul dan 0 in. Het resterende aflossingsschema gebruikt het openstaande bedrag op de peildatum.",
        "taxModule.share": "Belang (%)",
        "taxModule.netAsset": "Nettovermogenswaarde",
        "taxModule.atCost": "Aanschafwaarde",
        "taxModule.exempt": "Deelnemingsvrijstelling toepassen",
        "taxModule.equity": "Handmatige waarderingen eigen vermogen",
        "taxModule.subsidiaryEquity": "Totaal eigen vermogen deelneming",
        "taxModule.capitalMovement": "Kapitaalmutatie deelneming sinds vorige waardering",
        "taxModule.dividendMovement": "Dividend deelneming sinds vorige waardering",
        "taxModule.equityDate": "Laatste waarderingsdatum",
        "taxModule.participationHelp": "Voer het eigen vermogen van de deelneming handmatig per peildatum in. Geen gegevens ophalen uit Office. Eerdere waarderingen blijven beschikbaar. Kapitaal en dividend zijn mutaties sinds de vorige waardering.",
        "taxModule.debit": "Debetrekening",
        "taxModule.credit": "Creditrekening",
        "taxModule.fiscal": "Fiscale winstcorrectie (+ bijtellen / − aftrekken)",
        "taxModule.otherDeduction": "Overige investeringsaftrek",
        "taxModule.loss": "Historisch onverrekend fiscaal verlies",
        "taxModule.deductible": "Aftrekbaar voor VPB (%)",
        "taxModule.ledgerAccount": "Grootboekrekening",
        "taxModule.activities": "Bedrijfsactiviteiten",
        "taxModule.group": "Groepsstructuur",
        "taxModule.principles": "Aanvullende waarderingsgrondslagen",
        "taxModule.commitments": "Niet uit de balans blijkende verplichtingen",
        "taxModule.subsequentEvents": "Gebeurtenissen na balansdatum",
        "taxModule.employees": "Gemiddeld aantal werknemers",
        "taxModule.additional": "Aanvullende toelichting",
        "taxModule.classification": "Financiële verwerking",
        "taxModule.mollie_settlement": "Mollie-verzamelbetaling",
        "taxModule.settlementPayout": "Mollie-bankuitbetaling",
        "taxModule.settlementHelp": "Vink de factuurbetalingen van deze uitbetaling aan. Betalingen na de uitbetalingsdatum of betalingen die al elders gekoppeld zijn, kun je niet selecteren.",
        "taxModule.settlementSearch": "Factuurbetalingen zoeken",
        "taxModule.settlementPayments": "Mollie-factuurbetalingen inclusief btw",
        "taxModule.settlementFees": "Ingehouden Mollie-kosten",
        "taxModule.settlementFeesHelp": "De kosten worden automatisch ingevuld vanuit het positieve verschil tussen de geselecteerde factuurbetalingen en de bankuitbetaling. Je kunt het bedrag aanpassen; je handmatige bedrag blijft dan behouden voor deze uitbetaling. De kosten worden als bankkosten geboekt zonder extra bankmutatie.",
        "taxModule.settlementGross": "Bruto factuurbetalingen",
        "taxModule.settlementNet": "Netto bankuitbetaling",
        "taxModule.settlementDifference": "Resterend verschil",
        "taxModule.settlementPaymentCount": "{{count}} factuurbetalingen geselecteerd",
        "taxModule.settlementChoosePayout": "Kies eerst de bankuitbetaling.",
        "taxModule.settlementChoosePayments": "Vink minimaal één factuurbetaling aan.",
        "taxModule.settlementLoadFailed": "Mollie-factuurbetalingen konden niet worden geladen. Je selectie is behouden.",
        "taxModule.settlementRetry": "Opnieuw proberen",
        "taxModule.settlementEmpty": "Geen passende Mollie-factuurbetalingen tot en met deze uitbetalingsdatum.",
        "taxModule.settlementInvalidSelection": "Een geselecteerde betaling ontbreekt, is elders gekoppeld of ligt na de uitbetalingsdatum. Wis de selectie en kies de juiste betalingen opnieuw.",
        "taxModule.settlementClear": "Selectie wissen",
        "taxModule.settlementBalanced": "De uitbetaling en kosten sluiten aan op de geselecteerde factuurbetalingen.",
        "taxModule.settlementOpen": "Een resterend verschil blijft open op de Mollie-tussenrekening.",
        "taxModule.transaction": "Transactie",
        "taxModule.ordinaryCost": "Gewone kosten",
        "taxModule.loan_drawdown": "Lening ontvangen / verstrekt",
        "taxModule.loan_repayment": "Leningaflossing",
        "taxModule.loan_interest": "Leningrente",
        "taxModule.vpb": "VPB-betaling / teruggaaf",
        "taxModule.vat": "Btw-betaling / teruggaaf",
        "taxModule.capital": "Aandelenkapitaal",
        "taxModule.premium": "Agio",
        "taxModule.dividend": "Dividend / resultaatbestemming",
        "taxModule.transfer": "Overboeking tussen eigen rekeningen",
        "taxModule.participation_purchase": "Aankoop deelneming / kapitaalstorting",
        "taxModule.participation_dividend": "Dividend uit deelneming",
        "taxModule.revenue": "Overige opbrengst",
        "taxModule.related": "Gekoppelde lening / deelneming",
        "taxModule.periodStart": "Kostenperiode vanaf (optioneel)",
        "taxModule.periodEnd": "Kostenperiode t/m (optioneel)",
        "taxModule.allocationHelp": "Deze financiële verwerking wordt aanvullend bewaard. Bij gecombineerde betalingen hoofdsom en rente apart invullen.",
        "taxModule.linked": "Al gekoppeld",
        "taxModule.previewVAT": "Btw-overzicht tonen",
        "taxModule.outputVAT": "Verschuldigde btw",
        "taxModule.inputVAT": "Voorbelasting",
        "taxModule.payable": "Btw-saldo",
        "taxModule.reportHelp": "Genereer een jaarrekening op basis van Office en de aanvullende registraties. De beginbalans volgt automatisch uit de eerdere historie.",
        "taxModule.fiscalHelp": "Automatische VPB- en KIA-tabellen: 2020–2026. Overige fiscale verschillen via correcties; historisch onverrekende verliezen eenmalig in het eerste boekjaar.",
        "taxModule.useNext": "Volgend jaar gebruiken",
        "taxModule.bookyearHelp": "Boekjaren blijven bewerkbaar. Afsluiten of kopiëren is niet nodig.",
        "taxModule.corrections": "Waardecorrecties",
        "taxModule.accounts.bank": "Bank en kas",
        "taxModule.accounts.receivables": "Debiteuren",
        "taxModule.accounts.prepaid": "Vooruitbetaalde kosten",
        "taxModule.accounts.inventory": "Voorraad",
        "taxModule.accounts.fixed": "Overige vaste activa",
        "taxModule.accounts.participations": "Deelnemingen",
        "taxModule.accounts.vat": "Omzetbelasting",
        "taxModule.accounts.vpb": "Vennootschapsbelasting",
        "taxModule.accounts.creditors": "Crediteuren",
        "taxModule.accounts.accrued": "Nog te betalen kosten",
        "taxModule.accounts.deferred": "Vooruitontvangen omzet",
        "taxModule.accounts.provisions": "Voorzieningen",
        "taxModule.accounts.suspense": "Nog te rubriceren ontvangsten",
        "taxModule.accounts.capital": "Aandelenkapitaal",
        "taxModule.accounts.premium": "Agio",
        "taxModule.accounts.reserves": "Overige reserves",
        "taxModule.accounts.retained": "Overgedragen resultaat",
        "taxModule.accounts.dividend": "Dividend / resultaatbestemming",
        "taxModule.accounts.revenue": "Omzet",
        "taxModule.accounts.direct": "Inkoopwaarde omzet",
        "taxModule.accounts.costs": "Bedrijfskosten",
        "taxModule.accounts.depreciation": "Afschrijvingen",
        "taxModule.accounts.interest_cost": "Rentelasten",
        "taxModule.accounts.interest_income": "Rentebaten",
        "taxModule.accounts.participation_result": "Resultaat deelnemingen",
        "taxModule.accounts.other_result": "Overige resultaten",
        "assets.allCriticalities": "Alle criticaliteiten",
        "assets.allCustomers": "Alle relaties",
        "assets.allStatuses": "Alle statussen",
        "assets.clearFilters": "Filters wissen",
        "assets.calendar.action": "Agenda koppelen",
        "assets.calendar.copied": "Gekopieerd",
        "assets.calendar.copy": "Link kopiëren",
        "assets.calendar.copyFailed": "De link kon niet worden gekopieerd. Selecteer en kopieer hem handmatig.",
        "assets.calendar.help": "Abonneer je op de volgende service-uitvoering van ieder actief interval binnen de tenants waar je nu toegang toe hebt. Je agenda werkt automatisch bij vanuit deze feed.",
        "assets.calendar.linkLabel": "ICS-abonnementslink",
        "assets.calendar.loadFailed": "De agendalink kon niet worden aangemaakt.",
        "assets.calendar.secret": "Houd deze link privé. Iedereen met de link kan deze servicedatums bekijken.",
        "assets.calendar.title": "Service-intervallen in je agenda",
        "assets.back": "Assets",
        "assets.detail.addField": "Veld toevoegen",
        "assets.detail.addChild": "Child toevoegen",
        "assets.detail.addInterval": "Service-interval toevoegen",
        "assets.detail.addParent": "Parent toevoegen",
        "assets.detail.assignedTeam": "Toegewezen team",
        "assets.detail.complete": "Afronden",
        "assets.detail.completeAndExport": "Afronden en rapport exporteren",
        "assets.detail.collapseBranch": "{{name}} inklappen",
        "assets.detail.cron": "Cron-expressie",
        "assets.detail.deleteIntervalConfirm": "Service-interval ‘{{name}}’ verwijderen? Bestaande notities en rapporten blijven beschikbaar.",
        "assets.detail.dummyScript": "Dummyscript inschakelen",
        "assets.detail.editInterval": "Service-interval bewerken",
        "assets.detail.enabled": "Actief",
        "assets.detail.expandBranch": "{{name}} uitklappen",
        "assets.detail.fieldKey": "Veldsleutel",
        "assets.detail.fieldLabel": "Label",
        "assets.detail.graceDays": "Respijttermijn (dagen)",
        "assets.detail.hierarchy": "Assetstructuur",
        "assets.detail.invalidCron": "Ongeldige cron-expressie.",
        "assets.detail.lastCompleted": "Laatst afgerond",
        "assets.detail.lifecycle": "Levenscyclus asset",
        "assets.detail.lifecycleProgress": "Levenscyclus asset: {{percentage}}% verstreken",
        "assets.detail.accountParent": "Account",
        "assets.detail.noIntervals": "Geen service-intervallen ingesteld.",
        "assets.detail.openOwnerAccount": "Eigenaaraccount openen",
        "assets.detail.optionsHelp": "Opties, gescheiden door komma’s",
        "assets.detail.overview": "Overzicht",
        "assets.detail.ownerAccount": "Eigenaaraccount",
        "assets.detail.priority": "Prioriteit",
        "assets.detail.report": "Rapport / opmerkingen",
        "assets.detail.required": "Verplicht",
        "assets.detail.result": "Resultaat",
        "assets.detail.serviceIntervals": "Service-intervallen",
        "assets.detail.template": "Uitvoeringstemplate",
        "assets.detail.templateName": "Templatenaam",
        "assets.detail.timezone": "Tijdzone",
        "assets.detail.unit": "Eenheid",
        "assets.due": "Te doen",
        "assets.editAsset": "Asset bewerken",
        "assets.form.addTitle": "Asset toevoegen",
        "assets.form.addingChild": "Dit asset wordt als child van het huidige asset toegevoegd.",
        "assets.form.addingParent": "Dit asset wordt als parent van {{name}} toegevoegd.",
        "assets.form.assetType": "Assettype",
        "assets.form.criticality": "Criticaliteit",
        "assets.form.editTitle": "Asset bewerken",
        "assets.form.endOfLifeDate": "End-of-life-datum",
        "assets.form.installationDate": "Installatiedatum",
        "assets.form.internalAsset": "Intern asset (geen relatie)",
        "assets.custom.add": "Eigenschap toevoegen",
        "assets.custom.help": "Voeg typespecifieke metadata toe zonder het basisassetmodel uit te breiden.",
        "assets.custom.key": "Sleutel",
        "assets.custom.label": "Label",
        "assets.custom.none": "Geen custom properties.",
        "assets.custom.remove": "Eigenschap verwijderen",
        "assets.custom.title": "Custom properties",
        "assets.custom.type": "Type",
        "assets.custom.unit": "Eenheid",
        "assets.custom.value": "Waarde",
        "assets.form.location": "Locatie",
        "assets.form.manufacturer": "Fabrikant",
        "assets.form.model": "Model",
        "assets.form.noSupplier": "Geen leverancier",
        "assets.form.owner": "Eigenaar",
        "assets.form.parentAssets": "Bovenliggende assets",
        "assets.form.purchaseDate": "Aankoopdatum",
        "assets.form.required": "Administratie, naam en assettype zijn verplicht.",
        "assets.form.selectTenant": "Selecteer een administratie…",
        "assets.form.serialNumber": "Serienummer",
        "assets.form.tenant": "Administratie",
        "assets.form.warrantyUntil": "Garantie tot",
        "assets.internal": "Intern",
        "assets.filters": "Filters",
        "assets.management.enabled": "Manager ingeschakeld",
        "assets.management.help": "Voeg één of meerdere managers toe aan dit asset. Iedere manager heeft een eigen configuratie en statuscontrole.",
        "assets.management.remoteHelp": "De bestaande remote-desktopflow gebruikt deze RPort-client-ID.",
        "assets.management.rportId": "RPort-client-ID",
        "assets.management.title": "Managers",
        "assets.management.mikrotik": "MikroTik",
        "assets.management.remoteDesktop": "Remote desktop",
        "assets.management.domainName": "Domeinnaam",
        "assets.management.domain": "Domein",
        "assets.management.managerName": "Naam manager",
        "assets.management.managerNameOptional": "Optioneel, bijvoorbeeld primaire verbinding",
        "assets.management.remove": "Manager verwijderen",
        "assets.management.none": "Er zijn nog geen managers toegevoegd.",
        "assets.management.disabled": "Uitgeschakeld",
        "assets.management.expiresAt": "Verloopt",
        "assets.management.daysRemaining": "Nog {{count}} dagen",
        "assets.management.checked": "Gecontroleerd",
        "assets.management.connecting": "Verbinden",
        "assets.management.unreachable": "Niet bereikbaar",
        "assets.management.authenticationFailed": "Authenticatie mislukt",
        "assets.management.configurationError": "Configuratiefout",
        "assets.management.lastSeen": "Laatst gezien",
        "assets.management.pingTargets": "Pingtargets",
        "assets.management.pingTargetsHelp": "De router controleert deze interne adressen via zijn bestaande API-verbinding.",
        "assets.management.addPingTarget": "Target toevoegen",
        "assets.management.pingTargetNumber": "Target {{count}}",
        "assets.management.pingTargetEnabled": "Pingtarget ingeschakeld",
        "assets.management.removePingTarget": "Pingtarget verwijderen",
        "assets.management.linkedAsset": "Gekoppeld asset",
        "assets.management.manualTarget": "Handmatig target",
        "assets.management.noAssetsFound": "Geen assets gevonden",
        "assets.management.pingAddress": "IP-adres of hostnaam",
        "assets.management.noPingTargets": "Er zijn nog geen pingtargets toegevoegd.",
        "assets.management.pingState.unknown": "Onbekend",
        "assets.management.pingState.up": "Bereikbaar",
        "assets.management.pingState.degraded": "Packet loss",
        "assets.management.pingState.unreachable": "Niet bereikbaar",
        "assets.management.pingState.down": "Offline",
        "assets.management.pingStateStale": "Verouderd",
        "assets.management.pingIssues": "{{count}} pingprobleem/pingproblemen",
        "assets.management.pingIssues_one": "{{count}} pingprobleem",
        "assets.management.pingIssues_other": "{{count}} pingproblemen",
        "assets.management.averageRtt": "Gemiddelde RTT",
        "assets.management.packetLoss": "Packet loss",
        "assets.newAsset": "Asset toevoegen",
        "assets.noAssets": "Geen assets gevonden.",
        "assets.notes.addAttachment": "Bijlage toevoegen",
        "assets.notes.addDocument": "Bijlage toevoegen",
        "assets.notes.addLinkedNote": "Vervolgnotitie toevoegen",
        "assets.notes.addNote": "Notitie toevoegen",
        "assets.notes.attachments": "Bijlagen",
        "assets.notes.attachmentsSelected": "{{count}} bijlage(n) geselecteerd",
        "assets.notes.byAuthor": "door {{author}}",
        "assets.notes.content": "Inhoud",
        "assets.notes.correct": "Corrigeren (F13)",
        "assets.notes.corrected": "Gecorrigeerd",
        "assets.notes.correctionReason": "Reden van correctie",
        "assets.notes.edit": "Notitie bewerken",
        "assets.notes.edited": "aangepast",
        "assets.notes.editWindow": "De auteur kan deze notitie tot 24 uur na het aanmaken bewerken.",
        "assets.notes.linkedTo": "Deze notitie wordt gekoppeld aan {{name}}.",
        "assets.notes.logbook": "Assetlogboek",
        "assets.notes.noNotes": "Er zijn nog geen notities toegevoegd.",
        "assets.notes.openDocumentFailed": "De bijlage kon niet worden geopend.",
        "assets.notes.removeAttachment": "Bijlage verwijderen",
        "assets.notes.saveCorrection": "Correctie opslaan",
        "assets.notes.signaturePending": "Handtekening vereist",
        "assets.notes.signatureQuestion": "Moet dit document door de relatie worden ondertekend?",
        "assets.notes.signatureRequired": "Handtekening vereist",
        "assets.notes.signed": "Ondertekend",
        "assets.notes.title": "Titel",
        "assets.overdue": "Achterstallig",
        "assets.resultCount": "{{count}} assets",
        "assets.resultCountSingle": "1 asset",
        "assets.relation.dueCount": "{{count}} te doen",
        "assets.relation.loadFailed": "Assets konden niet worden geladen.",
        "assets.relation.none": "Er zijn geen assets aan deze relatie gekoppeld.",
        "assets.relation.overdueCount": "{{count}} achterstallig",
        "assets.search": "Assets zoeken…",
        "assets.subtitle": "Centraal overzicht van interne en relatiegebonden assets, onderhoud en notities.",
        "assets.title": "Assets",
        "accounts.accountAssetsCard.addRouter": "Router toevoegen",
        "accounts.accountAssetsCard.assets": "Bedrijfsmiddelen",
        "accounts.accountAssetsCard.connected": "Verbonden",
        "accounts.accountAssetsCard.deleteAsset": "{{name}} verwijderen",
        "accounts.accountAssetsCard.deleteAssetConfirm": "Bedrijfsmiddel \"{{name}}\" verwijderen?",
        "accounts.accountAssetsCard.deleteFailed": "Het bedrijfsmiddel kon niet worden verwijderd.",
        "accounts.accountAssetsCard.editAsset": "{{name}} bewerken",
        "accounts.accountAssetsCard.editRouter": "Router bewerken",
        "accounts.accountAssetsCard.invalidForm": "Vul een naam, adres en gebruikersnaam in.",
        "accounts.accountAssetsCard.loadFailed": "Bedrijfsmiddelen konden niet worden geladen.",
        "accounts.accountAssetsCard.offline": "Offline",
        "accounts.accountAssetsCard.openAsset": "{{name}} openen",
        "accounts.accountAssetsCard.saveFailed": "De router kon niet worden opgeslagen.",
        "accounts.accountAssetsCard.statusUnavailable": "Status niet beschikbaar",
        "accounts.accountAttachmentsCard.approve": "Goedkeuren",
        "accounts.accountAttachmentsCard.deleteDocument": "Document verwijderen",
        "accounts.accountAttachmentsCard.documents": "Documenten",
        "accounts.accountAttachmentsCard.download": "Downloaden",
        "accounts.accountAttachmentsCard.editExpiry": "Verloopdatum bewerken",
        "accounts.accountAttachmentsCard.editExpiryDate": "Verloopdatum bewerken",
        "accounts.accountAttachmentsCard.expiresDate": "Verloopt op {{date}}",
        "accounts.accountAttachmentsCard.expiryDate": "Verloopdatum",
        "accounts.accountAttachmentsCard.explainWhyNameIsRejectedThisReasonIsShownToTheWorker": "Leg uit waarom {{name}} is afgewezen. Deze reden wordt aan de medewerker getoond.",
        "accounts.accountAttachmentsCard.leaveThisEmptyToRemoveTheExpiryDate": "Laat dit leeg om de verloopdatum te verwijderen.",
        "accounts.accountAttachmentsCard.noDocumentsUploadedYet": "Nog geen documenten geüpload.",
        "accounts.accountAttachmentsCard.reasonForRejection": "Reden voor afwijzing",
        "accounts.accountAttachmentsCard.reject": "Afwijzen",
        "accounts.accountAttachmentsCard.rejectDocument": "Document afwijzen",
        "accounts.accountAttachmentsCard.thePdfCouldNotBeDisplayed": "De pdf kon niet worden weergegeven.",
        "accounts.accountAttachmentsCard.unknownType": "Onbekend type",
        "accounts.accountAttachmentsCard.updateTheExpiryDateForName": "Werk de verloopdatum van {{name}} bij.",
        "accounts.accountAttachmentsCard.view": "Bekijken",
        "accounts.accountCreate.createAccount": "Relatie aanmaken",
        "accounts.accountDetail.accountCouldNotBeLoaded": "Relatie kon niet worden geladen.",
        "accounts.accountDetail.accountSaved": "Relatie opgeslagen.",
        "accounts.accountDetail.confirmMerge": "Samenvoegen en huidige relatie verwijderen",
        "accounts.accountDetail.merge": "Samenvoegen",
        "accounts.accountDetail.mergeInto": "Relatie die moet blijven bestaan",
        "accounts.accountDetail.mergeRelations": "Relaties samenvoegen",
        "accounts.accountDetail.mergeWarning": "{{source}} wordt definitief verwijderd. Alle gekoppelde personen, facturen, offertes, periodieke regels, uitgaven, projecten, documenten, assets en e-mails worden naar de gekozen relatie verplaatst. Bestaande gegevens van de gekozen relatie hebben voorrang.",
        "accounts.accountDetail.merging": "Samenvoegen…",
        "accounts.accountDetail.noMergeTargets": "Er zijn geen andere relaties beschikbaar binnen deze administratie.",
        "accounts.accountDetail.selectMergeTarget": "Kies een relatie…",
        "accounts.accountDetailsCards.addAddress": "Adres toevoegen",
        "accounts.accountDetailsCards.addBankAccount": "Bankrekening toevoegen",
        "accounts.accountDetailsCards.checkingKvkDetails": "KvK-gegevens controleren",
        "accounts.accountDetailsCards.checkingVatDetails": "Btw-gegevens controleren",
        "accounts.accountDetailsCards.companyNameAndAddressMatchTheKvkRegistration": "Bedrijfsnaam en adres komen overeen met de KvK-registratie",
        "accounts.accountDetailsCards.companyNameAndAddressMatchTheVatRegistration": "Bedrijfsnaam en adres komen overeen met de btw-registratie",
        "accounts.accountDetailsCards.countDays": "{{count}} dagen",
        "accounts.accountDetailsCards.differs": "wijkt af",
        "accounts.accountDetailsCards.edit": "Bewerken",
        "accounts.accountDetailsCards.hourlyRate": "Uurtarief",
        "accounts.accountDetailsCards.internalDefaultsUsedForApprovedProjectHoursWorkersCannotViewTheseAmounts": "Interne standaardwaarden voor goedgekeurde projecturen. Medewerkers kunnen deze bedragen niet zien.",
        "accounts.accountDetailsCards.kvkCheckFailed": "KvK-controle mislukt",
        "accounts.accountDetailsCards.kvkCheckedAt": "KvK-gegevens gecontroleerd op {{date}}",
        "accounts.accountDetailsCards.kvkDetailsDiffer": "KvK-gegevens wijken af",
        "accounts.accountDetailsCards.kvkDetailsMatch": "KvK-gegevens komen overeen",
        "accounts.accountDetailsCards.kvkNumberIsInvalid": "KvK-nummer is ongeldig",
        "accounts.accountDetailsCards.kvkNumberIsValidButTheCompanyNameOrAddressDiffers": "KvK-nummer is geldig, maar de bedrijfsnaam of het adres wijkt af",
        "accounts.accountDetailsCards.matches": "komt overeen",
        "accounts.accountDetailsCards.noAddressSaved": "Geen adres opgeslagen.",
        "accounts.accountDetailsCards.noBankAccountSaved": "Geen bankrekening opgeslagen.",
        "accounts.accountDetailsCards.ibanIsInvalid": "IBAN is ongeldig",
        "accounts.accountDetailsCards.notReturned": "Niet ontvangen",
        "accounts.accountDetailsCards.ofHourlyRate": "van het uurtarief",
        "accounts.accountDetailsCards.primary": "Primair",
        "accounts.accountDetailsCards.primaryAddress": "Primair adres",
        "accounts.accountDetailsCards.primaryBankAccount": "Primaire bankrekening",
        "accounts.accountDetailsCards.registeredAddress": "Geregistreerd adres:",
        "accounts.accountDetailsCards.registeredCompany": "Geregistreerd bedrijf:",
        "accounts.accountDetailsCards.reverseChargeVatByDefault": "Standaard btw verleggen",
        "accounts.accountDetailsCards.savedToRegistration": "Opgeslagen → registratie",
        "accounts.accountDetailsCards.useRegisteredDetails": "Geregistreerde gegevens gebruiken",
        "accounts.accountDetailsCards.vatCheckFailed": "Btw-controle mislukt",
        "accounts.accountDetailsCards.vatDetailsDiffer": "Btw-gegevens wijken af",
        "accounts.accountDetailsCards.vatDetailsMatch": "Btw-gegevens komen overeen",
        "accounts.accountDetailsCards.vatNumberIsInvalid": "Btw-nummer is ongeldig",
        "accounts.accountDetailsCards.vatNumberIsValidButTheCompanyNameOrAddressDiffers": "Btw-nummer is geldig, maar de bedrijfsnaam of het adres wijkt af",
        "accounts.accountExpensesCard.noExpensesLinkedToThisAccount": "Geen uitgaven gekoppeld aan deze relatie.",
        "accounts.accountFormCard.accountDetails": "Relatiegegevens",
        "accounts.accountFormCard.accountName": "Rekeningnaam",
        "accounts.accountFormCard.addition": "Toevoeging",
        "accounts.accountFormCard.addresses": "Adressen",
        "accounts.accountFormCard.bankAccount": "Bankrekening",
        "accounts.accountFormCard.bankAccounts": "Bankrekeningen",
        "accounts.accountFormCard.chamberOfCommerceNumber": "KvK-nummer",
        "accounts.accountFormCard.country": "Land",
        "accounts.accountFormCard.currency": "Valuta",
        "accounts.accountFormCard.hourlyRateEuroPerHour": "Uurtarief (€ per uur)",
        "accounts.accountFormCard.internalDefaultsForApprovedProjectHours": "Interne standaardwaarden voor goedgekeurde projecturen.",
        "accounts.accountFormCard.invoiceEmail": "Factuur-e-mail",
        "accounts.accountFormCard.kvkNumberCouldNotBeChecked": "KvK-nummer kon niet worden gecontroleerd.",
        "accounts.accountFormCard.kvkNumberIsNotValid": "KvK-nummer is niet geldig.",
        "accounts.accountFormCard.kvkNumberVerifiedAddressDetailsWereFilledIn": "KvK-nummer gecontroleerd; de adresgegevens zijn ingevuld.",
        "accounts.accountFormCard.legalName": "Statutaire naam",
        "accounts.accountFormCard.paymentDeadlineDays": "Betaaltermijn (dagen)",
        "accounts.accountFormCard.postalCode": "Postcode",
        "accounts.accountFormCard.reverseChargeVatByDefaultOnInvoicesForThisAccount": "Btw standaard verleggen op facturen voor deze relatie",
        "accounts.accountFormCard.selectTenant": "Selecteer tenant…",
        "accounts.accountFormCard.separateNamesWithCommas": "Scheid namen met komma's",
        "accounts.accountFormCard.tradeNames": "Handelsnamen",
        "accounts.accountFormCard.vatNumberCouldNotBeChecked": "Btw-nummer kon niet worden gecontroleerd.",
        "accounts.accountFormCard.vatNumberVerifiedAddressDetailsWereFilledIn": "Btw-nummer gecontroleerd; de adresgegevens zijn ingevuld.",
        "accounts.accountFormCard.workerRates": "Medewerkerstarieven",
        "accounts.accountInvoicesCard.noInvoicesLinkedToThisAccount": "Geen facturen gekoppeld aan deze relatie.",
        "accounts.accountInvoicesCard.showCountMoreInvoices": "Toon nog {{count}} facturen",
        "accounts.accountPersonsCard.addPerson": "Persoon toevoegen",
        "accounts.accountPersonsCard.alreadyLinked": "Al gekoppeld aan deze relatie",
        "accounts.accountPersonsCard.contactAlreadyInUse": "Dit e-mailadres of telefoonnummer is al in gebruik. Koppel een bestaande persoon.",
        "accounts.accountPersonsCard.couldNotCreatePerson": "Deze persoon kon niet worden aangemaakt. Probeer opnieuw.",
        "accounts.accountPersonsCard.couldNotLinkPerson": "Deze persoon kon niet worden gekoppeld. Probeer opnieuw.",
        "accounts.accountPersonsCard.couldNotLoadPersons": "De personen konden niet worden geladen. Probeer opnieuw voordat je een persoon aanmaakt.",
        "accounts.accountPersonsCard.createAndLink": "Aanmaken en koppelen",
        "accounts.accountPersonsCard.linkExistingPerson": "Bestaande persoon koppelen",
        "accounts.accountPersonsCard.linkPerson": "{{name}} koppelen",
        "accounts.accountPersonsCard.noMatchingPersons": "Geen personen gevonden",
        "accounts.accountPersonsCard.noPersonsLinkedYet": "Nog geen personen gekoppeld.",
        "accounts.accountPersonsCard.removeAsRepresentative": "Verwijderen als vertegenwoordiger",
        "accounts.accountPersonsCard.representative": "Vertegenwoordiger",
        "accounts.accountPersonsCard.retryLoadingPersons": "Personen opnieuw laden",
        "accounts.accountPersonsCard.selectPerson": "Selecteer persoon…",
        "accounts.accountPersonsCard.setAsRepresentative": "Instellen als vertegenwoordiger",
        "accounts.accountProjectsCard.noProjectsLinkedToThisAccount": "Geen projecten gekoppeld aan deze relatie.",
        "accounts.accountQuotesCard.noQuotesLinkedToThisAccount": "Geen offertes gekoppeld aan deze relatie.",
        "accounts.accountRecentEmailsCard.composeEmail": "E-mail opstellen",
        "accounts.accountRecentEmailsCard.noSentEmailsFoundForThisAccount": "Geen verzonden e-mails voor deze relatie gevonden.",
        "accounts.accountRecentEmailsCard.noSubject": "(Geen onderwerp)",
        "accounts.accountRecentEmailsCard.sentEmailsCouldNotBeLoaded": "Verzonden e-mails konden niet worden geladen.",
        "accounts.accountRecentEmailsCard.unknownRecipient": "Onbekende ontvanger",
        "accounts.accountRecurringsCard.addRecurring": "Periodieke regel toevoegen",
        "accounts.accountRecurringsCard.deleteRecurringName": "Periodieke regel \"{{name}}\" verwijderen?",
        "accounts.accountRecurringsCard.editNamed": "{{name}} bewerken",
        "accounts.accountRecurringsCard.editRecurring": "Periodieke regel bewerken",
        "accounts.accountRecurringsCard.noRecurringsConfiguredForThisAccount": "Geen periodieke regels ingesteld voor deze relatie.",
        "accounts.accountRecurringsCard.saveRecurring": "Periodieke regel opslaan",
        "accounts.accountRecurringsCard.unit": "Eenheid",
        "accounts.accounts.accountOverview": "Relatieoverzicht",
        "accounts.accounts.clientDistribution": "Verdeling opdrachtgevers",
        "accounts.accounts.clientDistributionShare": "{{name}} {{percentage}}% ({{hours}} u)",
        "accounts.accounts.customersAndSuppliersInOneRelationshipOverview": "Klanten en leveranciers in één relatieoverzicht.",
        "accounts.accounts.hoursShort": "{{hours}} u",
        "accounts.accounts.loadingAccounts": "Relaties laden…",
        "accounts.accounts.noHoursRegistered": "Nog geen uren geregistreerd",
        "accounts.accounts.noResponsible": "Geen verantwoordelijke",
        "accounts.accounts.approvedDocument": "{{approved}}/{{total}} document goedgekeurd",
        "accounts.accounts.approvedDocuments": "{{approved}}/{{total}} documenten goedgekeurd",
        "accounts.accounts.pendingDocument": "{{count}} document in behandeling",
        "accounts.accounts.pendingDocuments": "{{count}} documenten in behandeling",
        "accounts.accounts.searchAccounts": "Relaties zoeken",
        "accounts.accounts.searchNameEmailOrVatNumber": "Zoek op naam, e-mail of btw-nummer…",
        "accounts.accounts.suppliers": "Leveranciers",
        "accounts.accounts.withoutRole": "Zonder rol",
        "accounts.accounts.unknownLocation": "Onbekende locatie",
        "accounts.invoiceIntervalField.cronExpression": "Cron-expressie",
        "accounts.invoiceIntervalField.cronExpression.2218a7d": "cron-expressie",
        "accounts.invoiceIntervalField.customSchedule": "Aangepast schema",
        "accounts.invoiceIntervalField.invoiceInterval": "Factuurinterval",
        "accounts.invoiceIntervalField.invoiceIntervalPreset": "Voorinstelling factuurinterval",
        "accounts.invoiceIntervalField.timezone": "Tijdzone",
        "authentication.login.donTTryToHackThisYouWillBeEatenByOurInterns": "Probeer dit niet te hacken; onze stagiairs houden alles in de gaten.",
        "authentication.login.emailAddress": "E-mailadres",
        "authentication.login.login": "Inloggen",
        "authentication.login.logIn": "Inloggen",
        "authentication.login.signIn": "Inloggen",
        "common.accessLevel": "Toegangsniveau",
        "common.accounts": "Relaties",
        "common.add": "Toevoegen",
        "common.addCheck": "Controle toevoegen",
        "common.addExpense": "Uitgave toevoegen",
        "common.addNewCustomer": "Nieuwe klant toevoegen",
        "common.addNewService": "Nieuwe service toevoegen",
        "common.address": "Adres",
        "common.addUser": "Gebruiker toevoegen",
        "common.adminConsole.closeConsole": "Console sluiten",
        "common.adminConsole.consoleCommand": "Consoleopdracht",
        "common.adminConsole.officeConsole": "Office-console",
        "common.adminConsole.working": "Bezig…",
        "common.amount": "Bedrag",
        "common.belgium": "België",
        "common.billing": "Facturatie",
        "common.body": "Bericht",
        "common.budget": "Budget",
        "common.cancel": "Annuleren",
        "common.checkNeedsANameTargetAndType": "Een controle heeft een naam, doel en type nodig",
        "common.checks": "Controles",
        "common.chooseOne": "Kies er één...",
        "common.chooseTenant": "Kies tenant",
        "common.city": "Plaats",
        "common.close": "Sluiten",
        "common.compose": "Opstellen",
        "common.conversations": "Gesprekken",
        "common.country": "Land:",
        "common.created": "Aangemaakt",
        "common.customer": "Klant",
        "common.customers": "Klanten",
        "common.date": "Datum",
        "common.dateOfBirth": "Geboortedatum",
        "common.defaultPaymentTerm": "Standaard betaaltermijn",
        "common.delete": "Verwijderen",
        "common.deleteCheck": "Controle verwijderen",
        "common.deleteNameThisCannotBeUndone": "{{name}} verwijderen? Dit kan niet ongedaan worden gemaakt.",
        "common.description": "Omschrijving",
        "common.details": "Details",
        "common.draft": "Concept",
        "common.dropzoneCustom.dropFileSHereOrClickToUpload": "Sleep bestanden hierheen of klik om te uploaden.",
        "common.email": "E-mail",
        "common.emailAddress": "E-mailadres",
        "common.expense": "Uitgave",
        "common.expenses": "Uitgaven",
        "common.expensesHasFailedCheckYourCredentials": "Uitgave opslaan is mislukt. Controleer de gegevens.",
        "common.firstName": "Voornaam",
        "common.fixedAmountPerHour": "Vast bedrag per uur",
        "common.fixedDeadline": "Vaste betaaltermijn",
        "common.france": "Frankrijk",
        "common.from": "Van:",
        "common.germany": "Duitsland",
        "common.invoice": "Factuur",
        "common.invoices": "Facturen",
        "common.label": "Label",
        "common.languageDropdown.language": "Taal",
        "common.lastName": "Achternaam",
        "common.lastQCard.ex": "excl.",
        "common.lastQCard.expenseTaxes": "btw op uitgaven",
        "common.lastQCard.lastQuarter": "Vorig kwartaal",
        "common.ledgerAccount": "Grootboekregel",
        "common.link": "Koppelen",
        "common.loginHasFailedCheckYourCredentials": "Inloggen is mislukt. Controleer je gegevens.",
        "common.message": "Bericht",
        "common.mfaActive": "MFA actief",
        "common.mfaInactive": "MFA inactief",
        "common.name": "Naam",
        "common.nameAndRegionAreMandatory": "Naam en regio zijn verplicht",
        "common.nameAndTotalAreMandatory": "Naam en totaal zijn verplicht",
        "common.new": "Nieuw",
        "common.newAccount": "Nieuwe relatie",
        "common.newProject": "Nieuw project",
        "common.nextRun": "Volgende uitvoering",
        "common.noAccountsFound": "Geen relaties gevonden.",
        "common.noConversationsFound": "Geen gesprekken gevonden",
        "common.noEmail": "Geen e-mail",
        "common.noName": "Geen naam",
        "common.none": "Geen",
        "common.number": "Nummer",
        "common.onBehalfOf": "Namens",
        "common.open": "Open",
        "common.orCreateANewPerson": "of maak een nieuwe persoon aan",
        "common.outstandingCard.countInvoices": "{{count}} facturen",
        "common.overdue": "Verlopen",
        "common.paid": "Betaald",
        "common.password": "Wachtwoord",
        "common.payWhenPaid": "Betaal wanneer betaald",
        "common.percentageOfHourlyRate": "Percentage van uurtarief",
        "common.perHour": "per uur",
        "common.personNeedsAName": "Persoon heeft een naam nodig",
        "common.persons": "Personen",
        "common.phone": "Telefoon",
        "common.platformFee": "Platformvergoeding",
        "common.platformFeeType": "Type platformvergoeding",
        "common.previewUnavailable": "Voorbeeld niet beschikbaar",
        "common.price": "Prijs",
        "common.profile": "Profiel",
        "common.profileMenu.logout": "Uitloggen",
        "common.projects": "Projecten",
        "common.pullToRefresh.pullToRefresh": "Trek om te vernieuwen",
        "common.pullToRefresh.refreshing": "Vernieuwen...",
        "common.pullToRefresh.releaseToRefresh": "Loslaten om te vernieuwen",
        "common.qty": "Aantal",
        "common.quote": "Offerte",
        "common.recurringItems": "Periodieke regels",
        "common.region": "Regio",
        "common.remaining": "resterend",
        "common.responsible": "Verantwoordelijke",
        "common.revenue": "Omzet",
        "common.rightbar.boxed": "In kader",
        "common.rightbar.brand": "Merkkleur",
        "common.rightbar.compact": "Compact",
        "common.rightbar.dark": "Donker",
        "common.rightbar.default": "Standaard",
        "common.rightbar.fixed": "Vast",
        "common.rightbar.fluid": "Vloeiend",
        "common.rightbar.horizontal": "Horizontaal",
        "common.rightbar.layoutMode": "Indelingsmodus",
        "common.rightbar.layoutPosition": "Indelingspositie",
        "common.rightbar.layouts": "Indelingen",
        "common.rightbar.layoutWidth": "Indelingsbreedte",
        "common.rightbar.light": "Licht",
        "common.rightbar.scrollable": "Scrollbaar",
        "common.rightbar.sidebarColor": "Kleur zijbalk",
        "common.rightbar.sidebarSize": "Grootte zijbalk",
        "common.rightbar.smallIconView": "Klein (pictogramweergave)",
        "common.rightbar.themeCustomizer": "Thema aanpassen",
        "common.rightbar.topbarColor": "Kleur bovenbalk",
        "common.rightbar.vertical": "Verticaal",
        "common.role": "Rol",
        "common.roles": "Rollen",
        "common.save": "Opslaan",
        "common.saving": "Opslaan…",
        "common.search": "Zoeken...",
        "common.searchAccounts": "Relaties zoeken…",
        "common.send": "Versturen",
        "common.sidebarContent.dashboard": "Dashboard",
        "common.sidebarContent.menu": "Menu",
        "common.status": "Status",
        "common.statusPage": "Statuspagina",
        "common.street": "Straat",
        "common.subject": "Onderwerp",
        "common.supplier": "Leverancier",
        "common.target": "Doel",
        "common.tax": "Belasting",
        "common.taxes": "Belastingen",
        "common.technical": "Technisch",
        "common.tenant": "Tenant",
        "common.tenants": "Tenants",
        "common.theNetherlands": "Nederland",
        "common.tickets": "Tickets",
        "common.to": "Aan:",
        "common.total": "Totaal",
        "common.type": "Type",
        "common.unitedKingdom": "Verenigd Koninkrijk",
        "common.unknown": "Onbekend",
        "common.unknownAccount": "Onbekende relatie",
        "common.unknownSupplier": "Onbekende leverancier",
        "common.uom": "Eenheid",
        "common.users": "Gebruikers",
        "common.vat": "Btw",
        "common.vatNumber": "Btw-nummer",
        "common.vatNumberIsNotValid": "Btw-nummer is niet geldig.",
        "common.vatRatePercentage": "Btw-tarief (%)",
        "common.worker": "Medewerker",
        "common.zip": "Postcode",
        "customer.computerRow.firmware": "firmware",
        "customer.computerRow.latestVersionVersion": "Nieuwste versie: {{version}}",
        "customer.computerRow.loadingRouterStatus": "Routerstatus laden",
        "customer.computersCard.assets": "Beheerde apparaten",
        "customer.computersCard.interfacesOptionalEGWanEther1BackupLte1": "Interfaces (optioneel, bijv. WAN=ether1, Backup=lte1)",
        "customer.computersCard.noAssetsLinked": "Geen bedrijfsmiddelen gekoppeld.",
        "customer.computersCard.passwordLeaveEmptyToKeepCurrent": "Wachtwoord (leeg laten om het huidige te behouden)",
        "customer.computersCard.port": "Poort",
        "customer.computersCard.router": "Router",
        "customer.computersCard.saveRouter": "Router opslaan",
        "customer.computersCard.updateRouter": "Router bijwerken",
        "customer.computersCard.username": "Gebruikersnaam",
        "customer.computersCard.useTls": "TLS gebruiken",
        "customer.computersCard.webUrlOptional": "Web-URL (optioneel)",
        "customer.customerAddForm.addCustomer": "Klant toevoegen",
        "customer.customerAddForm.nameEmailAndTenantAreMandatory": "Naam, e-mail en tenant zijn verplicht",
        "customer.customerDatesCard.amountOfDays": "Aantal dagen",
        "customer.customerDatesCard.autoClose": "Automatisch sluiten",
        "customer.customerDatesCard.defaultDeadlineInDays": "Standaard betaaltermijn (in dagen)",
        "customer.customerDatesCard.intervalCronjob": "Interval (cronjob)",
        "customer.customerDatesCard.value": "Waarde",
        "customer.customerEditForm.editCustomer": "Klant bewerken",
        "customer.customerEditForm.nameIsMandatory": "Naam is verplicht",
        "customer.customerEditForm.selectCountry": "Selecteer land",
        "customer.customerEmailCard.fromAddress": "Afzenderadres",
        "customer.customerEmailCard.fromName": "Naam afzender",
        "customer.customerEmailCard.noEmailsFound": "Geen e-mails gevonden",
        "customer.customerPersonAdd.insteadLinkName": "Koppel in plaats daarvan {{name}}",
        "customer.customerPersonChange.deletePerson": "Persoon verwijderen",
        "customer.customerPersonRow.mfaActive": "MFA: actief",
        "customer.customerPersonRow.mfaInactive": "MFA: inactief",
        "customer.customerPersonRow.noAuthLogin": "Geen login",
        "customer.customerRecurringAdd.everyMonth": "Elke maand",
        "customer.customerRecurringAdd.everyQuarter": "Elk kwartaal",
        "customer.customerRecurringAdd.everyYear": "Elk jaar",
        "customer.customerRecurringAdd.interval": "Interval",
        "customer.customerRecurringAdd.recurringNeedsANamePriceIntervalAmountAndVatRateBetween0PercentageAnd100Percentage": "Een periodieke regel heeft een naam, prijs, interval, aantal en btw-tarief tussen 0% en 100% nodig",
        "customer.customerVatCheckCard.vatCheck": "Btw-controle",
        "customer.personManagementCard.addAnotherPerson": "Nog een persoon toevoegen",
        "customer.personManagementCard.createAndLinkPerson": "Persoon aanmaken en koppelen",
        "customer.personManagementCard.existingPerson": "Bestaande persoon",
        "customer.personManagementCard.function": "Functie",
        "customer.personManagementCard.noContactsLinkedYet": "Nog geen contactpersonen gekoppeld.",
        "customer.personManagementCard.selectAPerson": "Selecteer een persoon…",
        "customer.recurringManagementCard.addAnotherRecurring": "Nog een periodieke regel toevoegen",
        "dashboard.activeProjectsOverview.active": "Lopend",
        "dashboard.activeProjectsOverview.activeProjects": "Lopende projecten",
        "dashboard.activeProjectsOverview.allProjects": "Alle projecten",
        "dashboard.activeProjectsOverview.loadingProjects": "Projecten laden…",
        "dashboard.activeProjectsOverview.openProject": "Open project",
        "dashboard.activeProjectsOverview.percentageOfTheDuration": "% van de looptijd",
        "dashboard.activeProjectsOverview.projectsCouldNotBeLoaded": "Projecten konden niet worden geladen.",
        "dashboard.activeProjectsOverview.showAll": "Alles tonen",
        "dashboard.activeProjectsOverview.showFewer": "Minder tonen",
        "dashboard.activeProjectsOverview.thereAreCurrentlyNoActiveProjects": "Er zijn momenteel geen lopende projecten.",
        "dashboard.assetServicesCard.dueAssetServices": "Uit te voeren asset-services",
        "dashboard.assetServicesCard.loadFailed": "De asset-services konden niet worden geladen.",
        "dashboard.assetServicesCard.loading": "Asset-services laden…",
        "dashboard.assetServicesCard.noneDue": "Er zijn momenteel geen uit te voeren asset-services.",
        "dashboard.editor.addWidget": "Widget toevoegen",
        "dashboard.editor.configureWidget": "{{name}} instellen",
        "dashboard.editor.customize": "Dashboard aanpassen",
        "dashboard.editor.dragWidget": "{{name}} verplaatsen",
        "dashboard.editor.duplicateWidget": "{{name}} dupliceren",
        "dashboard.editor.emptyDescription": "Voeg een of meer widgets toe om je persoonlijke overzicht samen te stellen.",
        "dashboard.editor.emptyTitle": "Je dashboard is leeg",
        "dashboard.editor.gridColumns": "Responsive grid: {{count}} kolommen",
        "dashboard.editor.loadFailed": "Je dashboardconfiguratie kon niet worden geladen.",
        "dashboard.editor.loading": "Je dashboard laden…",
        "dashboard.editor.noSettings": "Deze widget heeft geen inhoudsinstellingen.",
        "dashboard.editor.removeWidget": "{{name}} verwijderen",
        "dashboard.editor.saveFailed": "Het dashboard kon niet worden opgeslagen.",
        "dashboard.editor.widgetActions": "Acties voor {{name}}",
        "dashboard.openInvoicesCard.accountNamesUnavailable": "De namen van opdrachtgevers konden niet worden geladen.",
        "dashboard.openInvoicesCard.due": "Vervalt {{date}}",
        "dashboard.openInvoicesCard.empty": "Er zijn geen openstaande facturen.",
        "dashboard.openInvoicesCard.openInvoices": "Alle facturen openen",
        "dashboard.openInvoicesCard.overdue": "Te laat sinds {{date}}",
        "dashboard.openInvoicesCard.payWhenPaid": "Betalen bij betaald",
        "dashboard.openInvoicesCard.title": "Open facturen",
        "dashboard.openInvoicesCard.unnamed": "Factuur zonder naam",
        "dashboard.pendingDocumentsCard.documents": "{{count}} document(en)",
        "dashboard.pendingDocumentsCard.empty": "Er zijn geen documenten om goed te keuren.",
        "dashboard.pendingDocumentsCard.loadFailed": "De goed te keuren documenten konden niet worden geladen.",
        "dashboard.pendingDocumentsCard.loading": "Goed te keuren documenten laden…",
        "dashboard.pendingDocumentsCard.openAccounts": "Alle accounts openen",
        "dashboard.pendingDocumentsCard.title": "Goed te keuren documenten",
        "dashboard.pendingHoursCard.empty": "Er zijn geen uren om goed te keuren.",
        "dashboard.pendingHoursCard.entries": "{{count}} urenregels",
        "dashboard.pendingHoursCard.loadFailed": "De goed te keuren uren konden niet worden geladen.",
        "dashboard.pendingHoursCard.loading": "Goed te keuren uren laden…",
        "dashboard.pendingHoursCard.oldest": "Oudste: {{date}}",
        "dashboard.pendingHoursCard.openProjects": "Alle projecten openen",
        "dashboard.pendingHoursCard.title": "Goed te keuren uren",
        "dashboard.upcomingAssetServicesCard.empty": "Er zijn geen assetservices gepland in de komende {{count}} dagen.",
        "dashboard.upcomingAssetServicesCard.loadFailed": "De aankomende assetservices konden niet worden geladen.",
        "dashboard.upcomingAssetServicesCard.loading": "Aankomende assetservices laden…",
        "dashboard.upcomingAssetServicesCard.openAssets": "Alle assets openen",
        "dashboard.upcomingAssetServicesCard.title": "Aankomende assetservices",
        "dashboard.workerClientBalanceCard.empty": "In deze periode zijn geen geregistreerde uren gevonden.",
        "dashboard.workerClientBalanceCard.intro": "Workers met de meest geconcentreerde verdeling staan bovenaan, gemeten over de afgelopen {{count}} dagen.",
        "dashboard.workerClientBalanceCard.loadFailed": "De urenverdeling kon niet worden geladen.",
        "dashboard.workerClientBalanceCard.loading": "Urenverdeling laden…",
        "dashboard.workerClientBalanceCard.openProjects": "Alle projecten openen",
        "dashboard.workerClientBalanceCard.signalOnly": "Deze urenverdeling is alleen een signaal. Voor de arbeidsrelatie onder de Wet DBA telt het geheel van alle omstandigheden.",
        "dashboard.workerClientBalanceCard.title": "Urenverdeling over opdrachtgevers",
        "dashboard.workerClientBalanceCard.total": "{{hours}} totaal",
        "dashboard.widgets.activeProjects.description": "Lopende projecten met looptijd, voortgang en bezetting.",
        "dashboard.widgets.activeProjects.title": "Lopende projecten",
        "dashboard.widgets.assetServices.description": "Onderhoudsintervallen die uitgevoerd moeten worden of te laat zijn.",
        "dashboard.widgets.assetServices.title": "Uit te voeren asset-services",
        "dashboard.widgets.openInvoices.description": "Definitieve facturen met een openstaand bedrag.",
        "dashboard.widgets.openInvoices.title": "Open facturen",
        "dashboard.widgets.orphanedPayments.description": "Inkomende betalingen die nog niet aan een factuur zijn gekoppeld.",
        "dashboard.widgets.orphanedPayments.title": "Niet-gekoppelde betalingen",
        "dashboard.widgets.outstanding.description": "Het totale openstaande factuurbedrag.",
        "dashboard.widgets.outstanding.title": "Openstaand",
        "dashboard.widgets.pendingDocuments.description": "Documenten van workers die nog moeten worden goedgekeurd.",
        "dashboard.widgets.pendingDocuments.title": "Goed te keuren documenten",
        "dashboard.widgets.pendingHours.description": "Geregistreerde uren die nog moeten worden goedgekeurd.",
        "dashboard.widgets.pendingHours.title": "Goed te keuren uren",
        "dashboard.widgets.recentCalls.description": "De meest recent ontvangen telefoongesprekken.",
        "dashboard.widgets.recentCalls.title": "Recente oproepen",
        "dashboard.widgets.revenue.description": "De omzet van deze week, deze maand, dit kwartaal of dit jaar.",
        "dashboard.widgets.revenue.title": "Omzet",
        "dashboard.widgets.salesAnalytics.description": "Omzet en uitgaven over een instelbare periode.",
        "dashboard.widgets.salesAnalytics.title": "Omzetanalyse",
        "dashboard.widgets.settings.items": "Aantal items",
        "dashboard.widgets.settings.daysBack": "Dagen terug",
        "dashboard.widgets.settings.daysAhead": "Dagen vooruit",
        "dashboard.widgets.settings.months": "Aantal maanden",
        "dashboard.widgets.settings.period": "Periode",
        "dashboard.widgets.settings.periodDays": "Periode in dagen",
        "dashboard.widgets.settings.projects": "Aantal projecten",
        "dashboard.widgets.settings.thisMonth": "Deze maand",
        "dashboard.widgets.settings.thisQuarter": "Dit kwartaal",
        "dashboard.widgets.settings.thisWeek": "Deze week",
        "dashboard.widgets.settings.thisYear": "Dit jaar",
        "dashboard.widgets.upcomingAssetServices.description": "Ingeschakelde assetservices die binnen een instelbaar aantal dagen gepland staan.",
        "dashboard.widgets.upcomingAssetServices.title": "Aankomende assetservices",
        "dashboard.widgets.unreadEmail.description": "De meest recente ongelezen inkomende gesprekken.",
        "dashboard.widgets.unreadEmail.title": "Ongelezen e-mail",
        "dashboard.widgets.workerClientBalance.description": "Verdeling van geregistreerde uren van workers over opdrachtgevers als Wet DBA-signaal.",
        "dashboard.widgets.workerClientBalance.title": "Urenverdeling over opdrachtgevers",
        "dashboard.orphanedPaymentsCard.noOrphanedPaymentsFound": "Geen niet-gekoppelde betalingen gevonden.",
        "dashboard.orphanedPaymentsCard.orphanedPayments": "Niet-gekoppelde betalingen",
        "dashboard.orphanedPaymentsCard.showAll": "Toon alle niet-gekoppelde betalingen",
        "dashboard.orphanedPaymentsCard.showSuggested": "Toon voorgestelde betalingen",
        "dashboard.revenueCard.previousMonth": "Vorige maand",
        "dashboard.revenueCard.previousWeek": "Vorige week",
        "dashboard.revenueCard.previousYear": "Vorig jaar",
        "dashboard.recentCallsCard.answered": "Beantwoord",
        "dashboard.recentCallsCard.blocked": "Geblokkeerd",
        "dashboard.recentCallsCard.enqueued": "In wachtrij",
        "dashboard.recentCallsCard.leftQueue": "Wachtrij verlaten",
        "dashboard.recentCallsCard.noCallsFound": "Geen oproepen gevonden.",
        "dashboard.recentCallsCard.outOfOffice": "Buiten kantoor",
        "dashboard.recentCallsCard.recentCalls": "Recente oproepen",
        "dashboard.salesAnalytics.analytics": "Analyse",
        "email.emailCard.cc": "Cc:",
        "email.channel.whatsapp": "WhatsApp",
        "email.attachment.loading": "PDF laden…",
        "email.attachment.download": "PDF downloaden",
        "email.attachment.loadFailed": "Deze PDF kon niet worden weergegeven. Sluit het voorbeeld en probeer het opnieuw.",
        "email.emailCard.actions": "Berichtacties",
        "email.emailCard.holdToDelete": "Houd 2 seconden ingedrukt om te verwijderen",
        "email.emailCard.deliveryFailed": "Bezorging mislukt.",
        "email.emailCard.queued": "In wachtrij voor verzending",
        "email.emailCard.retrying": "Verzending wordt opnieuw geprobeerd",
        "email.emailCard.failureReason": "Reden: {{reason}}",
        "email.emailCard.failureReasonUnavailable": "Voor deze e-mail is geen foutreden beschikbaar.",
        "email.emailCard.hideQuoted": "Citaat verbergen",
        "email.emailCard.markAsRead": "Markeren als gelezen",
        "email.markAsSpam": "Markeren als spam",
        "email.spamFailed": "Verplaatsen naar spam mislukt. Het bericht blijft in Office staan. Probeer het opnieuw.",
        "email.emailCard.read": "Gelezen",
        "email.emailCard.reply": "Beantwoorden",
        "email.emailCard.showQuoted": "Citaat tonen",
        "email.emailCard.ticket": "Ticket",
        "email.emailCard.unread": "Ongelezen",
        "email.emailCompose.chooseCc": "Kies CC",
        "email.emailCompose.chooseInvoice": "Kies factuur",
        "email.composer.context": "Berichtcontext",
        "email.composer.chooseTenant": "Kies tenant",
        "email.composer.unavailableTenant": "Oorspronkelijke tenant",
        "email.composer.unavailableAccount": "Oorspronkelijke relatie",
        "email.composer.noAccount": "Geen relatie gekoppeld",
        "email.composer.optional": "(optioneel)",
        "email.composer.accountHelp": "Deze relatie koppelt het gesprek. De gekozen ontvanger blijft behouden.",
        "email.composer.invoiceLinked": "Gekoppeld aan een factuur",
        "email.composer.replyingTo": "Antwoord op",
        "email.composer.showOriginal": "Toon oorspronkelijk bericht",
        "email.composer.hideOriginal": "Verberg oorspronkelijk bericht",
        "email.composer.originalMessage": "Oorspronkelijk bericht",
        "email.composer.reply": "Beantwoorden",
        "email.composer.newMessage": "Nieuw bericht",
        "email.composer.addCc": "CC toevoegen",
        "email.composer.loading": "Contacten en berichtcontext laden…",
        "email.composer.loadingFailed": "De composer kon niet worden geladen. Probeer opnieuw.",
        "email.composer.retry": "Opnieuw proberen",
        "email.composer.sending": "Versturen…",
        "email.composer.sendFailed": "Versturen mislukt. Je bericht en bijlagen zijn behouden.",
        "email.composer.ready": "Klaar om te versturen",
        "email.composer.queued": "Je bericht staat in de wachtrij voor verzending.",
        "email.composer.mailboxes": "Postvakken",
        "email.composer.recipientPlaceholder": "Zoek een naam of vul een e-mailadres in",
        "email.composer.noContacts": "Geen passende contacten",
        "email.composer.useAddress": "Gebruik {{address}}",
        "email.composer.attachments": "Bijlagen",
        "email.composer.addAttachment": "Bijlage toevoegen",
        "email.composer.addInvoice": "Factuur toevoegen",
        "email.composer.dropAttachments": "Laat bestanden hier los om ze toe te voegen.",
        "email.composer.preparingAttachment": "PDF voorbereiden…",
        "email.composer.attachmentFailed": "Deze bijlage kon niet worden voorbereid. Verwijder hem en probeer opnieuw.",
        "email.composer.removeAttachment": "Verwijder {{name}}",
        "email.composer.loadingInvoices": "Facturen laden…",
        "email.composer.invoicesFailed": "Facturen konden niet worden geladen.",
        "email.composer.noInvoices": "Geen facturen beschikbaar voor deze relatie en tenant.",
        "email.composer.recipientRequired": "Kies een ontvanger om te versturen.",
        "email.composer.recipientInvalid": "Vul een geldig e-mailadres in bij Aan.",
        "email.composer.ccInvalid": "Controleer de e-mailadressen in CC.",
        "email.composer.tenantRequired": "Kies een tenant bij de berichtcontext.",
        "email.composer.attachmentsReading": "Wacht tot alle bijlagen klaar zijn.",
        "email.composer.attachmentsFailed": "Verwijder de mislukte bijlage en voeg hem opnieuw toe.",
        "email.composer.messageRequired": "Vul een bericht in om te versturen.",
        "email.composer.clearRecipients": "Ontvangers wissen",
        "email.composer.contactResults": "{{count}} passende contacten.",
        "email.composer.menuGuidance": "Gebruik de pijltjestoetsen om een contact te kiezen. Enter selecteert en Escape sluit de lijst.",
        "email.composer.inputGuidance": "Typ om te zoeken of vul een e-mailadres in. Backspace verwijdert de gekozen ontvanger.",
        "email.composer.recipientsCleared": "Ontvangers gewist.",
        "email.composer.recipientRemoved": "{{address}} verwijderd.",
        "email.composer.recipientSelected": "{{address}} geselecteerd.",
        "email.composer.removeRecipient": "Verwijder {{address}}",
        "email.emailInbox.loadingOlder": "Oudere e-mails laden",
        "email.emailInbox.searching": "E-mails doorzoeken…",
        "email.emailInbox.resultsUntil": "Dit zijn de resultaten tot {{date}}",
        "email.emailInbox.searchFailed": "E-mails zoeken is mislukt. Eerder gevonden resultaten blijven staan.",
        "email.emailInbox.retrySearch": "Zoeken opnieuw proberen",
        "email.emailInbox.searchFurther": "Zoek verder",
        "email.emailInbox.noSearchResults": "Geen e-mails gevonden.",
        "email.emailInbox.selected": "geselecteerd",
        "email.emailSideBar.inbox": "Postvak IN",
        "email.emailSideBar.labels": "Labels",
        "email.emailSideBar.sent": "Verzonden",
        "email.emailSideBar.starred": "Met ster",
        "email.emailView.emails": "E-mails",
        "email.unreadEmailCard.noUnreadConversations": "Geen ongelezen gesprekken.",
        "email.unreadEmailCard.unreadConversations": "Ongelezen gesprekken",
        "expenses.expenseAddButton.cancelAddingExpense": "Uitgave toevoegen annuleren",
        "expenses.expenseAddButton.chooseTenant": "Kies tenant…",
        "expenses.expenseAddButton.continue": "Doorgaan",
        "expenses.expenseAddForm.addNewExpense": "Nieuwe uitgave toevoegen",
        "expenses.expenseAddForm.orChooseExistingSupplier": "Of kies een bestaande leverancier:",
        "expenses.expenseAddForm.supplierVatNumber": "Btw-nummer leverancier",
        "expenses.expenseDetail.allExpensesToName": "Alle uitgaven aan {{name}}",
        "expenses.expenseDetail.allExtractedData": "Alle geëxtraheerde gegevens",
        "expenses.expenseDetail.acceptMatch": "Koppelen en toepassen",
        "expenses.expenseDetail.applyOcr": "OCR toepassen",
        "expenses.expenseDetail.applyOcrFailed": "De geselecteerde OCR-waarden konden niet worden opgeslagen. Probeer het opnieuw.",
        "expenses.expenseDetail.attachments": "Bijlagen",
        "expenses.expenseDetail.changesToApply": "Wijzigingen die worden toegepast",
        "expenses.expenseDetail.chooseOcrFields": "Kies de waarden die je wilt toepassen",
        "expenses.expenseDetail.confidence": "Zekerheid",
        "expenses.expenseDetail.confirmApplyOcr": "Bevestigen en toepassen",
        "expenses.expenseDetail.currentValue": "Huidige waarde",
        "expenses.expenseDetail.deleteAttachment": "Bijlage verwijderen",
        "expenses.expenseDetail.deleteAttachmentFailed": "De bijlage kon niet worden verwijderd. Probeer het opnieuw.",
        "expenses.expenseDetail.deleteAttachmentName": "{{name}} verwijderen",
        "expenses.expenseDetail.evidence": "Herkomst",
        "expenses.expenseDetail.extractedValue": "Geëxtraheerde waarde",
        "expenses.expenseDetail.loadAttachmentsFailed": "De bonnetjes en bijlagen konden niet worden geladen. Probeer het opnieuw.",
        "expenses.expenseDetail.invoiceMatches": "Voorgestelde factuurmatches",
        "expenses.expenseDetail.match": "match",
        "expenses.expenseDetail.noAttachments": "Er zijn nog geen bonnetjes of bijlagen toegevoegd.",
        "expenses.expenseDetail.openInNewTab": "Openen in nieuw tabblad",
        "expenses.expenseDetail.ocrStatus": "OCR: {{status}}",
        "expenses.expenseDetail.ocrField": "Veld",
        "expenses.expenseDetail.ocrFieldIban": "IBAN",
        "expenses.expenseDetail.ocrFieldInvoiceDate": "Factuurdatum",
        "expenses.expenseDetail.ocrFieldInvoiceNumber": "Factuurnummer",
        "expenses.expenseDetail.ocrFieldKvkNumber": "KvK-nummer",
        "expenses.expenseDetail.ocrFieldSupplierEmail": "E-mail leverancier",
        "expenses.expenseDetail.ocrFieldSupplierName": "Naam leverancier",
        "expenses.expenseDetail.ocrFieldTax": "Btw-bedrag",
        "expenses.expenseDetail.ocrFieldTotal": "Totaalbedrag",
        "expenses.expenseDetail.ocrFieldVatNumber": "Btw-nummer",
        "expenses.expenseDetail.ocrReviewTitle": "OCR controleren — {{name}}",
        "expenses.expenseDetail.ocrWarnings": "OCR-waarschuwingen",
        "expenses.expenseDetail.noOcrChangesToApply": "Geen geëxtraheerde waarden voldoen aan de regels voor automatisch toepassen.",
        "expenses.expenseDetail.noOcrFieldsSelected": "Selecteer hieronder één of meer waarden. Er verandert niets totdat je de selectie toepast.",
        "expenses.expenseDetail.ocrFieldsSelected": "{{count}} waarde(n) geselecteerd. Alleen deze waarden worden gewijzigd.",
        "expenses.expenseDetail.applySelectedOcr": "Selectie toepassen ({{count}})",
        "expenses.expenseDetail.selectOcrField": "{{field}} toepassen",
        "expenses.expenseDetail.receiptsAndAttachments": "Bonnetjes en bijlagen",
        "expenses.expenseDetail.supplierName": "Naam leverancier",
        "expenses.expenseDetail.supplierVat": "Btw leverancier",
        "expenses.expenseDetail.uploadAttachmentFailed": "De bijlage kon niet worden geüpload. Probeer het opnieuw.",
        "expenses.expenseDetail.uploadReceipt": "Voeg een bonnetje of andere bijlage toe",
        "expenses.expenseDetail.reviewOcr": "OCR controleren",
        "expenses.expenseDetail.taxLines": "Btw-regels",
        "expenses.expenseDetail.viewAttachment": "Bekijken",
        "expenses.expenseDetail.viewAttachmentFailed": "De bijlage kon niet worden geopend. Probeer het opnieuw.",
        "expenses.expenseDetail.viewAttachmentName": "{{name}} bekijken",
        "expenses.expenseEditForm.editExpense": "Uitgave bewerken",
        "expenses.expenseEditForm.saveEdit": "Wijzigingen opslaan",
        "expenses.expenseRowSupplier.currentExpense": "Huidige uitgave",
        "expenses.expenses.expenseOverview": "Uitgavenoverzicht",
        "expenses.expenses.expensesSuppliersAndLedgerAllocation": "Uitgaven, leveranciers en grootboektoewijzing.",
        "expenses.expenses.noExpensesFound": "Geen uitgaven gevonden.",
        "expenses.expenses.searchExpenseOrSupplier": "Zoek op uitgave of leverancier…",
        "expenses.expenses.searchExpenses": "Uitgaven zoeken",
        "expenses.expenseSuggestedEmails.onlyConversationsWithAttachmentsAreShown": "Alleen gesprekken met bijlagen worden getoond",
        "expenses.expenseSuggestedEmails.suggestedConversations": "Voorgestelde gesprekken",
        "expenses.supplierDetail.alternativeNames": "Alternatieve namen",
        "expenses.supplierDetail.editSupplier": "Leverancier bewerken",
        "expenses.supplierDetail.linkToExistingSupplier": "Koppelen aan bestaande leverancier",
        "expenses.supplierDetail.saveSupplier": "Leverancier opslaan",
        "expenses.supplierDetail.saving": "Opslaan...",
        "expenses.supplierDetail.supplierCouldNotBeSaved": "Leverancier kon niet worden opgeslagen",
        "expenses.supplierDetail.supplierNotFound": "Leverancier niet gevonden.",
        "expenses.supplierDetail.supplierSaved": "Leverancier opgeslagen",
        "expenses.supplierDetail.totalAllTime": "Totaal aller tijden",
        "expenses.supplierDetail.totalThisQuarter": "Totaal dit kwartaal",
        "expenses.supplierDetail.totalThisYear": "Totaal dit jaar",
        "expenses.supplierDetail.transactions": "Transacties",
        "expenses.supplierDetail.vatThisQuarter": "Btw dit kwartaal",
        "expenses.supplierDetail.vatThisYear": "Btw dit jaar",
        "invoice.invoiceAddButton.chooseACustomer": "Kies een klant",
        "invoice.invoiceAddButton.chooseACustomer.e590cbb": "Kies een klant.",
        "invoice.invoiceAddButton.createInvoice": "Factuur aanmaken",
        "invoice.invoiceAddButton.createQuote": "Offerte aanmaken",
        "invoice.invoiceAddButton.newInvoiceOrQuote": "Nieuwe factuur of offerte",
        "invoice.invoiceAddButton.newInvoiceQuote": "Nieuwe factuur / offerte",
        "invoice.invoiceAddButton.paymentDetailsAlwaysComeFromTheTenant": "Betaalgegevens komen altijd van de tenant.",
        "invoice.invoiceAddButton.tenantDefault": "Tenant (standaard)",
        "invoice.invoiceContentAddCard.addContent": "Regel toevoegen",
        "invoice.invoiceContentAddCard.instructions": "Selecteer een dienst of voeg een eigen regel toe",
        "invoice.invoiceContentAddCard.service": "Dienst",
        "invoice.invoiceContentAddCard.noTypeFound": "Geen type gevonden",
        "invoice.invoiceContentAddCard.searchOrEnterAType": "Zoek of typ type...",
        "invoice.invoiceContentAddCard.typeNameAmountPriceAndAVatRateBetween0PercentageAnd100PercentageAreMandatory": "Type, naam, aantal, prijs en een btw-tarief tussen 0% en 100% zijn verplicht",
        "invoice.invoiceContentAddCard.useValue": "Gebruik \"{{value}}\"",
        "invoice.invoiceContentAddCard.vatPercentage": "Btw %",
        "invoice.invoiceContentCard.item": "Regel",
        "invoice.invoiceContentCard.reverseCharged": "Verlegd",
        "invoice.invoiceContentCard.subtotal": "Subtotaal",
        "invoice.invoiceContentCard.vatReverseCharged": "Btw verlegd",
        "invoice.invoiceEmails.sentMailsCouldNotBeLoaded": "Verzonden e-mails konden niet worden geladen.",
        "invoice.invoiceEmails.sentMails": "Verzonden e-mails",
        "invoice.invoiceInfoSummaryCard.download": "Downloaden",
        "invoice.invoiceInfoSummaryCard.invoiceNumber": "Factuurnummer",
        "invoice.invoiceInfoSummaryCard.link": "link",
        "invoice.invoiceInfoSummaryCard.payLink": "Betaallink",
        "invoice.invoiceInfoSummaryCard.paymentDeadline": "Betaaltermijn",
        "invoice.invoiceInfoSummaryCard.pdfDownload": "Pdf downloaden",
        "invoice.invoiceRowIndex.deadline": "Vervaldatum",
        "invoice.invoiceRowIndex.invoice": "factuur",
        "invoice.invoiceRowIndex.paymentTerm": "Betaaltermijn",
        "invoice.invoiceRowIndex.viewName": "{{name}} bekijken",
        "invoice.invoices.drafts": "Concepten",
        "invoice.invoices.invoiceOverview": "Factuuroverzicht",
        "invoice.invoices.invoicesQuotesAndPaymentStatus": "Facturen, offertes en betaalstatus.",
        "invoice.invoices.noInvoicesFound": "Geen facturen gevonden.",
        "invoice.invoices.quotes": "Offertes",
        "invoice.invoices.searchInvoiceOrAccount": "Zoek op factuur of relatie…",
        "invoice.invoices.searchInvoices": "Facturen zoeken",
        "invoice.invoices.unpaid": "Onbetaald",
        "invoice.invoiceStatusCard.addManualPayment": "Handmatige betaling toevoegen",
        "invoice.invoiceStatusCard.convertToInvoice": "Omzetten naar factuur",
        "invoice.invoiceStatusCard.convertToQuote": "Omzetten naar offerte",
        "invoice.invoiceStatusCard.deleteDraft": "Concept verwijderen",
        "invoice.invoiceStatusCard.deleteQuote": "Offerte verwijderen",
        "invoice.invoiceStatusCard.enterAnAmountGreaterThanZero": "Voer een bedrag groter dan nul in.",
        "invoice.invoiceStatusCard.enterAPaymentDate": "Voer een betaaldatum in.",
        "invoice.invoiceStatusCard.finalizeInvoice": "Factuur definitief maken",
        "invoice.invoiceStatusCard.ibanOptional": "IBAN (optioneel)",
        "invoice.invoiceStatusCard.notPaid": "Niet betaald",
        "invoice.invoiceStatusCard.savePayment": "Betaling opslaan",
        "invoice.invoiceStatusCard.thePaymentCouldNotBeAdded": "De betaling kon niet worden toegevoegd.",
        "persons.personDetail.accountRelationLinked": "Relatie gekoppeld.",
        "persons.personDetail.accountRelationRemoved": "Relatiekoppeling verwijderd.",
        "persons.personDetail.addAccountRelation": "Relatie koppelen",
        "persons.personDetail.authentication": "Authenticatie",
        "persons.personDetail.authenticationCreatedThePasswordWasSentToEmail": "Login aangemaakt. Het wachtwoord is verzonden naar {{email}}.",
        "persons.personDetail.backToPersons": "Terug naar personen",
        "persons.personDetail.call": "Bellen",
        "persons.personDetail.couldNotCreateAuthentication": "Login kon niet worden aangemaakt.",
        "persons.personDetail.couldNotLinkThisAccount": "Deze relatie kon niet worden gekoppeld.",
        "persons.personDetail.couldNotLoadPerson": "De gegevens van deze persoon konden niet worden geladen. Probeer opnieuw.",
        "persons.persons.couldNotLoadPersons": "De personen konden niet worden geladen. Probeer opnieuw.",
        "persons.personDetail.couldNotRemoveThisRelation": "Deze koppeling kon niet worden verwijderd.",
        "persons.personDetail.couldNotSaveThisPerson": "Deze persoon kon niet worden opgeslagen.",
        "persons.personDetail.customerPortalLanguage": "Taal klantportaal",
        "persons.personDetail.emailAddressVerified": "E-mailadres geverifieerd",
        "persons.personDetail.emailAddressVerifiedHelp": "Geeft deze persoon toegang om hosted DNS-zones in Sheepname aan te maken.",
        "persons.personDetail.firstNameIsRequired": "Voornaam is verplicht.",
        "persons.personDetail.loadingPerson": "Persoon laden...",
        "persons.personDetail.loadingRelations": "Relaties laden…",
        "persons.personDetail.noAccountRelationsLinkedYet": "Nog geen relaties gekoppeld.",
        "persons.personDetail.noAuthentication": "Geen authenticatie",
        "persons.personDetail.noMatchingAccounts": "Geen overeenkomende relaties",
        "persons.personDetail.noTitleSpecified": "Geen functie opgegeven",
        "persons.personDetail.personDetailsAndAccountRelations": "Persoonsgegevens en gekoppelde relaties.",
        "persons.personDetail.personNotFound": "Persoon niet gevonden",
        "persons.personDetail.personSaved": "Persoon opgeslagen.",
        "persons.personDetail.reset": "Herstellen",
        "persons.personDetail.titleFunction": "Titel / functie",
        "persons.persons.loadingPersons": "Personen laden...",
        "persons.persons.manageContactsAndTheirLinkedRelations": "Beheer contactpersonen en hun gekoppelde relaties.",
        "persons.persons.noPersonsFound": "Geen personen gevonden.",
        "persons.persons.noRelations": "Geen relaties",
        "persons.persons.personOverview": "Personenoverzicht",
        "persons.persons.searchByNameEmailPhoneOrRelation": "Zoek op naam, e-mail, telefoon of relatie...",
        "persons.persons.searchPersons": "Personen zoeken",
        "persons.persons.statusUnavailable": "Status niet beschikbaar",
        "persons.persons.theAuthenticationServiceReturnedNoStatus": "De authenticatieservice gaf geen status terug",
        "persons.persons.withMfa": "Met MFA",
        "persons.persons.withoutLogin": "Zonder login",
        "persons.persons.withoutMfa": "Zonder MFA",
        "projects.contractTemplateEditor.contractTemplates": "Contracttemplates",
        "projects.contractTemplateEditor.deleteField": "Veld verwijderen",
        "projects.contractTemplateEditor.emailAfterSigning": "E-mail na tekenen",
        "projects.contractTemplateEditor.fieldSettings": "Veldinstellingen",
        "projects.contractTemplateEditor.fontSize": "Lettergrootte",
        "projects.contractTemplateEditor.heightPercentage": "Hoogte %",
        "projects.contractTemplateEditor.keepFields": "Velden behouden",
        "projects.contractTemplateEditor.loadingTemplateForTheSelectedTenant": "Template voor geselecteerde tenant laden…",
        "projects.contractTemplateEditor.manageTheWorkerContractAndResponsibleContractSeparatelyForEachWorkerProjectRelationship": "Beheer apart het contract voor de worker en het contract voor de responsible per worker-projectrelatie.",
        "projects.contractTemplateEditor.next": "Volgende",
        "projects.contractTemplateEditor.pagePageCount": "Pagina {{page}} / {{count}}",
        "projects.contractTemplateEditor.pdfFilename": "PDF-bestandsnaam",
        "projects.contractTemplateEditor.prefillData": "Prefill-data",
        "projects.contractTemplateEditor.prefillField": "Prefill-veld",
        "projects.contractTemplateEditor.previous": "Vorige",
        "projects.contractTemplateEditor.preservedFieldsKeepTheirPageAndPosition": "Behouden velden blijven op dezelfde pagina en positie staan. Controleer na het uploaden of ze nog goed staan.",
        "projects.contractTemplateEditor.removeFields": "Velden verwijderen",
        "projects.contractTemplateEditor.repeatOnEveryPage": "Op iedere pagina herhalen",
        "projects.contractTemplateEditor.replacePdf": "PDF vervangen",
        "projects.contractTemplateEditor.replacePdfFieldsQuestion": "Deze template bevat al velden. Wil je ze op de nieuwe PDF laten staan?",
        "projects.contractTemplateEditor.saveTemplate": "Template opslaan",
        "projects.contractTemplateEditor.selectAFieldOnThePdfToConfigureIt": "Selecteer een veld op de PDF om het te configureren.",
        "projects.contractTemplateEditor.signatureField": "Handtekeningveld",
        "projects.contractTemplateEditor.signatureCopy": "Paraaf (handtekening)",
        "projects.contractTemplateEditor.signatureCopyField": "Paraafveld",
        "projects.contractTemplateEditor.templateFor": "Template voor",
        "projects.contractTemplateEditor.templateName": "Templatenaam",
        "projects.contractTemplateEditor.uploadPdf": "PDF uploaden",
        "projects.contractTemplateEditor.uploadTheBaseContractAsAPdf": "Upload het basiscontract als PDF",
        "projects.contractTemplateEditor.widthPercentage": "Breedte %",
        "projects.contractTemplateEditor.workerSignature": "Handtekening werker",
        "projects.contractTemplateEditor.youCanThenPlaceFieldsDirectlyOnThePage": "Daarna kun je velden rechtstreeks op de pagina plaatsen.",
        "projects.projectBudgetProgress.costsWithoutAConfiguredBudget": "Kosten zonder ingesteld budget",
        "projects.projectBudgetProgress.invoicedCosts": "Gefactureerde kosten",
        "projects.projectBudgetProgress.noBudgetUsedYet": "Nog geen budget gebruikt",
        "projects.projectBudgetProgress.overBudget": "overschreden",
        "projects.projectBudgetProgress.percentagePercentageOfTheBudgetUsed": "{{percentage}}% van het budget gebruikt",
        "projects.projectCreate.budgetEur": "Budget (EUR)",
        "projects.projectCreate.chooseATenant": "Kies een tenant…",
        "projects.projectCreate.createProject": "Project aanmaken",
        "projects.projectCreate.creating": "Aanmaken…",
        "projects.projectCreate.endDate": "Einddatum",
        "projects.projectCreate.endDateMustBeOnOrAfterTheStartDate": "De einddatum moet op of na de startdatum liggen.",
        "projects.projectCreate.enterAValidNonNegativeBudget": "Voer een geldig budget van nul of hoger in.",
        "projects.projectCreate.enterTheAmountInEurosItIsStoredAccuratelyInCents": "Voer het bedrag in euro's in; het wordt nauwkeurig in centen opgeslagen.",
        "projects.projectCreate.forExampleOfficeRenovation": "Bijvoorbeeld: kantoorrenovatie",
        "projects.projectCreate.projectCouldNotBeCreated": "Project kon niet worden aangemaakt.",
        "projects.projectCreate.projectDetails": "Projectgegevens",
        "projects.projectCreate.selectWorkersAndProjectResponsibles": "Selecteer medewerkers en projectverantwoordelijken.",
        "projects.projectCreate.startDate": "Startdatum",
        "projects.projectCreate.tenantNameStartDateAndEndDateAreRequired": "Tenant, naam, startdatum en einddatum zijn verplicht.",
        "projects.projectCreate.tenantsOrAccountsCouldNotBeLoaded": "Tenants of relaties konden niet worden geladen.",
        "projects.projectCreate.tenantsCouldNotBeLoaded": "Tenants konden niet worden geladen.",
        "projects.projectDetail.accountDefault": "Accountdefault:",
        "projects.projectDetail.addToProject": "Toevoegen aan project",
        "projects.projectDetail.addWorker": "Medewerker toevoegen",
        "projects.projectDetail.addressSearchFailed": "Adres zoeken is tijdelijk niet beschikbaar.",
        "projects.projectDetail.addressSearchPlaceholder": "Straat, huisnummer, plaats of postcode",
        "projects.projectDetail.agreement": "Afspraak",
        "projects.projectDetail.budgetEuro": "Budget (€)",
        "projects.projectDetail.cancel": "Annuleren",
        "projects.projectDetail.checkTheProjectNameAndProjectPeriod": "Controleer de projectnaam en de projectperiode.",
        "projects.projectDetail.chooseAnAccount": "Kies een account…",
        "projects.projectDetail.clear": "Wissen",
        "projects.projectDetail.clickTheMapOrDragThePin": "Klik op de kaart of versleep de pin.",
        "projects.projectDetail.contract": "Contract",
        "projects.projectDetail.customHourlyRate": "Afwijkend uurtarief",
        "projects.projectDetail.customPlatformFee": "Afwijkende platformfee",
        "projects.projectDetail.customPlatformFeeType": "Type afwijkende platformfee",
        "projects.projectDetail.customRates": "Afwijkende tarieven",
        "projects.projectDetail.deleteThisDocument": "Dit document verwijderen?",
        "projects.projectDetail.documentCouldNotBeDeleted": "Document kon niet worden verwijderd.",
        "projects.projectDetail.documentCouldNotBeOpened": "Document kon niet worden geopend.",
        "projects.projectDetail.documentCouldNotBeUploaded": "Document kon niet worden geüpload.",
        "projects.projectDetail.documentUploaded": "Document geüpload.",
        "projects.projectDetail.edit": "Aanpassen",
        "projects.projectDetail.end": "Einde",
        "projects.projectDetail.endDate": "Einddatum",
        "projects.projectDetail.fixedAmountPerHour": "Vast bedrag per uur",
        "projects.projectDetail.forExampleEngineerOrProjectLead": "Bijvoorbeeld: monteur of projectleider",
        "projects.projectDetail.noContractsOrAgreementsYet": "Nog geen contracten of afspraken.",
        "projects.projectDetail.noAddressesFound": "Geen overeenkomende adressen gevonden.",
        "projects.projectDetail.notAssignedYet": "Nog niet toegewezen",
        "projects.projectDetail.noWorkersLinkedYet": "Nog geen medewerkers gekoppeld.",
        "projects.projectDetail.onlyPdfDocumentsAreAllowed": "Alleen PDF-documenten zijn toegestaan.",
        "projects.projectDetail.other": "Overig",
        "projects.projectDetail.percentageOfHourlyRate": "Percentage van uurtarief",
        "projects.projectDetail.percentagePercentageOfTheDurationElapsed": "{{percentage}}% van de looptijd verstreken",
        "projects.projectDetail.perHour": "per uur",
        "projects.projectDetail.projectCompleted": "Project voltooid",
        "projects.projectDetail.projectCouldNotBeLoaded": "Project kon niet worden geladen.",
        "projects.projectDetail.projectCouldNotBeSaved": "Project kon niet worden opgeslagen.",
        "projects.projectDetail.projectDetailsSaved": "Projectgegevens opgeslagen.",
        "projects.projectDetail.projectHasNotStartedYet": "Project is nog niet gestart",
        "projects.projectDetail.projectLocationCouldNotBeSaved": "Projectlocatie kon niet worden opgeslagen.",
        "projects.projectDetail.projects": "Projecten",
        "projects.projectDetail.projectSpecificRoleAvailableInContractTemplatesAsField": "Projectspecifieke rol; beschikbaar in contracttemplates als {{field}}.",
        "projects.projectDetail.radiusAroundThePin": "Radius rond de pin",
        "projects.projectDetail.removeWorkerProjectRelation": "Verwijderen uit project",
        "projects.projectDetail.removeWorkerProjectRelationConfirm": "{{name}} uit dit project verwijderen? De bijbehorende contracten en geregistreerde uren worden ook definitief verwijderd.",
        "projects.projectDetail.removeWorkerProjectRelationFor": "{{name}} uit dit project verwijderen",
        "projects.projectDetail.responsibleAccount": "Verantwoordelijke account",
        "projects.projectDetail.responsibleAccountCouldNotBeSaved": "Verantwoordelijke kon niet worden opgeslagen.",
        "projects.projectDetail.responsibleAccountSaved": "Verantwoordelijke account opgeslagen.",
        "projects.projectDetail.saveLocation": "Locatie opslaan",
        "projects.projectDetail.searchAddress": "Zoeken op adres",
        "projects.projectDetail.start": "Start",
        "projects.projectDetail.startDate": "Startdatum",
        "projects.projectDetail.theHoursOverviewCouldNotBeRefreshed": "Het urenoverzicht kon niet worden vernieuwd.",
        "projects.projectDetail.ultimatelyResponsibleForThisProject": "Eindverantwoordelijk voor dit project.",
        "projects.projectDetail.visibleInternallyOnlyWithoutAnOverrideTheAccountRatesApply": "Alleen intern zichtbaar. Zonder override gelden de tarieven van het account.",
        "projects.projectDetail.workerCouldNotBeAdded": "Medewerker kon niet worden toegevoegd.",
        "projects.projectDetail.noWorkerRoleAssigned": "Geen rol ingesteld",
        "projects.projectDetail.workerProjectSettingsCouldNotBeSaved": "Worker-projectinstellingen konden niet worden opgeslagen.",
        "projects.projectDetail.workerProjectSettingsSaved": "Worker-projectinstellingen opgeslagen.",
        "projects.projectDetail.workerProjectRelationCouldNotBeRemoved": "De worker-projectkoppeling kon niet worden verwijderd.",
        "projects.projectDetail.workerProjectRelationRemoved": "{{name}} is samen met de bijbehorende contracten uit het project verwijderd.",
        "projects.projectDetail.workerRole": "Rol binnen project",
        "projects.projectDetail.workerRoleRequiredForContracts": "Verplicht. Deze rol wordt direct in de gegenereerde contracten opgenomen.",
        "projects.projectHoursOverview.allWorkersRemainVisibleEvenWhenTheyHaveNotEnteredAnythingThisWeek": "Alle workers blijven zichtbaar, ook wanneer zij deze week niets hebben ingevuld.",
        "projects.projectHoursOverview.approved": "Goedgekeurd",
        "projects.projectHoursOverview.hoursEntered": "Uren ingevuld",
        "projects.projectHoursOverview.nextWeek": "Volgende week",
        "projects.projectHoursOverview.noHours": "Geen uren",
        "projects.projectHoursOverview.noHoursEntered": "Geen uren ingevuld",
        "projects.projectHoursOverview.notStartedYet": "Nog niet gestart",
        "projects.projectHoursOverview.noWorkersLinkedYet": "Nog geen workers gekoppeld.",
        "projects.projectHoursOverview.outsideProjectPeriod": "Buiten projectperiode",
        "projects.projectHoursOverview.outsideTheProjectPeriod": "Buiten de projectperiode",
        "projects.projectHoursOverview.pending": "in behandeling",
        "projects.projectHoursOverview.pendingApproval": "Pending approval",
        "projects.projectHoursOverview.previousWeek": "Vorige week",
        "projects.projectHoursOverview.refresh": "Vernieuwen",
        "projects.projectHoursOverview.thisWeek": "Deze week",
        "projects.projectHoursOverview.thisWeekHasNotStartedYet": "Deze week is nog niet gestart",
        "projects.projectHoursOverview.total": "Totaal",
        "projects.projectHoursOverview.totalThisWeek": "totaal deze week",
        "projects.projectInvoicesCard.noHoursHaveBeenInvoicedForThisProjectYet": "Nog geen uren voor dit project gefactureerd.",
        "projects.projectPayoutOverview.checkAmount": "Controleer bedrag",
        "projects.projectPayoutOverview.currencyNotSupported": "{{count}} uitbetaling(en) gebruiken een andere valuta dan EUR en kunnen niet in een SEPA-betaalbestand worden opgenomen.",
        "projects.projectPayoutOverview.downloadFailed": "Het betaalbestand kon niet worden gedownload.",
        "projects.projectPayoutOverview.downloadPaymentFile": "Betaalbestand downloaden",
        "projects.projectPayoutOverview.draftInvoices": "{{count}} uitbetaling(en) bevatten nog een conceptfactuur.",
        "projects.projectPayoutOverview.excluded": "Uitgesloten",
        "projects.projectPayoutOverview.explanation": "Het SEPA-bestand combineert alle projecten in de gekozen week en bevat één bankoverschrijving per workerfactuur. De platformfee wordt ingehouden en de naam van de workerfactuur wordt als betalingskenmerk gebruikt.",
        "projects.projectPayoutOverview.feeMissing": "Fee ontbreekt",
        "projects.projectPayoutOverview.gross": "Bruto",
        "projects.projectPayoutOverview.hoursPending": "Uren pending",
        "projects.projectPayoutOverview.ibanMissing": "IBAN ontbreekt",
        "projects.projectPayoutOverview.invalidNetAmount": "{{count}} uitbetaling(en) hebben een nettobedrag van nul of lager.",
        "projects.projectPayoutOverview.invoiceWeekMismatch": "De volgende factuurnamen komen niet overeen met geselecteerde week {{week}}:",
        "projects.projectPayoutOverview.includePayment": "Betaling {{payment}} opnemen",
        "projects.projectPayoutOverview.includePaymentColumn": "Opnemen in betaalbestand",
        "projects.projectPayoutOverview.lastWeek": "Vorige week",
        "projects.projectPayoutOverview.markAsPaid": "Markeren als betaald",
        "projects.projectPayoutOverview.markPaidFailed": "Niet alle geselecteerde facturen konden als betaald worden gemarkeerd. Opgeslagen betalingen blijven behouden; probeer opnieuw om de resterende facturen af te handelen.",
        "projects.projectPayoutOverview.missingPlatformFee": "Bij {{count}} workerfactuur(en) ontbreekt de bijbehorende platform-feefactuur.",
        "projects.projectPayoutOverview.multipleTenants": "Projecten van verschillende tenants kunnen niet in één betaalbestand worden gecombineerd.",
        "projects.projectPayoutOverview.net": "Netto",
        "projects.projectPayoutOverview.netToPay": "netto uit te betalen",
        "projects.projectPayoutOverview.nextWeek": "Volgende week",
        "projects.projectPayoutOverview.noInvoice": "Geen factuur",
        "projects.projectPayoutOverview.noPayments": "Voor deze week zijn geen projectfacturen of pending uren gevonden.",
        "projects.projectPayoutOverview.notEntered": "Niet ingevuld",
        "projects.projectPayoutOverview.pendingHours": "Er staan nog {{count}} urenregel(s) op pending approval.",
        "projects.projectPayoutOverview.plannedFor": "Geplande uitbetaling: {{date}}",
        "projects.projectPayoutOverview.platformFee": "Platformfee",
        "projects.projectPayoutOverview.previousWeek": "Vorige week",
        "projects.projectPayoutOverview.ready": "{{count}} betaling(en) staan klaar voor het SEPA-betaalbestand.",
        "projects.projectPayoutOverview.readyForPayment": "Klaar voor betaling",
        "projects.projectPayoutOverview.selectAllPayments": "Alle betalingen",
        "projects.projectPayoutOverview.tenantIbanMissing": "Vul in de facturatie-instellingen van de tenant een geldige IBAN in voordat je een betaalbestand downloadt.",
        "projects.projectPayoutOverview.title": "Wekelijks betaaloverzicht voor alle projecten",
        "projects.projectPayoutOverview.weekLabel": "Week {{week}}, {{year}}",
        "projects.projectPayoutOverview.workerInvoice": "Workerfactuur",
        "projects.projectPayoutOverview.workerPaidFeeUnpaid": "De workerfactuur is betaald, maar de platformfeefactuur staat nog open.",
        "projects.projectPayoutOverview.workersWithInvalidIban": "{{count}} worker(s) hebben een ongeldige IBAN: {{workers}}.",
        "projects.projectPayoutOverview.workersWithoutIban": "{{count}} worker(s) hebben geen IBAN ingevuld: {{workers}}.",
        "projects.projectPayments.backToProjects": "Terug naar projecten",
        "projects.projectPayments.description": "Maak één wekelijks betaalbestand voor workerfacturen over alle projecten.",
        "projects.projectPayments.loadFailed": "Het wekelijkse betaaloverzicht kon niet worden geladen.",
        "projects.projectPayments.loading": "Wekelijkse betalingen laden…",
        "projects.projectPayments.title": "Wekelijkse betalingen",
        "projects.projects.active": "Actief",
        "projects.projects.completed": "Voltooid",
        "projects.projects.contractTemplate": "Contracttemplate",
        "projects.projects.loadingProjects": "Projecten laden…",
        "projects.projects.noProjectsFound": "Geen projecten gevonden.",
        "projects.projects.noWorkers": "Geen medewerkers",
        "projects.projects.projectOverview": "Projectoverzicht",
        "projects.projects.projectsWorkersAndContractStatus": "Projecten, medewerkers en contractstatus.",
        "projects.projects.searchProjects": "Projecten zoeken",
        "projects.projects.searchProjects.1334959": "Projecten zoeken…",
        "projects.projects.upcoming": "Aankomend",
        "projects.projects.weeklyPayments": "Wekelijkse betalingen",
        "services.addServiceForm.addingServiceHasFailed": "Service toevoegen is mislukt",
        "services.checksStatusCard.checksStatus": "Status controles",
        "services.serviceDetailPage.editService": "Service bewerken",
        "services.serviceDetailPage.liveGraphic": "Live grafiek",
        "services.serviceEditForm.savingServiceHasFailed": "Service opslaan is mislukt",
        "services.serviceStatusBanner.allSystemsOperational": "Alle systemen operationeel",
        "services.serviceStatusBanner.minorServiceDisruptions": "Kleine serviceverstoringen",
        "taxes.taxes.expensesEx": "Uitgaven excl.",
        "taxes.taxes.expensesIncl": "Uitgaven incl.",
        "taxes.taxes.noExpensesFound": "Geen uitgaven gevonden",
        "taxes.taxes.noYearsFound": "Geen jaren gevonden",
        "taxes.taxes.perGrootboekregel": "per grootboekregel",
        "taxes.taxes.perQuarter": "per kwartaal",
        "taxes.taxes.quarter": "Kwartaal",
        "taxes.taxes.revenueEx": "Omzet excl.",
        "taxes.taxes.revenueIncl": "Omzet incl.",
        "taxes.taxes.totalIncl": "Totaal incl.",
        "taxes.taxes.vatExpenses": "Btw uitgaven",
        "taxes.taxes.vatRevenue": "Btw omzet",
        "taxes.taxes.year": "Jaar",
        "tenants.index.addNewTenant": "Nieuwe tenant toevoegen",
        "tenants.tenantAddForm.addingTenancyHasFailedCheckDataAndTryAgain": "Tenant toevoegen is mislukt. Controleer de gegevens en probeer opnieuw.",
        "tenants.tenantAddForm.addTenant": "Tenant toevoegen",
        "tenants.tenantAddForm.nameCanTBeEmpty": "Naam mag niet leeg zijn",
        "tenants.tenantAttachmentRequirements.add": "Toevoegen",
        "tenants.tenantAttachmentRequirements.attachmentRequirementsCouldNotBeLoaded": "Documentvereisten konden niet worden geladen.",
        "tenants.tenantAttachmentRequirements.attachmentRequirementsSaved": "Documentvereisten opgeslagen.",
        "tenants.tenantAttachmentRequirements.attachmentTypeDescription": "Omschrijving documenttype",
        "tenants.tenantAttachmentRequirements.attachmentTypeName": "Naam documenttype",
        "tenants.tenantAttachmentRequirements.chooseWhichApprovedDocumentsWorkersNeedBeforeTheyCanEnterHours": "Bepaal welke goedgekeurde documenten workers nodig hebben voordat zij uren mogen invoeren.",
        "tenants.tenantAttachmentRequirements.expiryDateRequired": "Verloopdatum verplicht",
        "tenants.tenantAttachmentRequirements.forExampleChamberOfCommerceExtract": "Bijvoorbeeld: KvK-uittreksel",
        "tenants.tenantAttachmentRequirements.instructionsShownInTheCustomerPortal": "Instructie die in het accountportaal wordt getoond",
        "tenants.tenantAttachmentRequirements.inputMethod": "Hoe de worker dit document aanlevert",
        "tenants.tenantAttachmentRequirements.uploadDocument": "Document uploaden",
        "tenants.tenantAttachmentRequirements.completeForm": "Formulier doorlopen",
        "tenants.tenantAttachmentRequirements.declarations": "Verklaringen",
        "tenants.tenantAttachmentRequirements.oneDeclarationPerLine": "Eén verklaring per regel",
        "tenants.tenantAttachmentRequirements.noDocumentTypesConfigured": "Geen documenttypen ingesteld.",
        "tenants.tenantAttachmentRequirements.removeAttachmentType": "Documenttype verwijderen",
        "tenants.tenantAttachmentRequirements.requiredForHourRegistration": "Verplicht voor urenregistratie",
        "tenants.tenantAttachmentRequirements.saveRequirements": "Vereisten opslaan",
        "tenants.tenantDetail.manageBillingRequirementsAccessAndActivityForThisTenant": "Beheer facturatie, vereisten, toegang en activiteiten voor deze tenant.",
        "tenants.tenantInvoiceSettings.invoiceNameTemplateCouldNotBeSaved": "Factuurnaamtemplate kon niet worden opgeslagen.",
        "tenants.tenantInvoiceSettings.invoiceNameTemplateSaved": "Factuurnaamtemplate opgeslagen.",
        "tenants.tenantInvoiceSettings.invoiceNumberPreview": "Voorbeeld factuurnummer",
        "tenants.tenantInvoiceSettings.invoicePrefix": "Factuurprefix",
        "tenants.tenantInvoiceSettings.invoicePrefixHelp": "Gebruik alleen letters en cijfers. Definitieve factuurnummers eindigen altijd met een volgnummer van vier cijfers.",
        "tenants.tenantInvoiceSettings.invoiceReminders": "Factuurherinneringen per e-mail versturen",
        "tenants.tenantInvoiceSettings.invoiceRemindersHelp": "Zet dit uit om alle automatische herinnerings- en incassomails voor deze tenant te stoppen. Pay-when-paid-facturen krijgen nooit herinneringen.",
        "tenants.tenantInvoiceSettings.nameTemplate": "Naamtemplate",
        "tenants.tenantInvoiceSettings.placeholders": "Plaatshouders",
        "tenants.tenantInvoiceSettings.presets": "Voorinstellingen",
        "tenants.tenantInvoiceSettings.preview": "Voorbeeld",
        "tenants.tenantInvoiceSettings.settingsCouldNotBeSaved": "Factuurinstellingen konden niet worden opgeslagen.",
        "tenants.tenantInvoiceSettings.settingsSaved": "Factuurinstellingen opgeslagen.",
        "tenants.tenantInvoiceSettings.weekProject": "Week + project",
        "tenants.tenantInvoiceSettings.withoutAProjectNameAProjectTemplateAutomaticallyFallsBackToYearMonth": "Zonder projectnaam valt een projecttemplate automatisch terug op jaar-maand.",
        "tenants.tenantInvoiceSettings.yearMonth": "Jaar-maand",
        "tenants.tenantURLSettings.account": "URL accountportaal",
        "tenants.tenantURLSettings.defaultHelp": "Bij een lege accountportal-URL wordt de Galactic Group-standaard gebruikt. De betaalportal-URL mag leeg blijven.",
        "tenants.tenantURLSettings.help": "Deze basis-URL's worden gebruikt voor account- en betaallinks in automatische e-mails en facturen.",
        "tenants.tenantURLSettings.payment": "URL betaalportaal",
        "tenants.tenantURLSettings.saveFailed": "Portaal-URL's konden niet worden opgeslagen.",
        "tenants.tenantURLSettings.saved": "Portaal-URL's opgeslagen.",
        "tenants.tenantURLSettings.title": "Portaal-URL's",
        "tenants.tenantOverviewCard.pushSubscriptions": "Push-abonnementen",
        "tenants.tenantPushNotifications.disabledForThisTenant": "Uitgeschakeld voor deze tenant",
        "tenants.tenantPushNotifications.enabledForThisTenant": "Ingeschakeld voor deze tenant",
        "tenants.tenantPushNotifications.pushNotificationsCouldNotBeChanged": "Push meldingen konden niet worden aangepast",
        "tenants.tenantTab.noItemFound": "Geen {{item}} gevonden.",
        "tenants.tenantTab.noRole": "Geen rol",
        "tenants.tenantTab.noTicketsForThisTenant": "Geen tickets voor deze tenant.",
        "tenants.tenantTab.showCountMoreItem": "Toon nog {{count}} {{item}}",
        "tenants.tenantTab.untitledExpense": "Naamloze uitgave",
        "tenants.tenantTab.untitledInvoice": "Naamloze factuur",
        "tenants.tenantUsers.noUsersAvailable": "Geen gebruikers beschikbaar.",
        "user.managedUserForm.accountActivated": "Account geactiveerd",
        "user.managedUserForm.aPasswordIsRequiredForANewUser": "Een wachtwoord is verplicht voor een nieuwe gebruiker.",
        "user.managedUserForm.confirmPassword": "Wachtwoord bevestigen",
        "user.managedUserForm.leaveBothFieldsEmptyToKeepTheCurrentPassword": "Laat beide velden leeg om het huidige wachtwoord te behouden.",
        "user.managedUserForm.nameEmailAndRegionAreRequired": "Naam, e-mail en regio zijn verplicht.",
        "user.managedUserForm.newPassword": "Nieuw wachtwoord",
        "user.managedUserForm.phoneNumber": "Telefoonnummer",
        "user.managedUserForm.selectARegion": "Selecteer een regio",
        "user.managedUserForm.thePasswordMustContainAtLeast8Characters": "Het wachtwoord moet minimaal 8 tekens bevatten.",
        "user.managedUserForm.thePasswordsDoNotMatch": "De wachtwoorden komen niet overeen.",
        "user.managedUserForm.theUserCouldNotBeSaved": "De gebruiker kon niet worden opgeslagen.",
        "user.userDetail.backToUsers": "Terug naar gebruikers",
        "user.userDetail.device": "Apparaat",
        "user.userDetail.devicesAndSessions": "Apparaten en sessies",
        "user.userDetail.ipAddress": "IP-adres",
        "user.userDetail.loadingUser": "Gebruiker laden...",
        "user.userDetail.mfaMethod": "MFA-methode",
        "user.userDetail.mfaStatus": "MFA-status",
        "user.userDetail.noActiveSessionsFound": "Geen actieve sessies gevonden.",
        "user.userDetail.noBrowserInformationStored": "Geen browserinformatie opgeslagen",
        "user.userDetail.noIpAddressStored": "Geen IP-adres opgeslagen",
        "user.userDetail.security": "Beveiliging",
        "user.userDetail.signedIn": "Ingelogd",
        "user.userDetail.unknownDevice": "Onbekend apparaat",
        "user.userDetail.userNotFound": "Gebruiker niet gevonden",
        "user.userDetail.userSavedSuccessfully": "Gebruiker opgeslagen.",
        "user.userProfile.activatedValue": "Geactiveerd: {{value}}",
        "user.userProfile.emailValue": "E-mail: {{value}}",
        "user.userProfile.no": "Nee",
        "user.userProfile.phoneValue": "Telefoon: {{value}}",
        "user.userProfile.regionValue": "Regio: {{value}}",
        "user.userProfile.yes": "Ja",
        "user.userProfiles.accessActivationAndRegionalSettings": "Toegang, activering en regionale instellingen.",
        "user.userProfiles.searchNameEmailOrRegion": "Zoek op naam, e-mail of regio…",
        "user.userProfiles.searchUsers": "Gebruikers zoeken",
        "user.userProfiles.userOverview": "Gebruikersoverzicht",
        "user.userProfilesTable.access": "Toegang",
        "user.userProfilesTable.accounts": "relaties",
        "user.userProfilesTable.noUsersFound": "Geen gebruikers gevonden.",
        "accounts.accountAttachmentsCard.approvalFailed": "Het document kon niet worden goedgekeurd.",
        "accounts.accountAttachmentsCard.deleteFailed": "Het document kon niet worden verwijderd.",
        "accounts.accountAttachmentsCard.expirySaveFailed": "De vervaldatum van het document kon niet worden opgeslagen.",
        "accounts.accountAttachmentsCard.loadFailed": "Documenten konden niet worden geladen.",
        "accounts.accountAttachmentsCard.noContent": "Het document heeft geen inhoud.",
        "accounts.accountAttachmentsCard.openFailed": "Het document kon niet worden geopend.",
        "accounts.accountAttachmentsCard.rejectionReasonRequired": "Voer een reden voor afwijzing in.",
        "accounts.accountAttachmentsCard.rejectionSaveFailed": "De afwijzing van het document kon niet worden opgeslagen.",
        "accounts.accountAttachmentsCard.statusApproved": "Goedgekeurd",
        "accounts.accountAttachmentsCard.statusPending": "In behandeling",
        "accounts.accountAttachmentsCard.statusRejected": "Afgewezen",
        "accounts.accountDetailsCards.accountInformation": "Relatiegegevens",
        "accounts.accountDetailsCards.addressNumber": "Adres {{number}}",
        "accounts.accountDetailsCards.bankAccountNumber": "Bankrekening {{number}}",
        "accounts.accountDetailsCards.billingParameters": "Facturatie-instellingen",
        "accounts.accountDetailsCards.chargeLineVatRates": "Btw-tarieven per regel berekenen",
        "accounts.accountDetailsCards.cocNumber": "KvK-nummer",
        "accounts.accountDetailsCards.defaultVatTreatment": "Standaard btw-behandeling",
        "accounts.accountDetailsCards.deleteAddressNumber": "Adres {{number}} verwijderen",
        "accounts.accountDetailsCards.deleteBankAccountNumber": "Bankrekening {{number}} verwijderen",
        "accounts.accountDetailsCards.editSection": "{{section}} bewerken",
        "accounts.accountDetailsCards.reverseCharged": "Btw verlegd",
        "accounts.accountPersonsCard.lastName": "Achternaam",
        "accounts.accountRecurringsCard.deleteFailed": "Terugkerende regel kon niet worden verwijderd.",
        "accounts.accountRecurringsCard.deleteNamed": "{{name}} verwijderen",
        "accounts.accountRecurringsCard.invalidForm": "Vul een naam, geldig aantal, prijs, btw-tarief en facturatie-interval in.",
        "accounts.accountRecurringsCard.loadFailed": "Terugkerende regels konden niet worden geladen.",
        "accounts.accountRecurringsCard.saveFailed": "Terugkerende regel kon niet worden opgeslagen.",
        "accounts.invoiceIntervalField.disabled": "Geen automatische facturatie",
        "accounts.invoiceIntervalField.disabledDescription": "Automatische facturatie is uitgeschakeld.",
        "accounts.invoiceIntervalField.everyDay": "Elke dag om 09:00",
        "accounts.invoiceIntervalField.everyMonday": "Elke maandag om 09:00",
        "accounts.invoiceIntervalField.everyMonth": "Eerste dag van iedere maand om 09:00",
        "accounts.invoiceIntervalField.everyQuarter": "Eerste dag van ieder kwartaal om 09:00",
        "accounts.invoiceIntervalField.everyYear": "Elke 1 januari om 09:00",
        "accounts.invoiceIntervalField.invalid": "Ongeldige cron-expressie.",
        "common.bic": "BIC",
        "common.iban": "IBAN",
        "common.quotes": "Offertes",
        "common.title": "Titel",
        "accounts.accountFormCard.saveAccount": "Relatie opslaan",
        "accounts.accountRecentEmailsCard.recentlySentEmails": "Recent verzonden e-mails",
        "common.adminConsole.errors.commandRequired": "Voer een commando in.",
        "common.adminConsole.errors.commandUsage": "Gebruik: {{command}} {{resource}} <uuid>",
        "common.adminConsole.errors.invalidUuid": "Ongeldige UUID.",
        "common.adminConsole.errors.listUsage": "Gebruik: list {{resource}}s",
        "common.adminConsole.errors.unknownCommand": "Onbekend commando. Typ 'help' voor de beschikbare commando's.",
        "common.adminConsole.errors.unknownResource": "Onbekende entity '{{resource}}'. Gebruik projects, accounts, invoices of persons.",
        "common.adminConsole.help.clear": "  clear                                  Wis de console",
        "common.adminConsole.help.delete": "  delete project|account|invoice|person <uuid> Verwijder één entity",
        "common.adminConsole.help.exit": "  exit                                   Sluit de console",
        "common.adminConsole.help.get": "  get project|account|invoice|person <uuid>    Toon één entity",
        "common.adminConsole.help.heading": "Beschikbare commando's:",
        "common.adminConsole.help.list": "  list projects|accounts|invoices|persons       Toon alle entities",
        "common.adminConsole.noId": "(geen ID)",
        "common.adminConsole.noName": "(geen naam)",
        "common.adminConsole.noResourcesFound": "Geen {{resources}} gevonden.",
        "common.adminConsole.projectDeleted": "Project {{id}} is volledig verwijderd, inclusief worker- en verantwoordelijke relaties, uren, contracten en bijlagen.",
        "common.adminConsole.resourceDeleteFailed": "{{resource}} kon niet worden verwijderd: {{error}}",
        "common.adminConsole.resourceDeleted": "{{resource}} {{id}} is verwijderd.",
        "common.adminConsole.resourceGetFailed": "{{resource}} kon niet worden opgehaald: {{error}}",
        "common.adminConsole.resourceList": "{{resources}} ({{count}}):\n{{entries}}",
        "common.adminConsole.resourceLoadFailed": "{{resource}} konden niet worden geladen: {{error}}",
        "common.adminConsole.unknownError": "Onbekende fout",
        "common.adminConsole.welcome": "Office console. Typ 'help' voor de beschikbare commando's.",
        "common.account": "Relatie",
        "common.attach": "Bijvoegen",
        "common.cc": "CC",
        "common.cpu": "CPU",
        "common.dashboard": "Dashboard",
        "common.duration.zeroHoursShort": "0u",
        "common.noSubject": "(Geen onderwerp)",
        "common.pdf": "PDF",
        "common.person": "Persoon",
        "common.project": "Project",
        "common.theme.darkMode": "Donkere modus",
        "common.theme.lightMode": "Lichte modus",
        "common.ticket": "Ticket",
        "common.totp": "TOTP",
        "common.units.millisecondsShort": "ms",
        "common.units.perSecondShort": "/s",
        "common.usa": "Verenigde Staten",
        "common.actions.checkKvk": "KvK controleren",
        "common.actions.checkVat": "Btw controleren",
        "common.actions.checking": "Controleren…",
        "common.actions.createLogin": "Login aanmaken",
        "common.actions.creating": "Aanmaken...",
        "common.actions.disable": "Uitschakelen",
        "common.actions.enable": "Inschakelen",
        "common.actions.saveChanges": "Wijzigingen opslaan",
        "common.actions.setPassword": "Wachtwoord instellen",
        "common.actions.changePassword": "Wachtwoord wijzigen",
        "common.actions.working": "Bezig...",
        "common.metrics.profit": "Winst",
        "common.period.lastWeek": "afgelopen week",
        "common.roles.customer": "Klant",
        "common.roles.supplier": "Leverancier",
        "common.status.active": "Actief",
        "common.status.completed": "Voltooid",
        "common.status.disabled": "Uitgeschakeld",
        "common.status.draft": "Concept",
        "common.status.enabled": "Ingeschakeld",
        "common.status.inactive": "Inactief",
        "common.status.final": "Definitief",
        "common.status.open": "Open",
        "common.status.outstanding": "Openstaand",
        "common.status.overdue": "Verlopen",
        "common.status.paid": "Betaald",
        "common.status.payWhenPaid": "Pay when paid",
        "common.status.pending": "In behandeling",
        "common.status.sent": "Verzonden",
        "common.status.signed": "Getekend",
        "common.status.unpaid": "Onbetaald",
        "common.status.upcoming": "Aankomend",
        "common.units.day": "dag",
        "common.units.days": "dagen",
        "common.units.worker": "werker",
        "common.units.workers": "werkers",
        "invoice.labels.deadline": "Vervaldatum",
        "invoice.labels.paymentTerm": "Betaaltermijn",
        "projects.hours.approved": "Goedgekeurd",
        "projects.hours.pending": "In behandeling",
        "projects.hours.workerWithoutHours": "worker zonder uren",
        "projects.hours.workersWithoutHours": "workers zonder uren",
        "projects.location.cleared": "Projectlocatie gewist.",
        "projects.location.saved": "Projectlocatie opgeslagen.",
        "customer.computerRow.routerOs": "RouterOS",
        "dashboard.serviceStatusBanner.summary": "Samenvatting statuspagina",
        "email.emailRowInbox.selectSubject": "{{subject}} selecteren",
        "email.emailRowInbox.failed": "Mislukt",
        "invoice.invoiceContentAddCard.vatRateSuffix": "% btw",
        "invoice.invoiceStatusCard.ibanExample": "NL00 BANK 0000 0000 00",
        "invoice.paymentMethods.ideal": "iDEAL",
        "invoice.paymentMethods.manual": "Handmatig",
        "persons.personDetail.linkedRelations": "Gekoppelde relaties",
        "persons.personDetail.personDetails": "Persoonsgegevens",
        "persons.personDetail.unlinkAccount": "{{name}} ontkoppelen",
        "persons.personDetail.viewAccount": "{{name}} bekijken",
        "persons.persons.viewPerson": "{{name}} bekijken",
        "projects.projectDetail.accountDefaultHourlyRate": "Relatiestandaard: {{rate}} per uur",
        "projects.projectDetail.distanceKilometers": "{{distance}} kilometer",
        "projects.projectDetail.distanceMeters": "{{distance}} meter",
        "projects.projectDetail.fixedPlatformFee": "{{fee}} platformfee per uur",
        "projects.projectDetail.mapAttribution": "© OpenStreetMap-bijdragers",
        "projects.projectDetail.percentagePlatformFee": "{{percentage}}% platformfee",
        "projects.projectDetail.projectDetails": "Projectgegevens",
        "projects.projectDetail.projectLocation": "Projectlocatie",
        "projects.projectDetail.projectPlanning": "Projectplanning",
        "projects.projectDetail.workerSettingsFor": "Worker-projectinstellingen voor {{name}}",
        "projects.projectDetail.workerSettingsTitle": "Worker-projectrol en tariefafwijkingen",
        "projects.projectDetail.workers": "Medewerkers",
        "projects.projectHoursOverview.title": "Urenoverzicht",
        "services.checkTypes.http": "HTTP",
        "services.checkTypes.ping": "Ping",
        "services.removeServiceButton.deleteService": "Dienst verwijderen",
        "taxes.quarters.q1": "Q1",
        "taxes.quarters.q2": "Q2",
        "taxes.quarters.q3": "Q3",
        "taxes.quarters.q4": "Q4",
        "tenants.tenantAttachmentRequirements.title": "Documentvereisten",
        "tenants.tenantCard.revenueThisQuarter": "Omzet dit kwartaal",
        "tenants.tenantInvoiceSettings.title": "Factuurinstellingen",
        "tenants.tenantOverviewCard.tenantId": "Tenant-ID",
        "tenants.tenantOverviewCard.title": "Tenantgegevens",
        "tenants.tenantPushNotifications.title": "Pushmeldingen",
        "tenants.tenantTab.openAccount": "{{name}} openen",
        "user.userDetail.idValue": "ID: {{id}}",
        "projects.contractTemplateEditor.dataLoadFailed": "Templategegevens konden niet worden geladen.",
        "projects.contractTemplateEditor.loadFailed": "De template kon niet worden geladen.",
        "projects.contractTemplateEditor.pdfRequired": "Upload een PDF-bestand.",
        "projects.contractTemplateEditor.responsibleSaved": "Responsible-contracttemplate opgeslagen.",
        "projects.contractTemplateEditor.saveFailed": "De template kon niet worden opgeslagen.",
        "projects.contractTemplateEditor.singleSignatureAllowed": "Er kan één handtekeningveld in het contract staan.",
        "projects.contractTemplateEditor.singleSignatureRequired": "Plaats precies één handtekeningveld op de PDF.",
        "projects.contractTemplateEditor.workerSaved": "Worker-contracttemplate opgeslagen.",
        "pushNotifications.deviceScope": "Voor dit apparaat en deze tenant",
        "pushNotifications.unsupportedDevice": "Niet ondersteund op dit apparaat",
        "user.form.create": "Gebruiker aanmaken",
        "user.form.details": "Gebruikersgegevens",
        "user.form.edit": "Gebruiker bewerken",
        "user.roles.administrator": "Beheerder",
        "user.roles.operator": "Operator",
        "user.roles.user": "Gebruiker",
        "user.security.authenticatorApp": "Authenticator-app",
        "user.security.createMfaQrCode": "MFA-QR-code maken",
        "user.security.creatingMfaQrCode": "MFA-QR-code maken…",
        "user.security.downloadMfaQrCode": "QR-code downloaden",
        "user.security.mfaQrCodeAlt": "MFA-QR-code voor {{name}}",
        "user.security.mfaQrFailed": "De MFA-QR-code kon niet worden gemaakt.",
        "user.security.mfaQrReady": "Stuur deze QR-code via een veilig kanaal naar de medewerker. In deze stap hoeft geen authenticatorcode te worden geverifieerd.",
        "user.regions.africa": "Afrika",
        "user.regions.antarctica": "Antarctica",
        "user.regions.asia": "Azië",
        "user.regions.australia": "Australië",
        "user.regions.europe": "Europa",
        "user.regions.northAmerica": "Noord-Amerika",
        "user.regions.southAmerica": "Zuid-Amerika",
        "ledgerAccounts.accountingCosts": "Accountantskosten",
        "ledgerAccounts.administrationCosts": "Administratiekosten",
        "ledgerAccounts.bankCosts": "Bankkosten",
        "ledgerAccounts.businessGifts": "Relatiegeschenken",
        "ledgerAccounts.carCosts": "Autokosten",
        "ledgerAccounts.cleaningCosts": "Schoonmaakkosten",
        "ledgerAccounts.depreciationCosts": "Afschrijvingskosten",
        "ledgerAccounts.directProjectCosts": "Directe kosten projecten",
        "ledgerAccounts.energyAndWater": "Energie en water",
        "ledgerAccounts.fairsAndEvents": "Beurzen en events",
        "ledgerAccounts.finesAndAssessments": "Boetes en naheffingen",
        "ledgerAccounts.fuel": "Brandstof",
        "ledgerAccounts.hardwareAndEquipment": "Hardware en apparatuur",
        "ledgerAccounts.hiredPersonnel": "Inhuur personeel",
        "ledgerAccounts.hostingAndCloud": "Hosting en cloud",
        "ledgerAccounts.insurance": "Verzekeringen",
        "ledgerAccounts.interestAndFinancing": "Rente en financieringskosten",
        "ledgerAccounts.inventoryDifferences": "Voorraadverschillen",
        "ledgerAccounts.itMaintenance": "Onderhoud IT",
        "ledgerAccounts.legalAdvice": "Juridisch advies",
        "ledgerAccounts.marketingAndAdvertising": "Marketing en reclame",
        "ledgerAccounts.materials": "Inkopen materialen",
        "ledgerAccounts.mileageAllowance": "Kilometervergoeding",
        "ledgerAccounts.noOptions": "Geen grootboekregel gevonden",
        "ledgerAccounts.officeMaintenance": "Onderhoud kantoor",
        "ledgerAccounts.officeRent": "Huur kantoorruimte",
        "ledgerAccounts.officeSupplies": "Kantoorbenodigdheden",
        "ledgerAccounts.otherAdvice": "Overig advies",
        "ledgerAccounts.otherDirectPurchasing": "Overige directe inkoopkosten",
        "ledgerAccounts.otherGeneralCosts": "Overige algemene kosten",
        "ledgerAccounts.otherRevenueCost": "Kostprijs overige omzet",
        "ledgerAccounts.parkingAndTolls": "Parkeren en tol",
        "ledgerAccounts.paymentDifferences": "Betalingsverschillen",
        "ledgerAccounts.pensionCosts": "Pensioenlasten",
        "ledgerAccounts.phoneAndInternet": "Telefoon en internet",
        "ledgerAccounts.postageAndPrinting": "Porti en drukwerk",
        "ledgerAccounts.publicTransport": "Openbaar vervoer",
        "ledgerAccounts.purchaseDiscounts": "Inkoopkortingen",
        "ledgerAccounts.representationCosts": "Representatiekosten",
        "ledgerAccounts.search": "Zoek grootboek...",
        "ledgerAccounts.smallPurchases": "Kleine aanschaffingen",
        "ledgerAccounts.socialSecurity": "Sociale lasten",
        "ledgerAccounts.softwareAndLicences": "Software en licenties",
        "ledgerAccounts.subcontractedWork": "Uitbesteed werk",
        "ledgerAccounts.subscriptionsAndMemberships": "Abonnementen en contributies",
        "ledgerAccounts.tradeGoods": "Inkopen handelsgoederen",
        "ledgerAccounts.trainingCosts": "Opleidingskosten",
        "ledgerAccounts.transportAndShipping": "Transport- en verzendkosten",
        "ledgerAccounts.travelAndAccommodation": "Reis- en verblijfkosten",
        "ledgerAccounts.uncategorized": "Niet gecategoriseerd",
        "ledgerAccounts.wagesAndSalaries": "Lonen en salarissen",
        "ledgerAccounts.websiteAndDomains": "Website en domeinen",
        "projects.contractTemplateEditor.defaults.newField": "Nieuw veld",
        "projects.contractTemplateEditor.defaults.responsibleBody": "Beste {{responsible.name}},\n\nIn de bijlage vindt u uw getekende contract voor {{project.name}} en {{worker.name}}.",
        "projects.contractTemplateEditor.defaults.responsibleFilename": "contract-{{project.name}}-{{worker.name}}-responsible.pdf",
        "projects.contractTemplateEditor.defaults.responsibleName": "Standaard responsible-contract",
        "projects.contractTemplateEditor.defaults.responsibleSubject": "Uw getekende contract voor {{project.name}} en {{worker.name}}",
        "projects.contractTemplateEditor.defaults.signatureField": "Handtekening werker",
        "projects.contractTemplateEditor.defaults.signatureCopyField": "Paraaf",
        "projects.contractTemplateEditor.defaults.workerBody": "Beste {{worker.name}},\n\nIn de bijlage vindt u uw getekende contract voor {{project.name}}.",
        "projects.contractTemplateEditor.defaults.workerFilename": "contract-{{project.name}}-{{worker.name}}.pdf",
        "projects.contractTemplateEditor.defaults.workerName": "Standaard worker-contract",
        "projects.contractTemplateEditor.defaults.workerSubject": "Uw getekende contract voor {{project.name}}",
    },
} as const;

export type OfficeTranslationKey = keyof typeof officeTranslations.en;

type TranslationParams = Record<string, string | number>;

export const translateOfficeText = (
    locale: OfficeLocale,
    key: OfficeTranslationKey,
    params: TranslationParams = {},
) => Object.entries(params).reduce<string>(
    (text, [name, replacement]) => text.replaceAll(`{{${name}}}`, String(replacement)),
    officeTranslations[locale][key] as string,
);
